{
  "level": "mt02b",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02b",
    "objects": "AREAS.E3:mt02b.e3",
    "mesh": "TREES.E3:mt02b.e3"
  },
  "spawn_point": {
    "position": [
      -1467.3180656954426,
      -3929.63400244982,
      694.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1467.3180656954426,
      -3829.63400244982,
      694.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1649.5,
      -4029.699951171875,
      670.0
    ],
    "bbox_max": [
      -1263.0,
      -3850.318359375,
      1080.0
    ],
    "vertex_count": 1683,
    "vertices": [
      [
        -1532.699951171875,
        -3923.5,
        670.5
      ],
      [
        -1523.5,
        -3923.5,
        670.5
      ],
      [
        -1532.699951171875,
        -3915.0,
        670.5
      ],
      [
        -1523.5,
        -3915.0,
        670.5
      ],
      [
        -1523.5,
        -3923.5,
        670.5
      ],
      [
        -1523.5,
        -3915.0,
        670.5
      ],
      [
        -1532.699951171875,
        -3915.0,
        670.5
      ],
      [
        -1532.699951171875,
        -3923.5,
        670.5
      ],
      [
        -1514.5,
        -3909.0,
        670.5
      ],
      [
        -1514.5,
        -3913.0,
        670.5
      ],
      [
        -1514.5,
        -3913.0,
        670.5
      ],
      [
        -1510.5,
        -3913.0,
        670.5
      ],
      [
        -1539.0,
        -3913.0,
        670.5
      ],
      [
        -1535.0,
        -3913.0,
        670.5
      ],
      [
        -1535.0,
        -3913.0,
        670.5
      ],
      [
        -1535.0,
        -3909.0,
        670.5
      ],
      [
        -1532.5,
        -3925.669921875,
        670.5
      ],
      [
        -1527.5,
        -3925.669921875,
        670.5
      ],
      [
        -1535.0,
        -3930.0,
        670.5
      ],
      [
        -1532.5,
        -3925.669921875,
        670.5
      ],
      [
        -1534.12109375,
        -3931.522216796875,
        670.5
      ],
      [
        -1534.12109375,
        -3931.522216796875,
        670.0
      ],
      [
        -1535.0,
        -3930.0,
        670.5
      ],
      [
        -1527.5,
        -3925.669921875,
        670.5
      ],
      [
        -1527.043212890625,
        -3926.4609375,
        670.0
      ],
      [
        -1527.043212890625,
        -3926.4609375,
        670.5
      ],
      [
        -1545.8375244140625,
        -3937.0,
        772.5
      ],
      [
        -1545.8375244140625,
        -3912.0,
        772.5
      ],
      [
        -1545.7747802734375,
        -3912.0,
        771.5
      ],
      [
        -1545.7747802734375,
        -3937.0,
        771.5
      ],
      [
        -1545.7747802734375,
        -3937.0,
        771.5
      ],
      [
        -1545.8375244140625,
        -3937.0,
        772.5
      ],
      [
        -1545.8375244140625,
        -3912.0,
        772.5
      ],
      [
        -1545.7747802734375,
        -3912.0,
        771.5
      ],
      [
        -1547.187744140625,
        -3912.0,
        794.0
      ],
      [
        -1547.187744140625,
        -3920.0,
        794.0
      ],
      [
        -1547.2506103515625,
        -3920.0,
        795.0
      ],
      [
        -1547.2506103515625,
        -3912.0,
        795.0
      ],
      [
        -1547.187744140625,
        -3920.0,
        794.0
      ],
      [
        -1547.2506103515625,
        -3920.0,
        795.0
      ],
      [
        -1547.2506103515625,
        -3912.0,
        795.0
      ],
      [
        -1547.187744140625,
        -3912.0,
        794.0
      ],
      [
        -1536.0,
        -3907.63427734375,
        728.0
      ],
      [
        -1513.5,
        -3907.63427734375,
        728.0
      ],
      [
        -1536.0,
        -3907.5712890625,
        729.04541015625
      ],
      [
        -1513.5,
        -3907.5712890625,
        729.04541015625
      ],
      [
        -1513.5,
        -3907.5712890625,
        729.04541015625
      ],
      [
        -1513.5,
        -3907.63427734375,
        728.0
      ],
      [
        -1536.0,
        -3907.63427734375,
        728.0
      ],
      [
        -1536.0,
        -3907.5712890625,
        729.04541015625
      ],
      [
        -1525.0,
        -3904.008056640625,
        788.0
      ],
      [
        -1513.5,
        -3904.008056640625,
        788.0
      ],
      [
        -1525.0,
        -3903.94482421875,
        789.04541015625
      ],
      [
        -1513.5,
        -3903.94482421875,
        789.04541015625
      ],
      [
        -1525.0,
        -3904.008056640625,
        788.0
      ],
      [
        -1525.0,
        -3903.94482421875,
        789.04541015625
      ],
      [
        -1513.5,
        -3903.94482421875,
        789.04541015625
      ],
      [
        -1513.5,
        -3904.008056640625,
        788.0
      ],
      [
        -1536.0,
        -3909.32666015625,
        700.0
      ],
      [
        -1513.5,
        -3909.32666015625,
        700.0
      ],
      [
        -1536.0,
        -3909.263671875,
        701.04541015625
      ],
      [
        -1513.5,
        -3909.263671875,
        701.04541015625
      ],
      [
        -1536.0,
        -3909.32666015625,
        700.0
      ],
      [
        -1536.0,
        -3909.263671875,
        701.04541015625
      ],
      [
        -1514.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1514.5,
        -3911.10986328125,
        670.5
      ],
      [
        -1514.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1510.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1513.5,
        -3910.0,
        688.8596801757812
      ],
      [
        -1511.5,
        -3910.0,
        688.8596801757812
      ],
      [
        -1513.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1513.5,
        -3910.0,
        688.8596801757812
      ],
      [
        -1511.5,
        -3910.0,
        688.8596801757812
      ],
      [
        -1511.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1535.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1535.0,
        -3911.10986328125,
        670.5
      ],
      [
        -1539.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1535.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1538.0,
        -3910.0,
        688.8596801757812
      ],
      [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      [
        -1538.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1538.0,
        -3910.0,
        688.8596801757812
      ],
      [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      [
        -1536.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1538.0,
        -3910.0,
        712.3767700195312
      ],
      [
        -1538.0,
        -3912.0,
        689.6947021484375
      ],
      [
        -1538.0,
        -3910.0,
        712.37744140625
      ],
      [
        -1536.0,
        -3910.0,
        696.7483520507812
      ],
      [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      [
        -1535.0,
        -3911.625244140625,
        670.5
      ],
      [
        -1538.0,
        -3913.0,
        678.354248046875
      ],
      [
        -1536.994873046875,
        -3913.0,
        670.5
      ],
      [
        -1538.0,
        -3913.0,
        670.5
      ],
      [
        -1536.0,
        -3910.0,
        696.7483520507812
      ],
      [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      [
        -1538.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1536.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      [
        -1538.0,
        -3912.193359375,
        687.5
      ],
      [
        -1537.7191162109375,
        -3912.0,
        687.5
      ],
      [
        -1538.0,
        -3912.0,
        689.6947021484375
      ],
      [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      [
        -1536.0,
        -3909.713134765625,
        700.0
      ],
      [
        -1536.0,
        -3909.62109375,
        701.04541015625
      ],
      [
        -1536.0,
        -3909.713134765625,
        700.0
      ],
      [
        -1535.439208984375,
        -3909.32666015625,
        700.0
      ],
      [
        -1536.0,
        -3909.62109375,
        701.04541015625
      ],
      [
        -1535.4814453125,
        -3909.263671875,
        701.04541015625
      ],
      [
        -1539.0,
        -3913.0,
        686.16845703125
      ],
      [
        -1539.0,
        -3912.882568359375,
        687.5
      ],
      [
        -1540.0,
        -3913.0,
        693.0
      ],
      [
        -1538.4229736328125,
        -3912.0,
        693.0
      ],
      [
        -1539.8739013671875,
        -3913.0,
        693.0
      ],
      [
        -1538.4229736328125,
        -3912.0,
        693.0
      ],
      [
        -1538.2947998046875,
        -3912.0,
        692.0
      ],
      [
        -1538.2947998046875,
        -3912.0,
        692.0
      ],
      [
        -1540.0,
        -3913.0,
        692.0
      ],
      [
        -1539.7459716796875,
        -3913.0,
        692.0
      ],
      [
        -1541.3662109375,
        -3912.0,
        716.0
      ],
      [
        -1541.3662109375,
        -3912.0,
        716.0
      ],
      [
        -1541.5,
        -3912.092041015625,
        716.0
      ],
      [
        -1540.0,
        -3913.175048828125,
        692.0
      ],
      [
        -1540.0,
        -3913.0869140625,
        693.0
      ],
      [
        -1503.0999755859375,
        -3907.303955078125,
        812.5
      ],
      [
        -1503.0999755859375,
        -3909.339111328125,
        789.4187622070312
      ],
      [
        -1513.5,
        -3910.0,
        700.6519165039062
      ],
      [
        -1511.5,
        -3910.0,
        716.280517578125
      ],
      [
        -1511.5,
        -3912.0,
        693.5952758789062
      ],
      [
        -1511.5,
        -3910.0,
        716.280517578125
      ],
      [
        -1514.5,
        -3910.470458984375,
        687.5
      ],
      [
        -1514.5,
        -3911.9697265625,
        670.5
      ],
      [
        -1511.5,
        -3913.0,
        670.5
      ],
      [
        -1513.0047607421875,
        -3913.0,
        670.5
      ],
      [
        -1511.5,
        -3913.0,
        682.2557983398438
      ],
      [
        -1513.5,
        -3911.159423828125,
        687.5
      ],
      [
        -1513.5,
        -3910.0,
        700.6519165039062
      ],
      [
        -1511.5,
        -3912.53759765625,
        687.5
      ],
      [
        -1513.5,
        -3911.159423828125,
        687.5
      ],
      [
        -1513.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1511.5,
        -3910.082275390625,
        687.5
      ],
      [
        -1512.280029296875,
        -3912.0,
        687.5
      ],
      [
        -1511.5,
        -3912.0,
        693.5952758789062
      ],
      [
        -1511.5,
        -3912.0,
        692.0
      ],
      [
        -1511.7041015625,
        -3912.0,
        692.0
      ],
      [
        -1511.5,
        -3912.140625,
        692.0
      ],
      [
        -1511.576416015625,
        -3912.0,
        693.0
      ],
      [
        -1511.5,
        -3912.0,
        693.0
      ],
      [
        -1511.5,
        -3912.052734375,
        693.0
      ],
      [
        -1514.5,
        -3910.470458984375,
        687.5
      ],
      [
        -1513.5,
        -3910.05712890625,
        700.0
      ],
      [
        -1513.5,
        -3910.0,
        700.0
      ],
      [
        -1513.5828857421875,
        -3910.0,
        700.0
      ],
      [
        -1510.8287353515625,
        -3913.0,
        687.5
      ],
      [
        -1507.0,
        -3912.128173828125,
        693.0
      ],
      [
        -1508.21923828125,
        -3913.0,
        693.0
      ],
      [
        -1510.1253662109375,
        -3913.0,
        693.0
      ],
      [
        -1510.2530517578125,
        -3913.0,
        692.0
      ],
      [
        -1508.2191162109375,
        -3913.0,
        692.0
      ],
      [
        -1507.0,
        -3912.128173828125,
        692.0
      ],
      [
        -1510.8287353515625,
        -3913.0,
        687.5
      ],
      [
        -1506.8209228515625,
        -3912.0,
        709.0
      ],
      [
        -1509.5291748046875,
        -3912.0,
        709.0
      ],
      [
        -1509.6568603515625,
        -3912.0,
        708.0
      ],
      [
        -1506.8209228515625,
        -3912.0,
        708.0
      ],
      [
        -1506.8209228515625,
        -3912.0,
        708.0
      ],
      [
        -1509.6568603515625,
        -3912.0,
        708.0
      ],
      [
        -1508.212646484375,
        -3912.9951171875,
        708.0
      ],
      [
        -1509.5291748046875,
        -3912.0,
        709.0
      ],
      [
        -1506.8209228515625,
        -3912.0,
        709.0
      ],
      [
        -1508.1500244140625,
        -3912.950439453125,
        709.0
      ],
      [
        -1509.21728515625,
        -3913.7138671875,
        692.0
      ],
      [
        -1509.1546630859375,
        -3913.6689453125,
        693.0
      ],
      [
        -1514.5181884765625,
        -3909.263671875,
        701.04541015625
      ],
      [
        -1513.5,
        -3909.965087890625,
        701.04541015625
      ],
      [
        -1514.5604248046875,
        -3909.32666015625,
        700.0
      ],
      [
        -1506.821044921875,
        -3912.0,
        748.5
      ],
      [
        -1506.821044921875,
        -3912.0,
        747.5
      ],
      [
        -1506.8209228515625,
        -3912.0,
        780.0
      ],
      [
        -1506.8209228515625,
        -3912.0,
        779.0
      ],
      [
        -1537.7193603515625,
        -3912.0,
        687.5
      ],
      [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      [
        -1536.0,
        -3912.0,
        687.5
      ],
      [
        -1513.5,
        -3911.159423828125,
        687.5
      ],
      [
        -1512.2801513671875,
        -3912.0,
        687.5
      ],
      [
        -1513.5,
        -3912.0,
        687.5
      ],
      [
        -1535.0,
        -3912.0,
        687.5
      ],
      [
        -1535.0,
        -3912.0,
        670.5
      ],
      [
        -1535.0,
        -3912.0,
        687.5
      ],
      [
        -1514.5,
        -3912.0,
        687.5
      ],
      [
        -1514.5,
        -3912.0,
        670.5
      ],
      [
        -1514.5,
        -3912.0,
        687.5
      ],
      [
        -1541.781005859375,
        -3937.0,
        771.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        771.5
      ],
      [
        -1541.781005859375,
        -3937.0,
        772.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        772.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        772.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        771.5
      ],
      [
        -1541.781005859375,
        -3937.0,
        771.5
      ],
      [
        -1541.781005859375,
        -3937.0,
        772.5
      ],
      [
        -1513.0,
        -3916.418701171875,
        780.0
      ],
      [
        -1506.8209228515625,
        -3912.0,
        780.0
      ],
      [
        -1506.8209228515625,
        -3912.0,
        779.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        779.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        779.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        780.0
      ],
      [
        -1541.7808837890625,
        -3937.0,
        802.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        802.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        801.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        801.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        801.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        802.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        802.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        801.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        740.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        740.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        741.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        741.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        741.5
      ],
      [
        -1536.5,
        -3933.2236328125,
        740.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        740.5
      ],
      [
        -1541.7808837890625,
        -3937.0,
        741.5
      ],
      [
        -1513.0,
        -3916.418701171875,
        748.5
      ],
      [
        -1506.821044921875,
        -3912.0,
        748.5
      ],
      [
        -1506.821044921875,
        -3912.0,
        747.5
      ],
      [
        -1513.0,
        -3916.418701171875,
        747.5
      ],
      [
        -1513.0,
        -3916.418701171875,
        747.5
      ],
      [
        -1513.0,
        -3916.418701171875,
        748.5
      ],
      [
        -1540.0,
        -3935.7265625,
        692.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        692.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        692.0
      ],
      [
        -1540.0,
        -3935.7265625,
        693.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        693.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        693.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        693.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        692.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        692.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        693.0
      ],
      [
        -1541.5,
        -3936.79931640625,
        709.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        709.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        709.0
      ],
      [
        -1541.5,
        -3936.79931640625,
        708.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        708.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        708.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        709.0
      ],
      [
        -1536.5,
        -3933.2236328125,
        708.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        708.0
      ],
      [
        -1513.0,
        -3916.418701171875,
        709.0
      ],
      [
        -1534.12109375,
        -3931.522216796875,
        685.0
      ],
      [
        -1527.043212890625,
        -3926.4609375,
        685.0
      ],
      [
        -1534.12109375,
        -3931.522216796875,
        685.0
      ],
      [
        -1527.043212890625,
        -3926.4609375,
        685.0
      ],
      [
        -1527.5,
        -3934.330078125,
        670.5
      ],
      [
        -1532.5,
        -3934.330078125,
        670.5
      ],
      [
        -1525.0,
        -3930.0,
        670.5
      ],
      [
        -1527.5,
        -3934.330078125,
        670.5
      ],
      [
        -1527.043212890625,
        -3926.4609375,
        670.5
      ],
      [
        -1525.0,
        -3930.0,
        670.5
      ],
      [
        -1532.5,
        -3934.330078125,
        670.5
      ],
      [
        -1534.12109375,
        -3931.522216796875,
        670.5
      ],
      [
        -1535.0,
        -3940.0,
        670.5
      ],
      [
        -1535.0,
        -3936.0,
        670.5
      ],
      [
        -1539.0,
        -3936.0,
        670.5
      ],
      [
        -1535.0,
        -3936.0,
        670.5
      ],
      [
        -1539.0,
        -3936.0,
        670.5
      ],
      [
        -1539.0,
        -3940.0,
        670.5
      ],
      [
        -1514.5,
        -3936.0,
        670.5
      ],
      [
        -1514.5,
        -3940.0,
        670.5
      ],
      [
        -1514.5,
        -3936.0,
        670.5
      ],
      [
        -1510.5,
        -3936.0,
        670.5
      ],
      [
        -1536.0,
        -3941.64013671875,
        716.0
      ],
      [
        -1513.5,
        -3941.64013671875,
        716.0
      ],
      [
        -1536.0,
        -3941.703369140625,
        717.04541015625
      ],
      [
        -1513.5,
        -3941.703369140625,
        717.04541015625
      ],
      [
        -1536.0,
        -3941.64013671875,
        716.0
      ],
      [
        -1536.0,
        -3941.703369140625,
        717.04541015625
      ],
      [
        -1513.5,
        -3941.703369140625,
        717.04541015625
      ],
      [
        -1513.5,
        -3941.64013671875,
        716.0
      ],
      [
        -1535.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1535.0,
        -3938.890380859375,
        670.5
      ],
      [
        -1539.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1539.0,
        -3938.890380859375,
        670.5
      ],
      [
        -1539.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1535.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1514.5,
        -3939.917724609375,
        687.5
      ],
      [
        -1514.5,
        -3938.890380859375,
        670.5
      ],
      [
        -1514.5,
        -3939.917724609375,
        687.5
      ],
      [
        -1510.5,
        -3939.917724609375,
        687.5
      ],
      [
        -1535.0,
        -3939.87353515625,
        687.5
      ],
      [
        -1535.0,
        -3938.374755859375,
        670.5
      ],
      [
        -1539.0,
        -3936.0,
        674.8258666992188
      ],
      [
        -1539.0,
        -3937.117431640625,
        687.5
      ],
      [
        -1536.26708984375,
        -3939.0,
        687.5
      ],
      [
        -1538.0,
        -3939.0,
        701.0419921875
      ],
      [
        -1538.0,
        -3937.805908203125,
        687.5
      ],
      [
        -1538.0,
        -3939.0,
        701.0419921875
      ],
      [
        -1538.0,
        -3937.806396484375,
        687.5
      ],
      [
        -1536.267822265625,
        -3939.0,
        687.5
      ],
      [
        -1538.0,
        -3939.0,
        687.5
      ],
      [
        -1539.0,
        -3936.0,
        674.828369140625
      ],
      [
        -1538.4461669921875,
        -3936.0,
        670.5
      ],
      [
        -1539.0,
        -3939.0,
        687.5
      ],
      [
        -1539.0,
        -3937.117431640625,
        687.5
      ],
      [
        -1535.0,
        -3939.87353515625,
        687.5
      ],
      [
        -1539.7454833984375,
        -3937.0,
        692.0
      ],
      [
        -1539.8736572265625,
        -3937.0,
        693.0
      ],
      [
        -1540.0,
        -3936.82470703125,
        692.0
      ],
      [
        -1539.7454833984375,
        -3937.0,
        692.0
      ],
      [
        -1539.8736572265625,
        -3937.0,
        693.0
      ],
      [
        -1540.0,
        -3936.912841796875,
        693.0
      ],
      [
        -1503.0999755859375,
        -3940.660888671875,
        789.4187622070312
      ],
      [
        -1503.0999755859375,
        -3942.696044921875,
        812.5
      ],
      [
        -1514.5,
        -3939.529296875,
        687.5
      ],
      [
        -1514.5,
        -3938.030029296875,
        670.5
      ],
      [
        -1513.5,
        -3939.0,
        689.313720703125
      ],
      [
        -1511.5,
        -3939.0,
        704.9429321289062
      ],
      [
        -1511.5,
        -3939.0,
        704.9429321289062
      ],
      [
        -1511.5,
        -3937.4619140625,
        687.5
      ],
      [
        -1513.73193359375,
        -3939.0,
        687.5
      ],
      [
        -1511.5,
        -3937.4619140625,
        687.5
      ],
      [
        -1511.5,
        -3939.0,
        687.5
      ],
      [
        -1511.553955078125,
        -3936.0,
        670.5
      ],
      [
        -1511.5,
        -3936.0,
        670.5
      ],
      [
        -1511.5,
        -3936.0,
        670.9215698242188
      ],
      [
        -1513.5,
        -3938.840087890625,
        687.5
      ],
      [
        -1513.5,
        -3939.0,
        689.313720703125
      ],
      [
        -1510.254150390625,
        -3937.0,
        692.0
      ],
      [
        -1507.0,
        -3934.757568359375,
        692.0
      ],
      [
        -1510.1259765625,
        -3937.0,
        693.0
      ],
      [
        -1507.0,
        -3934.845947265625,
        693.0
      ],
      [
        -1510.254150390625,
        -3937.0,
        692.0
      ],
      [
        -1510.1259765625,
        -3937.0,
        693.0
      ],
      [
        -1508.2066650390625,
        -3937.0,
        708.0
      ],
      [
        -1506.0,
        -3935.4794921875,
        708.0
      ],
      [
        -1508.0784912109375,
        -3937.0,
        709.0
      ],
      [
        -1506.0,
        -3935.567626953125,
        709.0
      ],
      [
        -1508.2066650390625,
        -3937.0,
        708.0
      ],
      [
        -1508.0784912109375,
        -3937.0,
        709.0
      ],
      [
        -1510.5,
        -3936.0,
        678.7353515625
      ],
      [
        -1510.5,
        -3936.77294921875,
        687.5
      ],
      [
        -1510.5,
        -3939.0,
        687.5
      ],
      [
        -1514.5,
        -3939.529296875,
        687.5
      ],
      [
        -1513.5,
        -3941.4453125,
        717.04541015625
      ],
      [
        -1513.5,
        -3941.35302734375,
        716.0
      ],
      [
        -1513.916748046875,
        -3941.64013671875,
        716.0
      ],
      [
        -1513.5,
        -3941.35302734375,
        716.0
      ],
      [
        -1513.5,
        -3941.4453125,
        717.04541015625
      ],
      [
        -1513.87451171875,
        -3941.703369140625,
        717.04541015625
      ],
      [
        -1538.0,
        -3937.0,
        687.5
      ],
      [
        -1536.0,
        -3937.0,
        687.5
      ],
      [
        -1536.0,
        -3939.0,
        687.5
      ],
      [
        -1536.267822265625,
        -3939.0,
        687.5
      ],
      [
        -1538.0,
        -3937.806396484375,
        687.5
      ],
      [
        -1536.0,
        -3939.1845703125,
        687.5
      ],
      [
        -1539.0,
        -3937.0,
        687.5
      ],
      [
        -1539.0,
        -3937.0,
        686.1680908203125
      ],
      [
        -1539.0,
        -3937.0,
        687.5
      ],
      [
        -1536.0,
        -3936.0,
        687.5
      ],
      [
        -1536.0,
        -3936.0,
        670.5
      ],
      [
        -1536.0,
        -3936.0,
        687.5
      ],
      [
        -1539.0,
        -3937.0,
        693.0
      ],
      [
        -1539.0,
        -3936.0,
        693.0
      ],
      [
        -1536.5,
        -3936.0,
        693.0
      ],
      [
        -1539.0,
        -3937.0,
        692.0
      ],
      [
        -1536.5,
        -3936.0,
        692.0
      ],
      [
        -1539.0,
        -3936.0,
        692.0
      ],
      [
        -1536.5,
        -3936.0,
        693.0
      ],
      [
        -1536.5,
        -3936.0,
        692.0
      ],
      [
        -1540.0,
        -3936.0,
        693.0
      ],
      [
        -1540.0,
        -3936.0,
        692.0
      ],
      [
        -1513.5,
        -3937.0,
        687.5
      ],
      [
        -1511.5,
        -3937.0,
        687.5
      ],
      [
        -1511.5,
        -3937.462158203125,
        687.5
      ],
      [
        -1513.5,
        -3938.84033203125,
        687.5
      ],
      [
        -1503.0999755859375,
        -3939.336669921875,
        789.418701171875
      ],
      [
        -1504.53466796875,
        -3937.0,
        766.57275390625
      ],
      [
        -1503.0999755859375,
        -3937.0,
        789.418701171875
      ],
      [
        -1503.0999755859375,
        -3940.660888671875,
        789.4187622070312
      ],
      [
        -1508.2193603515625,
        -3937.0,
        707.89794921875
      ],
      [
        -1504.53466796875,
        -3937.0,
        766.57275390625
      ],
      [
        -1503.0999755859375,
        -3939.336669921875,
        789.418701171875
      ],
      [
        -1510.8294677734375,
        -3937.0,
        687.5
      ],
      [
        -1535.0,
        -3937.0,
        687.5
      ],
      [
        -1535.0,
        -3937.0,
        670.5
      ],
      [
        -1535.0,
        -3937.0,
        687.5
      ],
      [
        -1536.0,
        -3937.0,
        687.5
      ],
      [
        -1514.5,
        -3937.0,
        687.5
      ],
      [
        -1514.5,
        -3937.0,
        670.5
      ],
      [
        -1514.5,
        -3937.0,
        687.5
      ],
      [
        -1503.0999755859375,
        -3910.535888671875,
        789.418701171875
      ],
      [
        -1503.0999755859375,
        -3910.535888671875,
        789.418701171875
      ],
      [
        -1503.0999755859375,
        -3909.339111328125,
        789.4187622070312
      ],
      [
        -1505.7322998046875,
        -3912.0,
        747.5
      ],
      [
        -1505.733154296875,
        -3937.0,
        747.5
      ],
      [
        -1505.67041015625,
        -3937.0,
        748.5
      ],
      [
        -1505.6695556640625,
        -3912.0,
        748.5
      ],
      [
        -1505.6695556640625,
        -3912.0,
        748.5
      ],
      [
        -1505.7322998046875,
        -3912.0,
        747.5
      ],
      [
        -1508.1507568359375,
        -3937.0,
        709.0
      ],
      [
        -1508.1500244140625,
        -3912.950439453125,
        709.0
      ],
      [
        -1508.2127685546875,
        -3912.995361328125,
        708.0
      ],
      [
        -1508.2135009765625,
        -3937.0,
        708.0
      ],
      [
        -1509.1546630859375,
        -3913.6689453125,
        693.0
      ],
      [
        -1509.1553955078125,
        -3936.331298828125,
        693.0
      ],
      [
        -1509.2181396484375,
        -3936.2861328125,
        692.0
      ],
      [
        -1509.2174072265625,
        -3913.7138671875,
        692.0
      ],
      [
        -1475.588134765625,
        -3928.667724609375,
        690.696533203125
      ],
      [
        -1475.588134765625,
        -3928.667724609375,
        690.696533203125
      ],
      [
        -1475.689697265625,
        -3928.46484375,
        690.665283203125
      ],
      [
        -1475.689697265625,
        -3928.46484375,
        690.665283203125
      ],
      [
        -1475.5933837890625,
        -3928.464599609375,
        690.663330078125
      ],
      [
        -1475.3125,
        -3928.46435546875,
        690.6575927734375
      ],
      [
        -1447.9625244140625,
        -3931.110107421875,
        692.7578735351562
      ],
      [
        -1460.930419921875,
        -3913.71484375,
        698.1178588867188
      ],
      [
        -1460.930419921875,
        -3913.71484375,
        698.1178588867188
      ],
      [
        -1460.802734375,
        -3913.625244140625,
        698.25
      ],
      [
        -1460.98388671875,
        -3944.821044921875,
        698.1400146484375
      ],
      [
        -1460.900634765625,
        -3944.902099609375,
        698.25
      ],
      [
        -1460.98388671875,
        -3944.821044921875,
        698.1400146484375
      ],
      [
        -1460.2806396484375,
        -3915.21240234375,
        704.0625
      ],
      [
        -1449.7095947265625,
        -3939.865478515625,
        704.5087890625
      ],
      [
        -1449.2962646484375,
        -3940.608154296875,
        704.0625
      ],
      [
        -1449.7095947265625,
        -3939.865478515625,
        704.5087890625
      ],
      [
        -1450.0426025390625,
        -3939.70751953125,
        704.6392822265625
      ],
      [
        -1449.5257568359375,
        -3940.671875,
        704.0625
      ],
      [
        -1450.0426025390625,
        -3939.70751953125,
        704.6392822265625
      ],
      [
        -1459.66796875,
        -3943.4921875,
        704.0625
      ],
      [
        -1457.032470703125,
        -3924.82275390625,
        708.4617919921875
      ],
      [
        -1458.58349609375,
        -3939.134765625,
        714.4840087890625
      ],
      [
        -1457.8900146484375,
        -3938.937744140625,
        714.4228515625
      ],
      [
        -1459.89208984375,
        -3938.9814453125,
        712.9061279296875
      ],
      [
        -1457.671875,
        -3938.4111328125,
        712.9063110351562
      ],
      [
        -1478.451416015625,
        -3935.50830078125,
        692.5814208984375
      ],
      [
        -1475.4473876953125,
        -3934.227294921875,
        691.6055297851562
      ],
      [
        -1476.6348876953125,
        -3938.09228515625,
        693.1264038085938
      ],
      [
        -1478.451416015625,
        -3935.50830078125,
        692.5814208984375
      ],
      [
        -1475.3125,
        -3940.314697265625,
        693.6384887695312
      ],
      [
        -1476.6348876953125,
        -3938.09228515625,
        693.1264038085938
      ],
      [
        -1479.0841064453125,
        -3935.383544921875,
        694.3300170898438
      ],
      [
        -1475.3125,
        -3941.830322265625,
        695.9558715820312
      ],
      [
        -1479.0841064453125,
        -3935.383544921875,
        694.3300170898438
      ],
      [
        -1494.5126953125,
        -3924.420166015625,
        691.9595336914062
      ],
      [
        -1476.255859375,
        -3917.84326171875,
        692.9401245117188
      ],
      [
        -1476.255859375,
        -3917.84326171875,
        692.9401245117188
      ],
      [
        -1475.3125,
        -3917.410888671875,
        693.0069580078125
      ],
      [
        -1484.41552734375,
        -3929.04296875,
        693.0807495117188
      ],
      [
        -1484.480712890625,
        -3928.938232421875,
        692.7757568359375
      ],
      [
        -1502.3138427734375,
        -3929.398681640625,
        698.3367309570312
      ],
      [
        -1503.0999755859375,
        -3929.38818359375,
        698.5020751953125
      ],
      [
        -1502.3138427734375,
        -3929.398681640625,
        698.3367309570312
      ],
      [
        -1481.412353515625,
        -3932.721435546875,
        701.5438232421875
      ],
      [
        -1481.412353515625,
        -3932.721435546875,
        701.5438232421875
      ],
      [
        -1478.1319580078125,
        -3934.246826171875,
        704.5570068359375
      ],
      [
        -1501.251220703125,
        -3920.23828125,
        698.5667724609375
      ],
      [
        -1503.0999755859375,
        -3920.302490234375,
        699.0739135742188
      ],
      [
        -1501.251220703125,
        -3920.23828125,
        698.5667724609375
      ],
      [
        -1479.0975341796875,
        -3916.841064453125,
        699.0569458007812
      ],
      [
        -1479.0975341796875,
        -3916.841064453125,
        699.0569458007812
      ],
      [
        -1476.01806640625,
        -3915.513671875,
        701.2632446289062
      ],
      [
        -1483.5,
        -3927.553466796875,
        700.65185546875
      ],
      [
        -1482.2584228515625,
        -3931.821044921875,
        699.4996948242188
      ],
      [
        -1481.402099609375,
        -3926.644287109375,
        703.0487670898438
      ],
      [
        -1483.5,
        -3927.553466796875,
        700.65185546875
      ],
      [
        -1481.402099609375,
        -3926.644287109375,
        703.0487670898438
      ],
      [
        -1478.642333984375,
        -3925.97705078125,
        704.59375
      ],
      [
        -1478.6412353515625,
        -3925.9716796875,
        704.5936889648438
      ],
      [
        -1485.9952392578125,
        -3927.73583984375,
        700.5341186523438
      ],
      [
        -1499.3504638671875,
        -3923.301025390625,
        701.7962036132812
      ],
      [
        -1503.0999755859375,
        -3922.307861328125,
        702.1025390625
      ],
      [
        -1499.3504638671875,
        -3923.301025390625,
        701.7962036132812
      ],
      [
        -1503.0999755859375,
        -3920.4755859375,
        699.5934448242188
      ],
      [
        -1486.7421875,
        -3919.33935546875,
        697.6436767578125
      ],
      [
        -1488.1456298828125,
        -3919.154052734375,
        696.54345703125
      ],
      [
        -1494.0760498046875,
        -3919.98876953125,
        696.598876953125
      ],
      [
        -1486.7421875,
        -3919.33935546875,
        697.6436767578125
      ],
      [
        -1485.8846435546875,
        -3927.727783203125,
        700.5393676757812
      ],
      [
        -1555.4541015625,
        -3962.08154296875,
        880.0
      ],
      [
        -1555.45703125,
        -3945.6513671875,
        880.0
      ],
      [
        -1555.213623046875,
        -3888.509033203125,
        880.0
      ],
      [
        -1555.45703125,
        -3945.6513671875,
        880.0
      ],
      [
        -1543.116943359375,
        -3972.93994140625,
        880.0
      ],
      [
        -1544.626708984375,
        -3971.752197265625,
        880.0
      ],
      [
        -1544.626708984375,
        -3971.752197265625,
        880.0
      ],
      [
        -1555.4541015625,
        -3962.08154296875,
        880.0
      ],
      [
        -1555.213623046875,
        -3888.509033203125,
        880.0
      ],
      [
        -1551.32177734375,
        -3883.620361328125,
        880.0
      ],
      [
        -1551.32177734375,
        -3883.620361328125,
        880.0
      ],
      [
        -1544.65576171875,
        -3875.318359375,
        880.0
      ],
      [
        -1536.0,
        -3876.28564453125,
        814.9671020507812
      ],
      [
        -1544.65576171875,
        -3875.318359375,
        880.0
      ],
      [
        -1536.0,
        -3875.359130859375,
        880.0
      ],
      [
        -1536.0,
        -3970.769775390625,
        818.0621337890625
      ],
      [
        -1536.0,
        -3973.0234375,
        880.0
      ],
      [
        -1543.116943359375,
        -3972.93994140625,
        880.0
      ],
      [
        -1536.0,
        -3887.00439453125,
        813.7374267578125
      ],
      [
        -1536.0,
        -3876.28564453125,
        814.9671020507812
      ],
      [
        -1536.0,
        -3887.684814453125,
        812.5
      ],
      [
        -1536.0,
        -3887.684814453125,
        813.6593017578125
      ],
      [
        -1536.0,
        -3970.5,
        812.5
      ],
      [
        -1536.0,
        -3970.769775390625,
        818.0621337890625
      ],
      [
        -1536.0,
        -3887.684814453125,
        813.8111572265625
      ],
      [
        -1536.0,
        -3887.00439453125,
        813.7374267578125
      ],
      [
        -1536.0,
        -3887.684814453125,
        813.8111572265625
      ],
      [
        -1444.762939453125,
        -3887.949462890625,
        880.0
      ],
      [
        -1445.1158447265625,
        -3952.99267578125,
        880.0
      ],
      [
        -1456.5343017578125,
        -3884.4921875,
        839.8536376953125
      ],
      [
        -1456.5343017578125,
        -3884.4921875,
        839.8536376953125
      ],
      [
        -1456.499267578125,
        -3884.49658203125,
        840.3994140625
      ],
      [
        -1456.2669677734375,
        -3884.526123046875,
        844.016357421875
      ],
      [
        -1456.8311767578125,
        -3884.376708984375,
        839.76025390625
      ],
      [
        -1456.8311767578125,
        -3884.376708984375,
        839.76025390625
      ],
      [
        -1456.4150390625,
        -3884.467529296875,
        844.0274658203125
      ],
      [
        -1464.0,
        -3961.354248046875,
        812.5
      ],
      [
        -1464.0,
        -3963.89599609375,
        846.8538818359375
      ],
      [
        -1464.0,
        -3894.8740234375,
        816.8230590820312
      ],
      [
        -1464.0,
        -3893.09521484375,
        840.1790771484375
      ],
      [
        -1464.0,
        -3881.587158203125,
        837.5050048828125
      ],
      [
        -1464.0,
        -3888.648681640625,
        839.6738891601562
      ],
      [
        -1464.0,
        -3888.648681640625,
        839.6738891601562
      ],
      [
        -1464.0,
        -3893.09521484375,
        840.1790771484375
      ],
      [
        -1464.0,
        -3894.8857421875,
        812.5
      ],
      [
        -1464.0,
        -3894.8740234375,
        816.8230590820312
      ],
      [
        -1464.0,
        -3881.587158203125,
        837.5050048828125
      ],
      [
        -1464.0,
        -3881.46533203125,
        844.5969848632812
      ],
      [
        -1464.0,
        -3963.89599609375,
        846.8538818359375
      ],
      [
        -1464.0,
        -3964.777099609375,
        862.1455078125
      ],
      [
        -1464.0,
        -3880.857666015625,
        880.0
      ],
      [
        -1456.4268798828125,
        -3883.845458984375,
        880.0
      ],
      [
        -1456.4268798828125,
        -3883.845458984375,
        880.0
      ],
      [
        -1444.762939453125,
        -3887.949462890625,
        880.0
      ],
      [
        -1464.0,
        -3978.08349609375,
        865.9923095703125
      ],
      [
        -1445.21337890625,
        -3969.818115234375,
        880.0
      ],
      [
        -1464.0,
        -3978.554931640625,
        880.0
      ],
      [
        -1445.21337890625,
        -3969.818115234375,
        880.0
      ],
      [
        -1445.1158447265625,
        -3952.99267578125,
        880.0
      ],
      [
        -1464.0,
        -3978.08349609375,
        865.9923095703125
      ],
      [
        -1464.0,
        -3969.618896484375,
        863.8148193359375
      ],
      [
        -1464.0,
        -3964.802001953125,
        862.5756225585938
      ],
      [
        -1464.0,
        -3964.835693359375,
        863.1624145507812
      ],
      [
        -1464.0,
        -3969.618896484375,
        863.8148193359375
      ],
      [
        -1464.0,
        -3964.835693359375,
        863.1624145507812
      ],
      [
        -1510.1998291015625,
        -3875.48046875,
        880.0
      ],
      [
        -1477.2425537109375,
        -3875.63330078125,
        880.0
      ],
      [
        -1510.1998291015625,
        -3875.48046875,
        880.0
      ],
      [
        -1536.0,
        -3887.684814453125,
        813.6593017578125
      ],
      [
        -1481.0947265625,
        -3887.699951171875,
        830.8259887695312
      ],
      [
        -1481.0947265625,
        -3887.699951171875,
        830.8259887695312
      ],
      [
        -1479.1204833984375,
        -3888.522705078125,
        831.3489379882812
      ],
      [
        -1479.1204833984375,
        -3888.522705078125,
        831.3489379882812
      ],
      [
        -1464.0,
        -3893.45068359375,
        835.5115356445312
      ],
      [
        -1475.146484375,
        -3899.153564453125,
        827.5134887695312
      ],
      [
        -1475.146484375,
        -3899.153564453125,
        820.0
      ],
      [
        -1472.853515625,
        -3895.446533203125,
        827.5134887695312
      ],
      [
        -1472.853515625,
        -3895.446533203125,
        820.0
      ],
      [
        -1472.853515625,
        -3895.446533203125,
        820.0
      ],
      [
        -1475.146484375,
        -3899.153564453125,
        820.0
      ],
      [
        -1473.3787841796875,
        -3898.421630859375,
        820.0
      ],
      [
        -1472.5001220703125,
        -3896.2998046875,
        820.0
      ],
      [
        -1475.1463623046875,
        -3899.153564453125,
        820.0134887695312
      ],
      [
        -1475.4998779296875,
        -3898.300048828125,
        820.0134887695312
      ],
      [
        -1474.6212158203125,
        -3896.178466796875,
        820.0134887695312
      ],
      [
        -1472.853515625,
        -3895.446533203125,
        820.0134887695312
      ],
      [
        -1473.732177734375,
        -3894.0322265625,
        820.0134887695312
      ],
      [
        -1471.878662109375,
        -3897.80029296875,
        820.0
      ],
      [
        -1470.0250244140625,
        -3897.032470703125,
        820.0
      ],
      [
        -1475.853515625,
        -3899.153564453125,
        820.0134887695312
      ],
      [
        -1469.853515625,
        -3897.446533203125,
        820.0134887695312
      ],
      [
        -1469.853515625,
        -3897.446533203125,
        812.5
      ],
      [
        -1472.1466064453125,
        -3901.153564453125,
        827.5134887695312
      ],
      [
        -1472.1466064453125,
        -3901.153564453125,
        820.0
      ],
      [
        -1469.8536376953125,
        -3897.4462890625,
        820.0
      ],
      [
        -1471.6209716796875,
        -3898.17822265625,
        820.0
      ],
      [
        -1472.5,
        -3900.30029296875,
        820.0
      ],
      [
        -1472.1466064453125,
        -3901.153564453125,
        820.0
      ],
      [
        -1472.146484375,
        -3901.153564453125,
        820.0134887695312
      ],
      [
        -1469.853515625,
        -3897.446533203125,
        820.0134887695312
      ],
      [
        -1469.5,
        -3898.300048828125,
        820.0134887695312
      ],
      [
        -1470.378662109375,
        -3900.421142578125,
        820.0134887695312
      ],
      [
        -1471.267822265625,
        -3902.56787109375,
        820.0134887695312
      ],
      [
        -1473.12158203125,
        -3898.7998046875,
        820.0
      ],
      [
        -1474.9749755859375,
        -3899.567626953125,
        820.0
      ],
      [
        -1467.732177734375,
        -3902.56787109375,
        820.0134887695312
      ],
      [
        -1464.0,
        -3887.128662109375,
        839.20703125
      ],
      [
        -1464.0,
        -3881.568359375,
        838.6049194335938
      ],
      [
        -1464.0,
        -3893.119873046875,
        839.855712890625
      ],
      [
        -1477.2425537109375,
        -3875.63330078125,
        880.0
      ],
      [
        -1490.6842041015625,
        -3922.39990234375,
        818.0
      ],
      [
        -1490.6842041015625,
        -3931.60009765625,
        818.0
      ],
      [
        -1469.3157958984375,
        -3931.60009765625,
        818.0
      ],
      [
        -1469.3157958984375,
        -3922.39990234375,
        818.0
      ],
      [
        -1467.4000244140625,
        -3934.5,
        816.0999755859375
      ],
      [
        -1467.4000244140625,
        -3932.0,
        816.0999755859375
      ],
      [
        -1469.3157958984375,
        -3932.0,
        817.5
      ],
      [
        -1469.3157958984375,
        -3934.5,
        817.5
      ],
      [
        -1467.4000244140625,
        -3934.5,
        816.5999755859375
      ],
      [
        -1467.4000244140625,
        -3932.0,
        816.5999755859375
      ],
      [
        -1467.4000244140625,
        -3932.0,
        816.0999755859375
      ],
      [
        -1467.4000244140625,
        -3934.5,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3932.0,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3934.5,
        816.0999755859375
      ],
      [
        -1490.6842041015625,
        -3934.5,
        817.5
      ],
      [
        -1490.6842041015625,
        -3932.0,
        817.5
      ],
      [
        -1492.5999755859375,
        -3934.5,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3932.0,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3932.0,
        816.5999755859375
      ],
      [
        -1492.5999755859375,
        -3934.5,
        816.5999755859375
      ],
      [
        -1490.6842041015625,
        -3934.89990234375,
        817.5
      ],
      [
        -1469.3157958984375,
        -3934.89990234375,
        817.5
      ],
      [
        -1490.0,
        -3932.0,
        818.0
      ],
      [
        -1470.0,
        -3932.0,
        818.0
      ],
      [
        -1469.3157958984375,
        -3919.5,
        817.5
      ],
      [
        -1469.3157958984375,
        -3922.0,
        817.5
      ],
      [
        -1467.4000244140625,
        -3922.0,
        816.0999755859375
      ],
      [
        -1467.4000244140625,
        -3919.5,
        816.0999755859375
      ],
      [
        -1467.4000244140625,
        -3922.0,
        816.5999755859375
      ],
      [
        -1467.4000244140625,
        -3919.5,
        816.5999755859375
      ],
      [
        -1467.4000244140625,
        -3919.5,
        816.0999755859375
      ],
      [
        -1467.4000244140625,
        -3922.0,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3919.5,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3922.0,
        816.0999755859375
      ],
      [
        -1490.6842041015625,
        -3922.0,
        817.5
      ],
      [
        -1490.6842041015625,
        -3919.5,
        817.5
      ],
      [
        -1492.5999755859375,
        -3922.0,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3919.5,
        816.0999755859375
      ],
      [
        -1492.5999755859375,
        -3919.5,
        816.5999755859375
      ],
      [
        -1492.5999755859375,
        -3922.0,
        816.5999755859375
      ],
      [
        -1469.3157958984375,
        -3919.10009765625,
        817.5
      ],
      [
        -1490.6842041015625,
        -3919.10009765625,
        817.5
      ],
      [
        -1470.0,
        -3922.0,
        818.0
      ],
      [
        -1490.0,
        -3922.0,
        818.0
      ],
      [
        -1526.449951171875,
        -3924.449951171875,
        818.5
      ],
      [
        -1526.449951171875,
        -3924.0498046875,
        818.5
      ],
      [
        -1526.8499755859375,
        -3924.0498046875,
        818.5
      ],
      [
        -1526.8499755859375,
        -3924.449951171875,
        818.5
      ],
      [
        -1526.8499755859375,
        -3924.449951171875,
        818.5
      ],
      [
        -1526.449951171875,
        -3924.449951171875,
        818.5
      ],
      [
        -1526.449951171875,
        -3924.0498046875,
        818.5
      ],
      [
        -1526.8499755859375,
        -3924.0498046875,
        818.5
      ],
      [
        -1526.8499755859375,
        -3924.0498046875,
        855.1973266601562
      ],
      [
        -1526.449951171875,
        -3924.0498046875,
        855.9824829101562
      ],
      [
        -1526.449951171875,
        -3924.449951171875,
        855.9824829101562
      ],
      [
        -1526.8499755859375,
        -3924.449951171875,
        855.1973266601562
      ],
      [
        -1526.8499755859375,
        -3924.449951171875,
        852.2965698242188
      ],
      [
        -1526.449951171875,
        -3924.449951171875,
        852.0927734375
      ],
      [
        -1526.449951171875,
        -3924.0498046875,
        852.0927734375
      ],
      [
        -1526.8499755859375,
        -3924.0498046875,
        852.2965698242188
      ],
      [
        -1527.5693359375,
        -3924.449951171875,
        853.7854614257812
      ],
      [
        -1527.5693359375,
        -3924.0498046875,
        853.7854614257812
      ],
      [
        -1527.13232421875,
        -3924.449951171875,
        852.4404296875
      ],
      [
        -1527.13232421875,
        -3924.0498046875,
        852.4404296875
      ],
      [
        -1527.5693359375,
        -3924.0498046875,
        853.7854614257812
      ],
      [
        -1527.5693359375,
        -3924.449951171875,
        853.7854614257812
      ],
      [
        -1527.13232421875,
        -3924.0498046875,
        852.4404296875
      ],
      [
        -1527.13232421875,
        -3924.449951171875,
        852.4404296875
      ],
      [
        -1526.449951171875,
        -3922.0,
        855.9824829101562
      ],
      [
        -1526.449951171875,
        -3922.0,
        853.7797241210938
      ],
      [
        -1526.449951171875,
        -3922.0,
        855.9824829101562
      ],
      [
        -1526.449951171875,
        -3922.0,
        853.7797241210938
      ],
      [
        -1526.449951171875,
        -3922.0,
        852.0927734375
      ],
      [
        -1526.449951171875,
        -3922.0,
        852.0927734375
      ],
      [
        -1526.449951171875,
        -3926.0,
        853.7797241210938
      ],
      [
        -1526.449951171875,
        -3926.0,
        855.9824829101562
      ],
      [
        -1526.449951171875,
        -3926.0,
        852.0927734375
      ],
      [
        -1526.449951171875,
        -3926.0,
        853.7797241210938
      ],
      [
        -1526.449951171875,
        -3926.0,
        855.9824829101562
      ],
      [
        -1526.449951171875,
        -3926.0,
        852.0927734375
      ],
      [
        -1504.17626953125,
        -3923.5,
        842.4271850585938
      ],
      [
        -1503.4952392578125,
        -3923.5,
        843.763671875
      ],
      [
        -1503.4952392578125,
        -3924.5,
        843.763671875
      ],
      [
        -1504.17626953125,
        -3924.5,
        842.4271850585938
      ],
      [
        -1500.822265625,
        -3924.5,
        842.4017333984375
      ],
      [
        -1500.822265625,
        -3923.5,
        842.4017333984375
      ],
      [
        -1501.5032958984375,
        -3923.5,
        841.065185546875
      ],
      [
        -1501.5032958984375,
        -3924.5,
        841.065185546875
      ],
      [
        -1523.097412109375,
        -3924.5,
        853.75146484375
      ],
      [
        -1523.097412109375,
        -3923.5,
        853.75146484375
      ],
      [
        -1523.7783203125,
        -3923.5,
        852.4149780273438
      ],
      [
        -1523.7783203125,
        -3924.5,
        852.4149780273438
      ],
      [
        -1504.4031982421875,
        -3924.5,
        841.981689453125
      ],
      [
        -1504.4031982421875,
        -3923.5,
        841.981689453125
      ],
      [
        -1501.730224609375,
        -3923.5,
        840.6196899414062
      ],
      [
        -1501.730224609375,
        -3924.5,
        840.6196899414062
      ],
      [
        -1524.00537109375,
        -3923.5,
        851.969482421875
      ],
      [
        -1524.00537109375,
        -3924.5,
        851.969482421875
      ],
      [
        -1523.097412109375,
        -3926.0,
        853.75146484375
      ],
      [
        -1504.4031982421875,
        -3925.0,
        841.981689453125
      ],
      [
        -1503.4952392578125,
        -3925.0,
        843.763671875
      ],
      [
        -1500.822265625,
        -3925.0,
        842.4017333984375
      ],
      [
        -1501.730224609375,
        -3925.0,
        840.6196899414062
      ],
      [
        -1501.730224609375,
        -3925.0,
        840.6196899414062
      ],
      [
        -1500.822265625,
        -3925.0,
        842.4017333984375
      ],
      [
        -1503.4952392578125,
        -3925.0,
        843.763671875
      ],
      [
        -1504.4031982421875,
        -3925.0,
        841.981689453125
      ],
      [
        -1503.2681884765625,
        -3923.5,
        844.209228515625
      ],
      [
        -1500.59521484375,
        -3923.5,
        842.8472290039062
      ],
      [
        -1525.54345703125,
        -3923.5,
        855.5589599609375
      ],
      [
        -1526.4344482421875,
        -3923.5,
        856.012939453125
      ],
      [
        -1523.7613525390625,
        -3923.5,
        854.6510009765625
      ],
      [
        -1522.870361328125,
        -3923.5,
        854.197021484375
      ],
      [
        -1525.54345703125,
        -3923.5,
        855.5589599609375
      ],
      [
        -1523.7613525390625,
        -3923.5,
        854.6510009765625
      ],
      [
        -1522.870361328125,
        -3923.5,
        854.197021484375
      ],
      [
        -1526.4344482421875,
        -3923.5,
        856.012939453125
      ],
      [
        -1526.449951171875,
        -3923.5,
        855.9824829101562
      ],
      [
        -1503.2681884765625,
        -3923.5,
        844.209228515625
      ],
      [
        -1500.59521484375,
        -3923.5,
        842.8472290039062
      ],
      [
        -1524.8963623046875,
        -3922.0,
        852.4234008789062
      ],
      [
        -1526.449951171875,
        -3922.0,
        853.2150268554688
      ],
      [
        -1524.8963623046875,
        -3922.0,
        852.4234008789062
      ],
      [
        -1504.4031982421875,
        -3923.0,
        841.981689453125
      ],
      [
        -1501.730224609375,
        -3923.0,
        840.6196899414062
      ],
      [
        -1504.4031982421875,
        -3923.0,
        841.981689453125
      ],
      [
        -1501.730224609375,
        -3923.0,
        840.6196899414062
      ],
      [
        -1513.74609375,
        -3984.483154296875,
        880.0
      ],
      [
        -1476.98876953125,
        -3985.392333984375,
        880.0
      ],
      [
        -1513.74609375,
        -3984.483154296875,
        880.0
      ],
      [
        -1516.0067138671875,
        -3979.058837890625,
        880.0
      ],
      [
        -1467.1107177734375,
        -3973.061279296875,
        865.3023681640625
      ],
      [
        -1467.1107177734375,
        -3973.061279296875,
        865.3023681640625
      ],
      [
        -1464.0,
        -3973.03173828125,
        864.6927490234375
      ],
      [
        -1464.0,
        -3977.505859375,
        865.8436889648438
      ],
      [
        -1516.0067138671875,
        -3979.058837890625,
        880.0
      ],
      [
        -1513.762451171875,
        -3973.774169921875,
        880.0
      ],
      [
        -1474.237548828125,
        -3983.31591796875,
        880.0
      ],
      [
        -1474.237548828125,
        -3983.31591796875,
        880.0
      ],
      [
        -1476.98876953125,
        -3985.392333984375,
        880.0
      ],
      [
        -1513.5552978515625,
        -3973.286376953125,
        880.0
      ],
      [
        -1513.5552978515625,
        -3973.286376953125,
        880.0
      ],
      [
        -1442.504150390625,
        -3873.025634765625,
        957.2897338867188
      ],
      [
        -1442.504150390625,
        -3873.025634765625,
        957.2897338867188
      ],
      [
        -1442.4906005859375,
        -3872.9931640625,
        957.7694091796875
      ],
      [
        -1442.2774658203125,
        -3872.4814453125,
        965.3356323242188
      ],
      [
        -1441.93798828125,
        -3872.23583984375,
        977.5
      ],
      [
        -1442.2774658203125,
        -3872.4814453125,
        965.3356323242188
      ],
      [
        -1442.5101318359375,
        -3873.0234375,
        957.2883911132812
      ],
      [
        -1442.5101318359375,
        -3873.0234375,
        957.2883911132812
      ],
      [
        -1445.268310546875,
        -3969.84375,
        880.0
      ],
      [
        -1470.6650390625,
        -3861.09375,
        976.6776123046875
      ],
      [
        -1470.6650390625,
        -3861.09375,
        976.6776123046875
      ],
      [
        -1470.6767578125,
        -3861.063720703125,
        977.5
      ],
      [
        -1563.8291015625,
        -3874.615478515625,
        923.1052856445312
      ],
      [
        -1563.8291015625,
        -3874.615478515625,
        923.1052856445312
      ],
      [
        -1564.060302734375,
        -3874.58203125,
        925.3764038085938
      ],
      [
        -1442.4283447265625,
        -3872.8330078125,
        960.1175537109375
      ],
      [
        -1442.5089111328125,
        -3874.684326171875,
        957.654296875
      ],
      [
        -1457.5418701171875,
        -3874.646728515625,
        955.41259765625
      ],
      [
        -1457.5418701171875,
        -3874.646728515625,
        955.41259765625
      ],
      [
        -1568.374267578125,
        -3873.956298828125,
        967.7459106445312
      ],
      [
        -1568.84716796875,
        -3873.814697265625,
        977.5
      ],
      [
        -1568.374267578125,
        -3873.956298828125,
        967.7459106445312
      ],
      [
        -1568.890625,
        -3879.917724609375,
        920.3544311523438
      ],
      [
        -1568.890625,
        -3879.917724609375,
        920.3544311523438
      ],
      [
        -1568.882080078125,
        -3879.923828125,
        920.1843872070312
      ],
      [
        -1556.496826171875,
        -3888.93310546875,
        919.8519287109375
      ],
      [
        -1568.843017578125,
        -3879.952392578125,
        920.1708374023438
      ],
      [
        -1568.843017578125,
        -3879.952392578125,
        920.1708374023438
      ],
      [
        -1568.882080078125,
        -3879.923828125,
        920.1843872070312
      ],
      [
        -1556.49267578125,
        -3888.93603515625,
        919.851806640625
      ],
      [
        -1555.751708984375,
        -3889.47509765625,
        919.8327026367188
      ],
      [
        -1555.2193603515625,
        -3889.862548828125,
        880.0
      ],
      [
        -1555.751708984375,
        -3889.47509765625,
        919.8327026367188
      ],
      [
        -1474.4013671875,
        -3983.439453125,
        880.0
      ],
      [
        -1514.1810302734375,
        -3983.439453125,
        880.0
      ],
      [
        -1555.6951904296875,
        -3889.51611328125,
        915.604736328125
      ],
      [
        -1555.7852783203125,
        -3980.8193359375,
        893.3043212890625
      ],
      [
        -1555.7852783203125,
        -3980.8193359375,
        893.3043212890625
      ],
      [
        -1555.826904296875,
        -3981.21923828125,
        896.2918701171875
      ],
      [
        -1555.7022705078125,
        -3962.39453125,
        894.5100708007812
      ],
      [
        -1555.71240234375,
        -3958.2109375,
        895.064453125
      ],
      [
        -1555.7022705078125,
        -3962.39453125,
        894.5100708007812
      ],
      [
        -1548.30224609375,
        -3985.051025390625,
        894.02490234375
      ],
      [
        -1467.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1467.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1467.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1395.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1395.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1395.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1395.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1461.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1461.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1461.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1461.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1401.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1401.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1401.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1401.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1335.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1335.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1335.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1335.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1329.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1329.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1329.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1329.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1533.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1533.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1533.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1533.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1527.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1527.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1527.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1527.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1599.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1599.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1599.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1599.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1593.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1593.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      [
        -1593.0,
        -4016.0595703125,
        1042.0234375
      ],
      [
        -1593.0,
        -4029.699951171875,
        977.5
      ],
      [
        -1467.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1467.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1467.0,
        -3850.318359375,
        977.5
      ],
      [
        -1467.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1395.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1395.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1395.0,
        -3850.318359375,
        977.5
      ],
      [
        -1395.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1461.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1461.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1461.0,
        -3850.318359375,
        977.5
      ],
      [
        -1461.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1401.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1401.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1401.0,
        -3850.318359375,
        977.5
      ],
      [
        -1401.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1335.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1335.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1335.0,
        -3850.318359375,
        977.5
      ],
      [
        -1335.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1329.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1329.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1329.0,
        -3850.318359375,
        977.5
      ],
      [
        -1329.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1533.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1533.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1533.0,
        -3850.318359375,
        977.5
      ],
      [
        -1533.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1527.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1527.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1527.0,
        -3850.318359375,
        977.5
      ],
      [
        -1527.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1599.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1599.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1599.0,
        -3850.318359375,
        977.5
      ],
      [
        -1599.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1593.0,
        -3864.9423828125,
        1046.7713623046875
      ],
      [
        -1593.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1593.0,
        -3850.318359375,
        977.5
      ],
      [
        -1593.0,
        -3863.93994140625,
        1042.0234375
      ],
      [
        -1281.599609375,
        -3930.0,
        1034.5
      ],
      [
        -1281.599609375,
        -3939.789306640625,
        1034.5
      ],
      [
        -1281.599609375,
        -4000.210693359375,
        1034.5
      ],
      [
        -1281.599609375,
        -4010.0,
        1034.5
      ],
      [
        -1281.599609375,
        -3939.789306640625,
        1034.5
      ],
      [
        -1281.599609375,
        -4000.210693359375,
        1034.5
      ],
      [
        -1263.0,
        -4010.0,
        1000.7767333984375
      ],
      [
        -1265.053466796875,
        -4010.0,
        1004.5
      ],
      [
        -1265.053466796875,
        -4010.0,
        1004.5
      ],
      [
        -1281.599609375,
        -4010.0,
        1034.5
      ],
      [
        -1280.344970703125,
        -3930.0,
        1032.2252197265625
      ],
      [
        -1271.7564697265625,
        -3930.0,
        1016.6531982421875
      ],
      [
        -1263.0,
        -3930.0,
        1000.7767333984375
      ],
      [
        -1269.72314453125,
        -3930.0,
        1012.9666137695312
      ],
      [
        -1280.344970703125,
        -3930.0,
        1032.2252197265625
      ],
      [
        -1281.599609375,
        -3930.0,
        1034.5
      ],
      [
        -1270.56884765625,
        -3930.0,
        1014.5
      ],
      [
        -1271.7564697265625,
        -3930.0,
        1016.6531982421875
      ],
      [
        -1269.72314453125,
        -3930.0,
        1012.9666137695312
      ],
      [
        -1270.56884765625,
        -3930.0,
        1014.5
      ],
      [
        -1274.705322265625,
        -3930.0,
        1022.0
      ],
      [
        -1274.705322265625,
        -3924.0,
        1022.0
      ],
      [
        -1273.878173828125,
        -3924.0,
        1020.5
      ],
      [
        -1273.8780517578125,
        -3930.0,
        1020.5
      ],
      [
        -1274.705322265625,
        -3924.0,
        1022.0
      ],
      [
        -1273.8780517578125,
        -3924.0,
        1020.5
      ],
      [
        -1284.357177734375,
        -4001.0,
        1039.5
      ],
      [
        -1284.357177734375,
        -3940.0,
        1039.5
      ],
      [
        -1281.5994873046875,
        -4001.0,
        1034.5
      ],
      [
        -1284.357177734375,
        -4001.0,
        1039.5
      ],
      [
        -1284.357177734375,
        -3940.0,
        1039.5
      ],
      [
        -1281.5994873046875,
        -3940.0,
        1034.5
      ],
      [
        -1395.0,
        -3905.0,
        1080.0
      ],
      [
        -1395.0,
        -3863.82958984375,
        1041.5
      ],
      [
        -1335.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1335.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1335.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1335.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1335.0,
        -3863.829345703125,
        1041.5001220703125
      ],
      [
        -1335.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1329.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1329.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1329.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1329.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1329.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1329.0,
        -3863.829345703125,
        1041.5001220703125
      ],
      [
        -1329.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1335.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1329.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1335.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1357.0,
        -3874.0,
        1051.010986328125
      ],
      [
        -1341.443603515625,
        -3880.443603515625,
        1057.03662109375
      ],
      [
        -1372.556396484375,
        -3880.443603515625,
        1057.03662109375
      ],
      [
        -1357.0,
        -3874.0,
        1051.010986328125
      ],
      [
        -1357.0,
        -3884.187255859375,
        1060.5374755859375
      ],
      [
        -1343.68701171875,
        -3882.68701171875,
        1059.134521484375
      ],
      [
        -1370.31298828125,
        -3882.68701171875,
        1059.134521484375
      ],
      [
        -1357.0,
        -3884.187255859375,
        1060.5374755859375
      ],
      [
        -1343.68701171875,
        -3882.68701171875,
        1059.134521484375
      ],
      [
        -1340.79541015625,
        -3882.008544921875,
        1058.5
      ],
      [
        -1373.20458984375,
        -3882.008544921875,
        1058.5
      ],
      [
        -1370.31298828125,
        -3882.68701171875,
        1059.134521484375
      ],
      [
        -1340.79541015625,
        -3882.008544921875,
        1058.5
      ],
      [
        -1341.443603515625,
        -3880.443603515625,
        1057.03662109375
      ],
      [
        -1373.20458984375,
        -3882.008544921875,
        1058.5
      ],
      [
        -1372.556396484375,
        -3880.443603515625,
        1057.03662109375
      ],
      [
        -1336.6568603515625,
        -3900.0,
        1063.0
      ],
      [
        -1377.34326171875,
        -3900.0,
        1063.0
      ],
      [
        -1375.6865234375,
        -3904.0,
        1063.0
      ],
      [
        -1338.3135986328125,
        -3904.0,
        1063.0
      ],
      [
        -1336.6568603515625,
        -3900.0,
        1067.0
      ],
      [
        -1377.34326171875,
        -3900.0,
        1067.0
      ],
      [
        -1377.34326171875,
        -3900.0,
        1063.0
      ],
      [
        -1336.6568603515625,
        -3900.0,
        1063.0
      ],
      [
        -1338.3135986328125,
        -3904.0,
        1067.0
      ],
      [
        -1375.6865234375,
        -3904.0,
        1067.0
      ],
      [
        -1377.34326171875,
        -3900.0,
        1067.0
      ],
      [
        -1336.6568603515625,
        -3900.0,
        1067.0
      ],
      [
        -1338.3135986328125,
        -3904.0,
        1063.0
      ],
      [
        -1375.6865234375,
        -3904.0,
        1063.0
      ],
      [
        -1375.6865234375,
        -3904.0,
        1067.0
      ],
      [
        -1338.3135986328125,
        -3904.0,
        1067.0
      ],
      [
        -1370.9359130859375,
        -3876.531494140625,
        1039.24267578125
      ],
      [
        -1370.9359130859375,
        -3876.531494140625,
        1040.24267578125
      ],
      [
        -1362.2264404296875,
        -3871.835205078125,
        1036.903564453125
      ],
      [
        -1370.3916015625,
        -3875.21728515625,
        1039.096435546875
      ],
      [
        -1370.9359130859375,
        -3876.531494140625,
        1039.24267578125
      ],
      [
        -1370.3916015625,
        -3875.21728515625,
        1039.096435546875
      ],
      [
        -1362.2264404296875,
        -3871.835205078125,
        1036.903564453125
      ],
      [
        -1362.2264404296875,
        -3871.835205078125,
        1037.19580078125
      ],
      [
        -1370.3916015625,
        -3875.21728515625,
        1039.8201904296875
      ],
      [
        -1370.9359130859375,
        -3876.531494140625,
        1040.24267578125
      ],
      [
        -1370.3916015625,
        -3875.21728515625,
        1040.096435546875
      ],
      [
        -1362.2264404296875,
        -3871.835205078125,
        1037.903564453125
      ],
      [
        -1362.2264404296875,
        -3871.835205078125,
        1037.903564453125
      ],
      [
        -1370.3916015625,
        -3875.21728515625,
        1040.096435546875
      ],
      [
        -1343.064208984375,
        -3876.531494140625,
        1032.7574462890625
      ],
      [
        -1343.6085205078125,
        -3875.21728515625,
        1031.903564453125
      ],
      [
        -1343.064208984375,
        -3876.531494140625,
        1031.7574462890625
      ],
      [
        -1343.6085205078125,
        -3875.21728515625,
        1032.903564453125
      ],
      [
        -1343.064208984375,
        -3876.531494140625,
        1032.7574462890625
      ],
      [
        -1343.6085205078125,
        -3875.21728515625,
        1031.903564453125
      ],
      [
        -1343.6085205078125,
        -3875.21728515625,
        1032.903564453125
      ],
      [
        -1343.064208984375,
        -3876.531494140625,
        1031.7574462890625
      ],
      [
        -1381.164794921875,
        -3890.773681640625,
        1045.096435546875
      ],
      [
        -1381.164794921875,
        -3890.773681640625,
        1045.096435546875
      ],
      [
        -1381.164794921875,
        -3890.773681640625,
        1044.8043212890625
      ],
      [
        -1370.3916015625,
        -3875.21728515625,
        1039.8201904296875
      ],
      [
        -1381.164794921875,
        -3890.773681640625,
        1044.096435546875
      ],
      [
        -1381.164794921875,
        -3890.773681640625,
        1044.096435546875
      ],
      [
        -1395.0,
        -3900.0,
        1063.0
      ],
      [
        -1395.0,
        -3902.260009765625,
        1063.0
      ],
      [
        -1390.799560546875,
        -3904.0,
        1063.0
      ],
      [
        -1395.0,
        -3900.0,
        1067.0
      ],
      [
        -1395.0,
        -3900.0,
        1063.0
      ],
      [
        -1390.799560546875,
        -3904.0,
        1067.0
      ],
      [
        -1395.0,
        -3902.260009765625,
        1067.0
      ],
      [
        -1395.0,
        -3900.0,
        1067.0
      ],
      [
        -1390.799560546875,
        -3904.0,
        1063.0
      ],
      [
        -1390.799560546875,
        -3904.0,
        1067.0
      ],
      [
        -1376.4683837890625,
        -3909.93603515625,
        1049.24267578125
      ],
      [
        -1376.4683837890625,
        -3909.93603515625,
        1050.24267578125
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1050.096435546875
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1049.096435546875
      ],
      [
        -1376.4683837890625,
        -3909.93603515625,
        1049.24267578125
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1049.096435546875
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1050.096435546875
      ],
      [
        -1376.4683837890625,
        -3909.93603515625,
        1050.24267578125
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1011.5
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1010.5
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1010.5
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1011.5
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1055.0963134765625
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1055.0963134765625
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1054.8040771484375
      ],
      [
        -1377.78271484375,
        -3909.3916015625,
        1049.8201904296875
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1054.0963134765625
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1054.0963134765625
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1015.0963745117188
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1015.0963745117188
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1014.8041381835938
      ],
      [
        -1376.9066162109375,
        -3911.506591796875,
        1010.5
      ],
      [
        -1375.667724609375,
        -3910.267578125,
        1010.5
      ],
      [
        -1376.9066162109375,
        -3911.506591796875,
        1010.5
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1014.0963745117188
      ],
      [
        -1362.2265625,
        -3920.164794921875,
        1014.0963745117188
      ],
      [
        -1395.0,
        -3904.0,
        1063.0
      ],
      [
        -1395.0,
        -3904.0,
        1067.0
      ],
      [
        -1395.0,
        -3904.0,
        1067.0
      ],
      [
        -1395.0,
        -3904.0,
        1063.0
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1056.5
      ],
      [
        -1343.0640869140625,
        -3915.468505859375,
        1019.2426147460938
      ],
      [
        -1343.0640869140625,
        -3915.468505859375,
        1020.2426147460938
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1020.096435546875
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1019.096435546875
      ],
      [
        -1343.0640869140625,
        -3915.468505859375,
        1019.2426147460938
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1019.096435546875
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1020.096435546875
      ],
      [
        -1343.0640869140625,
        -3915.468505859375,
        1020.2426147460938
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1055.5
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1056.5
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1055.5
      ],
      [
        -1360.7235107421875,
        -3920.787353515625,
        1055.5
      ],
      [
        -1360.7235107421875,
        -3919.542236328125,
        1055.5
      ],
      [
        -1360.7235107421875,
        -3920.787353515625,
        1055.5
      ],
      [
        -1335.0,
        -3896.00048828125,
        1070.0
      ],
      [
        -1335.0,
        -3924.0,
        1070.0
      ],
      [
        -1335.0,
        -3924.0,
        1061.0
      ],
      [
        -1335.0,
        -3896.000244140625,
        1061.0
      ],
      [
        -1329.0,
        -3924.0,
        1061.0
      ],
      [
        -1329.0,
        -3910.485595703125,
        1061.0
      ],
      [
        -1335.0,
        -3896.000244140625,
        1061.0
      ],
      [
        -1335.0,
        -3924.0,
        1061.0
      ],
      [
        -1329.0,
        -3910.48583984375,
        1070.0
      ],
      [
        -1329.0,
        -3924.0,
        1070.0
      ],
      [
        -1335.0,
        -3924.0,
        1070.0
      ],
      [
        -1335.0,
        -3896.000732421875,
        1070.0
      ],
      [
        -1329.0,
        -3910.485595703125,
        1061.0
      ],
      [
        -1329.0,
        -3924.0,
        1061.0
      ],
      [
        -1329.0,
        -3924.0,
        1070.0
      ],
      [
        -1329.0,
        -3910.48583984375,
        1070.0
      ],
      [
        -1332.8353271484375,
        -3901.2265625,
        1025.0963134765625
      ],
      [
        -1335.0,
        -3906.45263671875,
        1023.6928100585938
      ],
      [
        -1335.0,
        -3906.45263671875,
        1022.6928100585938
      ],
      [
        -1332.8353271484375,
        -3901.2265625,
        1024.0963134765625
      ],
      [
        -1332.8353271484375,
        -3901.2265625,
        1024.0963134765625
      ],
      [
        -1335.0,
        -3906.45263671875,
        1022.6928100585938
      ],
      [
        -1335.0,
        -3906.45263671875,
        1023.6928100585938
      ],
      [
        -1332.8353271484375,
        -3901.2265625,
        1025.0963134765625
      ],
      [
        -1335.0,
        -3906.45263671875,
        1023.1244506835938
      ],
      [
        -1343.6083984375,
        -3916.78271484375,
        1019.8204956054688
      ],
      [
        -1275.27880859375,
        -3924.0,
        977.5
      ],
      [
        -1285.4603271484375,
        -3924.0,
        1041.5
      ],
      [
        -1277.7864990234375,
        -3901.25,
        993.2631225585938
      ],
      [
        -1277.7864990234375,
        -3906.75,
        993.2631225585938
      ],
      [
        -1277.02880859375,
        -3898.5,
        988.5
      ],
      [
        -1277.7864990234375,
        -3901.25,
        993.2631225585938
      ],
      [
        -1277.7864990234375,
        -3906.75,
        993.2631225585938
      ],
      [
        -1277.02880859375,
        -3909.5,
        988.5
      ],
      [
        -1276.27099609375,
        -3901.25,
        983.7368774414062
      ],
      [
        -1277.02880859375,
        -3898.5,
        988.5
      ],
      [
        -1277.02880859375,
        -3909.5,
        988.5
      ],
      [
        -1276.27099609375,
        -3906.75,
        983.7368774414062
      ],
      [
        -1276.27099609375,
        -3906.75,
        983.7368774414062
      ],
      [
        -1276.27099609375,
        -3901.25,
        983.7368774414062
      ],
      [
        -1329.0,
        -3870.000732421875,
        1047.2711181640625
      ],
      [
        -1315.6754150390625,
        -3869.815673828125,
        1046.374267578125
      ],
      [
        -1308.735107421875,
        -3868.8095703125,
        1041.5
      ],
      [
        -1318.47021484375,
        -3870.000732421875,
        1047.2708740234375
      ],
      [
        -1315.6754150390625,
        -3869.815673828125,
        1046.374267578125
      ],
      [
        -1322.9990234375,
        -3899.121826171875,
        987.4234008789062
      ],
      [
        -1321.422607421875,
        -3898.94482421875,
        987.729736328125
      ],
      [
        -1321.422607421875,
        -3909.05517578125,
        987.7297973632812
      ],
      [
        -1322.9990234375,
        -3908.878173828125,
        987.4234008789062
      ],
      [
        -1328.2420654296875,
        -3901.25,
        983.737060546875
      ],
      [
        -1328.2421875,
        -3906.75,
        983.7368774414062
      ],
      [
        -1321.422607421875,
        -3898.94482421875,
        987.729736328125
      ],
      [
        -1321.422607421875,
        -3909.05517578125,
        987.7297973632812
      ],
      [
        -1328.2421875,
        -3906.75,
        983.7368774414062
      ],
      [
        -1325.0899658203125,
        -3908.032470703125,
        985.9586181640625
      ],
      [
        -1328.2420654296875,
        -3901.25,
        983.737060546875
      ],
      [
        -1325.0899658203125,
        -3899.967529296875,
        985.95849609375
      ],
      [
        -1322.9990234375,
        -3899.121826171875,
        987.4234008789062
      ],
      [
        -1325.0899658203125,
        -3899.967529296875,
        985.95849609375
      ],
      [
        -1322.9990234375,
        -3908.878173828125,
        987.4234008789062
      ],
      [
        -1325.0899658203125,
        -3908.032470703125,
        985.9586181640625
      ],
      [
        -1323.4718017578125,
        -3909.5,
        983.7368774414062
      ],
      [
        -1320.873291015625,
        -3907.999755859375,
        983.7368774414062
      ],
      [
        -1324.80859375,
        -3908.732421875,
        983.7368774414062
      ],
      [
        -1323.4718017578125,
        -3909.5,
        983.7368774414062
      ],
      [
        -1324.80859375,
        -3908.732421875,
        983.7368774414062
      ],
      [
        -1318.7274169921875,
        -3906.98388671875,
        983.7368774414062
      ],
      [
        -1319.3125,
        -3907.11181640625,
        983.7368774414062
      ],
      [
        -1318.7274169921875,
        -3906.98388671875,
        983.7368774414062
      ],
      [
        -1319.3125,
        -3907.11181640625,
        983.7368774414062
      ],
      [
        -1320.873291015625,
        -3907.999755859375,
        983.7368774414062
      ],
      [
        -1329.2630615234375,
        -3902.656982421875,
        981.300048828125
      ],
      [
        -1329.2630615234375,
        -3902.656982421875,
        981.300048828125
      ],
      [
        -1329.2630615234375,
        -3904.85107421875,
        977.5000610351562
      ],
      [
        -1319.73681640625,
        -3902.656982421875,
        981.300048828125
      ],
      [
        -1319.73681640625,
        -3904.85107421875,
        977.5000610351562
      ],
      [
        -1319.73681640625,
        -3907.353271484375,
        983.7368774414062
      ],
      [
        -1318.8695068359375,
        -3901.506103515625,
        983.2938842773438
      ],
      [
        -1319.73681640625,
        -3907.1865234375,
        983.063720703125
      ],
      [
        -1319.73681640625,
        -3902.656982421875,
        981.300048828125
      ],
      [
        -1318.8695068359375,
        -3901.506103515625,
        983.2938842773438
      ],
      [
        -1318.998046875,
        -3901.676513671875,
        982.9984741210938
      ],
      [
        -1318.479248046875,
        -3901.4462890625,
        983.3974609375
      ],
      [
        -1329.0,
        -3888.999755859375,
        1061.0
      ],
      [
        -1329.0,
        -3898.524169921875,
        1070.0
      ],
      [
        -1329.0,
        -3888.999755859375,
        1061.0
      ],
      [
        -1335.0,
        -3888.999755859375,
        1061.0
      ],
      [
        -1329.0,
        -3898.524169921875,
        1070.0
      ],
      [
        -1333.9547119140625,
        -3898.524169921875,
        1070.0
      ],
      [
        -1335.0,
        -3885.54736328125,
        1029.30712890625
      ],
      [
        -1335.0,
        -3885.54736328125,
        1028.30712890625
      ],
      [
        -1335.0,
        -3885.54736328125,
        1028.30712890625
      ],
      [
        -1335.0,
        -3885.54736328125,
        1029.30712890625
      ],
      [
        -1335.0,
        -3885.54736328125,
        1028.8756103515625
      ],
      [
        -1343.6085205078125,
        -3875.21728515625,
        1032.1796875
      ],
      [
        -1285.1422119140625,
        -4001.0,
        1039.5
      ],
      [
        -1285.1422119140625,
        -3940.0,
        1039.5
      ],
      [
        -1284.3468017578125,
        -3930.0,
        1034.5
      ],
      [
        -1284.3466796875,
        -3941.235107421875,
        1034.5
      ],
      [
        -1284.3468017578125,
        -3998.764892578125,
        1034.5
      ],
      [
        -1284.3466796875,
        -4010.0,
        1034.5
      ],
      [
        -1284.3468017578125,
        -3941.235107421875,
        1034.5
      ],
      [
        -1284.3466796875,
        -3998.764892578125,
        1034.5
      ],
      [
        -1275.27880859375,
        -4010.0,
        977.5
      ],
      [
        -1279.5740966796875,
        -4010.0,
        1004.5
      ],
      [
        -1279.5740966796875,
        -4010.0,
        1004.5
      ],
      [
        -1284.3466796875,
        -4010.0,
        1034.5
      ],
      [
        -1283.9105224609375,
        -3930.0,
        1031.757568359375
      ],
      [
        -1281.904541015625,
        -3930.0,
        1019.1486206054688
      ],
      [
        -1280.5289306640625,
        -3930.0,
        1010.5021362304688
      ],
      [
        -1277.1326904296875,
        -3930.0,
        989.1532592773438
      ],
      [
        -1277.1326904296875,
        -3930.0,
        989.1532592773438
      ],
      [
        -1275.27880859375,
        -3930.0,
        977.5
      ],
      [
        -1283.9105224609375,
        -3930.0,
        1031.757568359375
      ],
      [
        -1284.3466796875,
        -3930.0,
        1034.5
      ],
      [
        -1281.1650390625,
        -3930.0,
        1014.5
      ],
      [
        -1281.904541015625,
        -3930.0,
        1019.1486206054688
      ],
      [
        -1280.5289306640625,
        -3930.0,
        1010.5021362304688
      ],
      [
        -1281.1650390625,
        -3930.0,
        1014.5
      ],
      [
        -1282.1195068359375,
        -3924.0,
        1020.5
      ],
      [
        -1282.1195068359375,
        -3930.0,
        1020.5
      ],
      [
        -1282.3582763671875,
        -3930.0,
        1022.0
      ],
      [
        -1282.3582763671875,
        -3924.0,
        1022.0
      ],
      [
        -1284.3468017578125,
        -4001.0,
        1034.5
      ],
      [
        -1285.1422119140625,
        -4001.0,
        1039.5
      ],
      [
        -1285.1422119140625,
        -3940.0,
        1039.5
      ],
      [
        -1284.3468017578125,
        -3940.0,
        1034.5
      ],
      [
        -1395.0,
        -4016.17041015625,
        1041.5
      ],
      [
        -1395.0,
        -3975.0,
        1080.0
      ],
      [
        -1329.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1329.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1329.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1329.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1329.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1329.0,
        -4016.170166015625,
        1041.5001220703125
      ],
      [
        -1335.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1335.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1335.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1335.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1335.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1335.0,
        -4016.170166015625,
        1041.5001220703125
      ],
      [
        -1335.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1329.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1335.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1329.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1353.0,
        -4010.0,
        1034.5
      ],
      [
        -1353.0,
        -3930.0,
        1010.0428466796875
      ],
      [
        -1353.0,
        -3930.0,
        1016.24755859375
      ],
      [
        -1353.0,
        -3930.0,
        1033.5679931640625
      ],
      [
        -1353.0,
        -3930.0,
        1033.5679931640625
      ],
      [
        -1353.0,
        -3930.0,
        1034.5
      ],
      [
        -1353.0,
        -3930.0,
        1014.5
      ],
      [
        -1353.0,
        -3930.0,
        1016.24755859375
      ],
      [
        -1353.0,
        -3930.0,
        1014.5
      ],
      [
        -1353.0,
        -3930.0,
        1010.0428466796875
      ],
      [
        -1286.263427734375,
        -3998.1455078125,
        1039.5
      ],
      [
        -1295.6163330078125,
        -4010.0,
        1016.2077026367188
      ],
      [
        -1279.6585693359375,
        -4010.0,
        977.5
      ],
      [
        -1285.1422119140625,
        -3997.4443359375,
        1039.5
      ],
      [
        -1284.80615234375,
        -3998.523193359375,
        1034.5
      ],
      [
        -1303.15771484375,
        -4010.0,
        1034.5
      ],
      [
        -1284.3466796875,
        -3998.23583984375,
        1034.5
      ],
      [
        -1284.8060302734375,
        -3998.523193359375,
        1034.5
      ],
      [
        -1288.7667236328125,
        -4001.0,
        1034.5
      ],
      [
        -1290.82763671875,
        -4001.0,
        1039.5
      ],
      [
        -1308.0,
        -3930.0,
        1034.5
      ],
      [
        -1308.0,
        -3953.684326171875,
        1034.5
      ],
      [
        -1308.0,
        -3986.31591796875,
        1034.5
      ],
      [
        -1308.0,
        -4010.0,
        1034.5
      ],
      [
        -1308.0,
        -3953.68408203125,
        1034.5
      ],
      [
        -1308.0,
        -3986.315673828125,
        1034.5
      ],
      [
        -1289.9000244140625,
        -4002.7548828125,
        1030.4434814453125
      ],
      [
        -1288.2711181640625,
        -4000.690185546875,
        1034.5
      ],
      [
        -1289.9000244140625,
        -4001.67431640625,
        1034.5
      ],
      [
        -1308.0,
        -3958.0,
        1014.5
      ],
      [
        -1308.0,
        -3930.699951171875,
        1014.5
      ],
      [
        -1308.0,
        -3931.5,
        1008.5
      ],
      [
        -1308.0,
        -3940.0,
        1008.5
      ],
      [
        -1308.0,
        -3940.0,
        1000.5
      ],
      [
        -1308.0,
        -3931.5,
        1000.5
      ],
      [
        -1308.0,
        -3940.0,
        1008.5
      ],
      [
        -1308.0,
        -3940.0,
        1000.5
      ],
      [
        -1308.0,
        -3931.5,
        1001.0
      ],
      [
        -1308.0,
        -3931.5,
        1000.5
      ],
      [
        -1308.0,
        -3931.5,
        1008.0
      ],
      [
        -1308.0,
        -3931.5,
        1008.5
      ],
      [
        -1308.0,
        -3930.0,
        1008.0
      ],
      [
        -1308.0,
        -3931.5,
        1008.0
      ],
      [
        -1308.0,
        -3931.5,
        1001.0
      ],
      [
        -1308.0,
        -3930.0,
        1001.0
      ],
      [
        -1308.0,
        -3930.699951171875,
        1032.5
      ],
      [
        -1308.0,
        -3958.0,
        1032.5
      ],
      [
        -1303.6793212890625,
        -4010.0,
        1034.5
      ],
      [
        -1302.7977294921875,
        -4010.0,
        1032.5
      ],
      [
        -1289.9000244140625,
        -4002.20703125,
        1032.5
      ],
      [
        -1308.0,
        -3958.0,
        1032.5
      ],
      [
        -1308.0,
        -3958.0,
        1014.5
      ],
      [
        -1295.6163330078125,
        -4010.0,
        1016.2077026367188
      ],
      [
        -1308.0,
        -3930.699951171875,
        1032.5
      ],
      [
        -1308.0,
        -3930.699951171875,
        1031.3333740234375
      ],
      [
        -1308.0,
        -3930.699951171875,
        1014.5
      ],
      [
        -1308.0,
        -3930.699951171875,
        1018.8748779296875
      ],
      [
        -1308.0,
        -3930.699951171875,
        1018.8748779296875
      ],
      [
        -1308.0,
        -3930.699951171875,
        1031.3333740234375
      ],
      [
        -1305.88330078125,
        -4010.0,
        1039.5
      ],
      [
        -1286.263427734375,
        -3998.1455078125,
        1039.5
      ],
      [
        -1288.7841796875,
        -4001.0,
        1034.5
      ],
      [
        -1290.9879150390625,
        -4001.0,
        1039.5
      ],
      [
        -1353.0,
        -4006.571533203125,
        1034.5
      ],
      [
        -1353.0,
        -4010.0,
        1034.5
      ],
      [
        -1353.0,
        -4006.571533203125,
        1034.5
      ],
      [
        -1353.0,
        -3930.0,
        1034.5
      ],
      [
        -1353.0,
        -3931.5,
        1014.5
      ],
      [
        -1349.5,
        -3940.0,
        1007.5408325195312
      ],
      [
        -1349.5,
        -3931.5,
        1007.5408325195312
      ],
      [
        -1353.0,
        -3931.5,
        1032.5
      ],
      [
        -1353.0,
        -3931.5,
        1032.5
      ],
      [
        -1343.0352783203125,
        -4003.0,
        1034.5
      ],
      [
        -1343.0352783203125,
        -3986.0,
        1034.5
      ],
      [
        -1333.9647216796875,
        -3986.0,
        1034.5
      ],
      [
        -1333.9647216796875,
        -4003.0,
        1034.5
      ],
      [
        -1343.0352783203125,
        -3986.0,
        1034.5
      ],
      [
        -1333.9647216796875,
        -3986.0,
        1034.5
      ],
      [
        -1333.9647216796875,
        -4003.0,
        1034.5
      ],
      [
        -1343.0352783203125,
        -4003.0,
        1034.5
      ],
      [
        -1353.0,
        -3931.5,
        1014.5
      ],
      [
        -1353.0,
        -3931.5,
        1032.5
      ],
      [
        -1333.9647216796875,
        -4004.0,
        1034.5
      ],
      [
        -1333.9647216796875,
        -4004.0,
        1039.2369384765625
      ],
      [
        -1343.0352783203125,
        -4004.0,
        1034.5
      ],
      [
        -1343.0352783203125,
        -4004.0,
        1036.7630615234375
      ],
      [
        -1306.764892578125,
        -4010.0,
        1041.5
      ],
      [
        -1315.6353759765625,
        -4010.0,
        1046.5244140625
      ],
      [
        -1329.0,
        -3930.0,
        1061.0
      ],
      [
        -1335.0,
        -3930.0,
        1061.0
      ],
      [
        -1335.0,
        -3930.0,
        1070.0
      ],
      [
        -1335.0,
        -3930.0,
        1061.0
      ],
      [
        -1329.0,
        -3930.0,
        1061.0
      ],
      [
        -1329.0,
        -3930.0,
        1070.0
      ],
      [
        -1329.0,
        -3930.0,
        1070.0
      ],
      [
        -1335.0,
        -3930.0,
        1070.0
      ],
      [
        -1311.7691650390625,
        -3992.22265625,
        1061.0
      ],
      [
        -1322.0220947265625,
        -3995.31787109375,
        1061.0
      ],
      [
        -1353.0,
        -3942.0,
        1063.0
      ],
      [
        -1353.0,
        -3942.0,
        1067.0
      ],
      [
        -1353.0,
        -3942.0,
        1067.0
      ],
      [
        -1353.0,
        -3938.0,
        1067.0
      ],
      [
        -1353.0,
        -3938.0,
        1067.0
      ],
      [
        -1353.0,
        -3938.0,
        1063.0
      ],
      [
        -1353.0,
        -3938.0,
        1063.0
      ],
      [
        -1353.0,
        -3942.0,
        1063.0
      ],
      [
        -1353.0,
        -3980.0,
        1063.0
      ],
      [
        -1353.0,
        -3980.0,
        1067.0
      ],
      [
        -1353.0,
        -3980.0,
        1067.0
      ],
      [
        -1353.0,
        -3976.0,
        1067.0
      ],
      [
        -1353.0,
        -3976.0,
        1067.0
      ],
      [
        -1353.0,
        -3976.0,
        1063.0
      ],
      [
        -1353.0,
        -3976.0,
        1063.0
      ],
      [
        -1353.0,
        -3980.0,
        1063.0
      ],
      [
        -1335.0,
        -4010.0,
        1043.046142578125
      ],
      [
        -1329.0,
        -4010.0,
        1043.046142578125
      ],
      [
        -1329.0,
        -4010.0,
        1043.046142578125
      ],
      [
        -1329.0,
        -4010.0,
        1047.27001953125
      ],
      [
        -1335.0,
        -4010.0,
        1047.27001953125
      ],
      [
        -1335.0,
        -4010.0,
        1043.046142578125
      ],
      [
        -1315.6353759765625,
        -4010.0,
        1046.5244140625
      ],
      [
        -1318.4700927734375,
        -4010.0,
        1047.2701416015625
      ],
      [
        -1306.764892578125,
        -4010.0,
        1041.5
      ],
      [
        -1353.0,
        -3924.0,
        1020.5
      ],
      [
        -1353.0,
        -3930.0,
        1020.5
      ],
      [
        -1353.0,
        -3930.0,
        1022.0
      ],
      [
        -1353.0,
        -3924.0,
        1022.0
      ],
      [
        -1395.0,
        -3976.0,
        1067.0
      ],
      [
        -1395.0,
        -3976.0,
        1063.0
      ],
      [
        -1395.0,
        -3980.0,
        1063.0
      ],
      [
        -1395.0,
        -3980.0,
        1067.0
      ],
      [
        -1395.0,
        -3980.0,
        1067.0
      ],
      [
        -1395.0,
        -3976.0,
        1067.0
      ],
      [
        -1395.0,
        -3976.0,
        1063.0
      ],
      [
        -1395.0,
        -3980.0,
        1063.0
      ],
      [
        -1395.0,
        -3938.0,
        1063.0
      ],
      [
        -1395.0,
        -3942.0,
        1063.0
      ],
      [
        -1395.0,
        -3942.0,
        1063.0
      ],
      [
        -1395.0,
        -3942.0,
        1067.0
      ],
      [
        -1395.0,
        -3942.0,
        1067.0
      ],
      [
        -1395.0,
        -3938.0,
        1067.0
      ],
      [
        -1395.0,
        -3938.0,
        1067.0
      ],
      [
        -1395.0,
        -3938.0,
        1063.0
      ],
      [
        -1365.0,
        -3930.800048828125,
        1032.5
      ],
      [
        -1365.0,
        -3930.0,
        1032.5
      ],
      [
        -1365.0,
        -3950.0,
        1032.5
      ],
      [
        -1365.0,
        -3930.800048828125,
        1032.5
      ],
      [
        -1353.0,
        -3960.0,
        1032.5
      ],
      [
        -1353.3199462890625,
        -3959.7333984375,
        1032.5
      ],
      [
        -1353.3199462890625,
        -3959.7333984375,
        1032.5
      ],
      [
        -1365.0,
        -3950.0,
        1032.5
      ],
      [
        -1363.5,
        -3951.25,
        1022.0
      ],
      [
        -1363.5,
        -3951.25,
        1017.0
      ],
      [
        -1395.0,
        -3870.000732421875,
        1047.2708740234375
      ],
      [
        -1401.0,
        -3863.82958984375,
        1041.5
      ],
      [
        -1401.0,
        -3870.000732421875,
        1047.2708740234375
      ],
      [
        -1401.0,
        -4016.17041015625,
        1041.5
      ],
      [
        -1395.0,
        -4010.019287109375,
        1047.252197265625
      ],
      [
        -1401.0,
        -4010.019287109375,
        1047.252197265625
      ],
      [
        -1395.0,
        -3995.31787109375,
        1061.0
      ],
      [
        -1395.0,
        -3985.693603515625,
        1070.0
      ],
      [
        -1401.0,
        -3985.693603515625,
        1070.0
      ],
      [
        -1401.0,
        -3995.31787109375,
        1061.0
      ],
      [
        -1395.0,
        -3894.306396484375,
        1070.0
      ],
      [
        -1395.0,
        -3884.68212890625,
        1061.0
      ],
      [
        -1401.0,
        -3884.68212890625,
        1061.0
      ],
      [
        -1401.0,
        -3894.306396484375,
        1070.0
      ],
      [
        -1401.0,
        -3942.0,
        1063.0
      ],
      [
        -1401.0,
        -3942.0,
        1067.0
      ],
      [
        -1401.0,
        -3904.0,
        1063.0
      ],
      [
        -1401.0,
        -3904.0,
        1067.0
      ],
      [
        -1401.0,
        -3900.0,
        1067.0
      ],
      [
        -1401.0,
        -3900.0,
        1063.0
      ],
      [
        -1401.0,
        -3904.0,
        1067.0
      ],
      [
        -1401.0,
        -3900.0,
        1067.0
      ],
      [
        -1401.0,
        -3900.0,
        1063.0
      ],
      [
        -1401.0,
        -3904.0,
        1063.0
      ],
      [
        -1401.0,
        -3942.0,
        1067.0
      ],
      [
        -1401.0,
        -3938.0,
        1067.0
      ],
      [
        -1401.0,
        -3938.0,
        1067.0
      ],
      [
        -1401.0,
        -3938.0,
        1063.0
      ],
      [
        -1401.0,
        -3938.0,
        1063.0
      ],
      [
        -1401.0,
        -3942.0,
        1063.0
      ],
      [
        -1401.0,
        -3980.0,
        1063.0
      ],
      [
        -1401.0,
        -3980.0,
        1067.0
      ],
      [
        -1401.0,
        -3980.0,
        1067.0
      ],
      [
        -1401.0,
        -3976.0,
        1067.0
      ],
      [
        -1401.0,
        -3976.0,
        1067.0
      ],
      [
        -1401.0,
        -3976.0,
        1063.0
      ],
      [
        -1401.0,
        -3976.0,
        1063.0
      ],
      [
        -1401.0,
        -3980.0,
        1063.0
      ],
      [
        -1401.0,
        -3975.0,
        1080.0
      ],
      [
        -1401.0,
        -3905.0,
        1080.0
      ],
      [
        -1467.0,
        -4016.17041015625,
        1041.5
      ],
      [
        -1467.0,
        -3975.0,
        1080.0
      ],
      [
        -1461.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1461.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1461.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1461.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1461.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1461.0,
        -4016.170166015625,
        1041.5001220703125
      ],
      [
        -1467.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1461.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1467.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1461.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1467.0,
        -3905.0,
        1080.0
      ],
      [
        -1467.0,
        -3863.82958984375,
        1041.5
      ],
      [
        -1461.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1461.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1461.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1461.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1461.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1461.0,
        -3863.829345703125,
        1041.5001220703125
      ],
      [
        -1461.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1467.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1461.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1467.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1461.0,
        -3870.000732421875,
        1047.2711181640625
      ],
      [
        -1461.0,
        -4010.019287109375,
        1047.251953125
      ],
      [
        -1467.0,
        -3900.0,
        1063.0
      ],
      [
        -1467.0,
        -3904.0,
        1063.0
      ],
      [
        -1467.0,
        -3938.0,
        1063.0
      ],
      [
        -1467.0,
        -3942.0,
        1063.0
      ],
      [
        -1467.0,
        -3976.0,
        1063.0
      ],
      [
        -1467.0,
        -3980.0,
        1063.0
      ],
      [
        -1467.0,
        -3904.0,
        1067.0
      ],
      [
        -1467.0,
        -3900.0,
        1067.0
      ],
      [
        -1467.0,
        -3942.0,
        1067.0
      ],
      [
        -1467.0,
        -3938.0,
        1067.0
      ],
      [
        -1467.0,
        -3980.0,
        1067.0
      ],
      [
        -1467.0,
        -3976.0,
        1067.0
      ],
      [
        -1467.0,
        -3942.0,
        1063.0
      ],
      [
        -1467.0,
        -3942.0,
        1067.0
      ],
      [
        -1467.0,
        -3904.0,
        1063.0
      ],
      [
        -1467.0,
        -3904.0,
        1067.0
      ],
      [
        -1467.0,
        -3900.0,
        1067.0
      ],
      [
        -1467.0,
        -3900.0,
        1063.0
      ],
      [
        -1461.0,
        -3904.0,
        1067.0
      ],
      [
        -1461.0,
        -3900.0,
        1067.0
      ],
      [
        -1461.0,
        -3900.0,
        1063.0
      ],
      [
        -1461.0,
        -3904.0,
        1063.0
      ],
      [
        -1461.0,
        -3891.09814453125,
        1067.0
      ],
      [
        -1461.0,
        -3886.820556640625,
        1063.0
      ],
      [
        -1467.0,
        -3938.0,
        1067.0
      ],
      [
        -1467.0,
        -3938.0,
        1063.0
      ],
      [
        -1461.0,
        -3940.0,
        1063.0
      ],
      [
        -1461.0,
        -3940.0,
        1067.0
      ],
      [
        -1461.0,
        -3938.0,
        1067.0
      ],
      [
        -1461.0,
        -3938.0,
        1063.0
      ],
      [
        -1461.0,
        -3940.0,
        1067.0
      ],
      [
        -1461.0,
        -3940.0,
        1063.0
      ],
      [
        -1461.0,
        -3942.0,
        1063.0
      ],
      [
        -1461.0,
        -3942.0,
        1067.0
      ],
      [
        -1467.0,
        -3980.0,
        1063.0
      ],
      [
        -1467.0,
        -3980.0,
        1067.0
      ],
      [
        -1467.0,
        -3976.0,
        1067.0
      ],
      [
        -1467.0,
        -3976.0,
        1063.0
      ],
      [
        -1461.0,
        -3976.0,
        1063.0
      ],
      [
        -1461.0,
        -3980.0,
        1063.0
      ],
      [
        -1461.0,
        -3980.0,
        1067.0
      ],
      [
        -1461.0,
        -3976.0,
        1067.0
      ],
      [
        -1461.0,
        -3993.178955078125,
        1063.0
      ],
      [
        -1461.0,
        -3988.9013671875,
        1067.0
      ],
      [
        -1527.0,
        -3868.8095703125,
        1041.5
      ],
      [
        -1533.0,
        -3868.8095703125,
        1041.5
      ],
      [
        -1527.0,
        -3868.8095703125,
        1041.5
      ],
      [
        -1527.0,
        -3863.829345703125,
        1041.5
      ],
      [
        -1533.0,
        -4011.188720703125,
        1041.5
      ],
      [
        -1527.0,
        -4011.188720703125,
        1041.5
      ],
      [
        -1527.0,
        -4011.188720703125,
        1041.5
      ],
      [
        -1527.0,
        -4016.170166015625,
        1041.5
      ],
      [
        -1533.0,
        -4016.17041015625,
        1041.5
      ],
      [
        -1533.0,
        -3975.0,
        1080.0
      ],
      [
        -1527.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1527.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1527.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1527.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1527.0,
        -4015.610595703125,
        1042.0234375
      ],
      [
        -1533.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1527.0,
        -3985.693359375,
        1070.0
      ],
      [
        -1533.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1527.0,
        -3995.317626953125,
        1061.0
      ],
      [
        -1533.0,
        -3905.0,
        1080.0
      ],
      [
        -1533.0,
        -3863.82958984375,
        1041.5
      ],
      [
        -1527.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1527.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1527.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1527.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1527.0,
        -3864.38916015625,
        1042.0234375
      ],
      [
        -1527.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1533.0,
        -3894.30615234375,
        1070.0
      ],
      [
        -1527.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1533.0,
        -3884.681884765625,
        1061.0
      ],
      [
        -1533.0,
        -3900.0,
        1063.0
      ],
      [
        -1533.0,
        -3904.0,
        1063.0
      ],
      [
        -1533.0,
        -3938.0,
        1063.0
      ],
      [
        -1533.0,
        -3942.0,
        1063.0
      ],
      [
        -1533.0,
        -3976.0,
        1063.0
      ],
      [
        -1533.0,
        -3980.0,
        1063.0
      ],
      [
        -1533.0,
        -3904.0,
        1067.0
      ],
      [
        -1533.0,
        -3900.0,
        1067.0
      ],
      [
        -1533.0,
        -3942.0,
        1067.0
      ],
      [
        -1533.0,
        -3938.0,
        1067.0
      ],
      [
        -1533.0,
        -3980.0,
        1067.0
      ],
      [
        -1533.0,
        -3976.0,
        1067.0
      ],
      [
        -1533.0,
        -3942.0,
        1063.0
      ],
      [
        -1533.0,
        -3942.0,
        1067.0
      ],
      [
        -1533.0,
        -3904.0,
        1063.0
      ],
      [
        -1533.0,
        -3904.0,
        1067.0
      ],
      [
        -1533.0,
        -3900.0,
        1067.0
      ],
      [
        -1533.0,
        -3900.0,
        1063.0
      ],
      [
        -1527.0,
        -3904.0,
        1067.0
      ],
      [
        -1527.0,
        -3900.0,
        1067.0
      ],
      [
        -1527.0,
        -3900.0,
        1063.0
      ],
      [
        -1527.0,
        -3904.0,
        1063.0
      ],
      [
        -1527.0,
        -3891.09814453125,
        1067.0
      ],
      [
        -1527.0,
        -3886.820556640625,
        1063.0
      ],
      [
        -1533.0,
        -3938.0,
        1067.0
      ],
      [
        -1533.0,
        -3938.0,
        1063.0
      ],
      [
        -1527.0,
        -3940.0,
        1063.0
      ],
      [
        -1527.0,
        -3940.0,
        1067.0
      ],
      [
        -1527.0,
        -3938.0,
        1067.0
      ],
      [
        -1527.0,
        -3938.0,
        1063.0
      ],
      [
        -1527.0,
        -3940.0,
        1067.0
      ],
      [
        -1527.0,
        -3940.0,
        1063.0
      ],
      [
        -1527.0,
        -3942.0,
        1063.0
      ],
      [
        -1527.0,
        -3942.0,
        1067.0
      ],
      [
        -1533.0,
        -3980.0,
        1063.0
      ],
      [
        -1533.0,
        -3980.0,
        1067.0
      ],
      [
        -1533.0,
        -3976.0,
        1067.0
      ],
      [
        -1533.0,
        -3976.0,
        1063.0
      ],
      [
        -1527.0,
        -3976.0,
        1063.0
      ],
      [
        -1527.0,
        -3980.0,
        1063.0
      ],
      [
        -1527.0,
        -3980.0,
        1067.0
      ],
      [
        -1527.0,
        -3976.0,
        1067.0
      ],
      [
        -1527.0,
        -3993.178955078125,
        1063.0
      ],
      [
        -1527.0,
        -3988.9013671875,
        1067.0
      ],
      [
        -1593.0,
        -4011.188720703125,
        1041.5
      ],
      [
        -1593.0,
        -4016.170166015625,
        1041.5
      ],
      [
        -1593.0,
        -3868.8095703125,
        1041.5
      ],
      [
        -1593.0,
        -3863.829345703125,
        1041.5
      ],
      [
        -1593.0,
        -4027.9130859375,
        981.0108642578125
      ],
      [
        -1593.0,
        -4013.841064453125,
        1041.5
      ],
      [
        -1593.0,
        -3866.158935546875,
        1041.5
      ],
      [
        -1593.0,
        -3852.1044921875,
        981.0108642578125
      ],
      [
        -1593.0,
        -4028.614990234375,
        977.5
      ],
      [
        -1593.0,
        -4027.9130859375,
        981.0108642578125
      ],
      [
        -1593.0,
        -3852.1044921875,
        981.0108642578125
      ],
      [
        -1593.0,
        -3851.40283203125,
        977.5
      ],
      [
        -1593.0,
        -3868.8095703125,
        1041.5
      ],
      [
        -1599.0,
        -3868.8095703125,
        1041.5
      ],
      [
        -1599.0,
        -3868.048828125,
        1041.5
      ],
      [
        -1599.0,
        -3855.583740234375,
        987.85107421875
      ],
      [
        -1599.0,
        -3855.583740234375,
        987.85107421875
      ],
      [
        -1599.0,
        -3853.514892578125,
        977.5
      ],
      [
        -1599.0,
        -4011.188720703125,
        1041.5
      ],
      [
        -1593.0,
        -4011.188720703125,
        1041.5
      ],
      [
        -1599.0,
        -4024.431884765625,
        987.85107421875
      ],
      [
        -1599.0,
        -4011.951171875,
        1041.5
      ],
      [
        -1599.0,
        -4026.5009765625,
        977.5
      ],
      [
        -1599.0,
        -4024.431884765625,
        987.85107421875
      ],
      [
        -1599.0,
        -3938.40869140625,
        1030.0
      ],
      [
        -1599.0,
        -3938.40869140625,
        1032.0
      ],
      [
        -1599.0,
        -3941.59130859375,
        1030.0
      ],
      [
        -1599.0,
        -3941.59130859375,
        1032.0
      ],
      [
        -1599.0,
        -3940.0,
        1030.0
      ],
      [
        -1599.0,
        -3938.40869140625,
        1030.0
      ],
      [
        -1599.0,
        -3940.0,
        1030.0
      ],
      [
        -1599.0,
        -3941.59130859375,
        1030.0
      ],
      [
        -1599.0,
        -3938.40869140625,
        1032.0
      ],
      [
        -1599.0,
        -3940.0,
        1032.0
      ],
      [
        -1599.0,
        -3940.0,
        1032.0
      ],
      [
        -1599.0,
        -3941.59130859375,
        1032.0
      ],
      [
        -1593.0,
        -3900.0,
        1072.9722900390625
      ],
      [
        -1593.0,
        -3907.8505859375,
        1080.0
      ],
      [
        -1573.8170166015625,
        -3900.0,
        1075.3243408203125
      ],
      [
        -1593.0,
        -3875.035888671875,
        1050.625
      ],
      [
        -1593.0,
        -3866.158935546875,
        1041.5
      ],
      [
        -1593.0,
        -3875.035888671875,
        1050.625
      ],
      [
        -1573.8170166015625,
        -3980.0,
        1075.3243408203125
      ],
      [
        -1593.0,
        -3972.1494140625,
        1080.0
      ],
      [
        -1593.0,
        -3980.0,
        1072.9722900390625
      ],
      [
        -1593.0,
        -4004.964111328125,
        1050.625
      ],
      [
        -1593.0,
        -4004.964111328125,
        1050.625
      ],
      [
        -1593.0,
        -4013.841064453125,
        1041.5
      ],
      [
        -1599.0,
        -3982.49853515625,
        1070.0
      ],
      [
        -1599.0,
        -3992.55224609375,
        1061.0
      ],
      [
        -1593.0,
        -3993.374267578125,
        1061.0
      ],
      [
        -1593.0,
        -3983.3203125,
        1070.0
      ],
      [
        -1599.0,
        -3887.44775390625,
        1061.0
      ],
      [
        -1599.0,
        -3897.50146484375,
        1070.0
      ],
      [
        -1593.0,
        -3896.6796875,
        1070.0
      ],
      [
        -1593.0,
        -3886.625732421875,
        1061.0
      ],
      [
        -1599.0,
        -3971.32763671875,
        1080.0
      ],
      [
        -1599.0,
        -3908.67236328125,
        1080.0
      ],
      [
        -1599.0,
        -3868.048828125,
        1041.5
      ],
      [
        -1599.0,
        -3884.12841796875,
        1058.0286865234375
      ],
      [
        -1599.0,
        -3884.12841796875,
        1058.0286865234375
      ],
      [
        -1599.0,
        -3995.87158203125,
        1058.0286865234375
      ],
      [
        -1599.0,
        -4011.951171875,
        1041.5
      ],
      [
        -1599.0,
        -3995.87158203125,
        1058.0286865234375
      ],
      [
        -1645.64599609375,
        -3945.0,
        1045.0
      ],
      [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      [
        -1645.7049560546875,
        -3944.5,
        1044.5
      ],
      [
        -1646.7669677734375,
        -3944.5,
        1035.5
      ],
      [
        -1646.825927734375,
        -3945.0,
        1035.0
      ],
      [
        -1645.64599609375,
        -3945.0,
        1045.0
      ],
      [
        -1649.5,
        -3944.5,
        1035.0
      ],
      [
        -1646.825927734375,
        -3945.0,
        1035.0
      ],
      [
        -1646.825927734375,
        -3944.5,
        1035.0
      ],
      [
        -1646.7669677734375,
        -3944.5,
        1035.5
      ],
      [
        -1646.7669677734375,
        -3935.5,
        1035.5
      ],
      [
        -1646.825927734375,
        -3935.0,
        1035.0
      ],
      [
        -1649.5,
        -3935.0,
        1035.5
      ],
      [
        -1646.825927734375,
        -3935.0,
        1035.0
      ],
      [
        -1646.7669677734375,
        -3935.0,
        1035.5
      ],
      [
        -1646.7669677734375,
        -3935.5,
        1035.5
      ],
      [
        -1645.7049560546875,
        -3935.5,
        1044.5
      ],
      [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      [
        -1645.7049560546875,
        -3935.5,
        1044.5
      ],
      [
        -1645.7049560546875,
        -3944.5,
        1044.5
      ],
      [
        -1605.0,
        -3978.0,
        1080.0
      ],
      [
        -1605.0,
        -3900.0,
        1080.0
      ],
      [
        -1628.2030029296875,
        -3900.10888671875,
        1065.0
      ],
      [
        -1628.2030029296875,
        -3921.34912109375,
        1065.0
      ],
      [
        -1628.2030029296875,
        -3979.89111328125,
        1065.0
      ],
      [
        -1628.2030029296875,
        -3958.65087890625,
        1065.0
      ],
      [
        -1628.2030029296875,
        -3921.34912109375,
        1065.0
      ],
      [
        -1628.2030029296875,
        -3958.65087890625,
        1065.0
      ],
      [
        -1628.2027587890625,
        -3978.0,
        1065.0
      ],
      [
        -1640.0,
        -3978.0,
        1080.0
      ],
      [
        -1616.805419921875,
        -3978.0,
        1080.0
      ],
      [
        -1640.0,
        -3900.0,
        1080.0
      ],
      [
        -1628.2027587890625,
        -3900.0,
        1065.0
      ],
      [
        -1616.805419921875,
        -3900.0,
        1080.0
      ],
      [
        -1605.0,
        -3986.779296875,
        1065.4324951171875
      ],
      [
        -1628.2030029296875,
        -3979.89111328125,
        1065.0
      ],
      [
        -1605.0,
        -3987.199951171875,
        1065.0
      ],
      [
        -1626.2440185546875,
        -3978.0,
        1067.577880859375
      ],
      [
        -1605.0,
        -3978.0,
        1080.0
      ],
      [
        -1605.0,
        -3978.0,
        1074.4569091796875
      ],
      [
        -1628.2030029296875,
        -3900.10888671875,
        1065.0
      ],
      [
        -1605.0,
        -3893.220703125,
        1065.4324951171875
      ],
      [
        -1605.0,
        -3892.800048828125,
        1065.0
      ],
      [
        -1627.857421875,
        -3900.0,
        1065.0
      ],
      [
        -1605.0,
        -3900.0,
        1072.4014892578125
      ],
      [
        -1605.0,
        -3900.0,
        1080.0
      ],
      [
        -1605.0,
        -3970.505859375,
        1080.0
      ],
      [
        -1605.0,
        -3986.779296875,
        1065.4324951171875
      ],
      [
        -1610.7938232421875,
        -3978.0,
        1072.580810546875
      ],
      [
        -1605.0,
        -3978.0,
        1073.2911376953125
      ],
      [
        -1605.0,
        -3893.220703125,
        1065.4324951171875
      ],
      [
        -1605.0,
        -3909.494140625,
        1080.0
      ],
      [
        -1605.0,
        -3900.0,
        1071.5009765625
      ],
      [
        -1609.4757080078125,
        -3900.0,
        1070.9522705078125
      ],
      [
        -1604.6495361328125,
        -3987.310302734375,
        1065.0
      ],
      [
        -1599.0,
        -3988.083984375,
        1065.0
      ],
      [
        -1604.6495361328125,
        -3892.689697265625,
        1065.0
      ],
      [
        -1599.0,
        -3891.916015625,
        1065.0
      ],
      [
        -1604.6495361328125,
        -3987.310302734375,
        1065.0
      ],
      [
        -1604.6495361328125,
        -3892.689697265625,
        1065.0
      ],
      [
        -1635.0,
        -3940.0,
        1056.0546875
      ],
      [
        -1630.8995361328125,
        -3930.1005859375,
        1061.4512939453125
      ],
      [
        -1630.8995361328125,
        -3949.8994140625,
        1061.4512939453125
      ],
      [
        -1635.0,
        -3940.0,
        1056.0546875
      ],
      [
        -1630.8995361328125,
        -3930.1005859375,
        1061.4512939453125
      ],
      [
        -1628.203125,
        -3928.983642578125,
        1065.0
      ],
      [
        -1630.8995361328125,
        -3949.8994140625,
        1061.4512939453125
      ],
      [
        -1628.203125,
        -3951.016357421875,
        1065.0
      ],
      [
        -1643.399658203125,
        -3945.0,
        1045.0
      ],
      [
        -1643.399658203125,
        -3935.0,
        1045.0
      ],
      [
        -1646.0589599609375,
        -3945.0,
        1041.5001220703125
      ],
      [
        -1643.399658203125,
        -3945.0,
        1045.0
      ],
      [
        -1643.779541015625,
        -3935.5,
        1044.5
      ],
      [
        -1643.779541015625,
        -3944.5,
        1044.5
      ],
      [
        -1643.399658203125,
        -3935.0,
        1045.0
      ],
      [
        -1645.7049560546875,
        -3935.0,
        1044.5
      ],
      [
        -1643.779541015625,
        -3935.0,
        1044.5
      ],
      [
        -1646.0589599609375,
        -3935.5,
        1041.5001220703125
      ],
      [
        -1643.779541015625,
        -3935.5,
        1044.5
      ],
      [
        -1646.0589599609375,
        -3935.0,
        1041.5001220703125
      ],
      [
        -1643.779541015625,
        -3944.5,
        1044.5
      ],
      [
        -1646.0589599609375,
        -3944.5,
        1041.5001220703125
      ],
      [
        -1637.8992919921875,
        -3946.999755859375,
        1030.0
      ],
      [
        -1637.8992919921875,
        -3946.999755859375,
        1032.0
      ],
      [
        -1639.3294677734375,
        -3950.45263671875,
        1030.0
      ],
      [
        -1631.4520263671875,
        -3958.32958984375,
        1030.0
      ],
      [
        -1639.3294677734375,
        -3950.45263671875,
        1032.0
      ],
      [
        -1631.4520263671875,
        -3958.32958984375,
        1032.0
      ],
      [
        -1631.4520263671875,
        -3958.32958984375,
        1030.0
      ],
      [
        -1631.4520263671875,
        -3958.32958984375,
        1032.0
      ],
      [
        -1639.3294677734375,
        -3950.45263671875,
        1030.0
      ],
      [
        -1639.3294677734375,
        -3950.45263671875,
        1032.0
      ],
      [
        -1641.35205078125,
        -3934.43017578125,
        1032.0
      ],
      [
        -1641.35205078125,
        -3934.43017578125,
        1030.0
      ],
      [
        -1641.35205078125,
        -3934.43017578125,
        1030.0
      ],
      [
        -1641.35205078125,
        -3934.43017578125,
        1032.0
      ],
      [
        -1642.7271728515625,
        -3935.0,
        1035.0
      ],
      [
        -1646.825927734375,
        -3936.69775390625,
        1035.0
      ],
      [
        -1642.727294921875,
        -3935.0,
        1045.0
      ],
      [
        -1642.7271728515625,
        -3935.0,
        1035.0
      ],
      [
        -1643.399658203125,
        -3935.278564453125,
        1045.0
      ],
      [
        -1642.727294921875,
        -3935.0,
        1045.0
      ],
      [
        -1646.7669677734375,
        -3936.673095703125,
        1035.5
      ],
      [
        -1643.93505859375,
        -3935.5,
        1035.5
      ],
      [
        -1643.93505859375,
        -3935.5,
        1035.5
      ],
      [
        -1643.9351806640625,
        -3935.5,
        1044.295166015625
      ],
      [
        -1631.452392578125,
        -3921.67041015625,
        1032.0
      ],
      [
        -1631.452392578125,
        -3921.67041015625,
        1030.0
      ],
      [
        -1631.452392578125,
        -3921.67041015625,
        1030.0
      ],
      [
        -1631.452392578125,
        -3921.67041015625,
        1032.0
      ],
      [
        -1615.429931640625,
        -3960.351806640625,
        1030.0
      ],
      [
        -1615.429931640625,
        -3960.351806640625,
        1032.0
      ],
      [
        -1615.429931640625,
        -3960.351806640625,
        1030.0
      ],
      [
        -1615.429931640625,
        -3960.351806640625,
        1032.0
      ],
      [
        -1602.67041015625,
        -3950.452392578125,
        1032.0
      ],
      [
        -1602.67041015625,
        -3950.452392578125,
        1030.0
      ],
      [
        -1602.67041015625,
        -3950.452392578125,
        1030.0
      ],
      [
        -1602.67041015625,
        -3950.452392578125,
        1032.0
      ],
      [
        -1600.64794921875,
        -3934.430419921875,
        1030.0
      ],
      [
        -1600.64794921875,
        -3934.430419921875,
        1032.0
      ],
      [
        -1600.64794921875,
        -3934.430419921875,
        1030.0
      ],
      [
        -1600.64794921875,
        -3934.430419921875,
        1032.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -812.5,
      "bbox_min": [
        -1708.0,
        -4033.199951171875,
        670.0
      ],
      "bbox_max": [
        -1263.0,
        -3830.0,
        1086.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.5,
      "bbox_min": [
        -1548.3494873046875,
        -3941.697265625,
        670.0
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3900.0,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3923.5,
      "bbox_min": [
        -1539.0,
        -3931.522216796875,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3909.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3915.0,
      "bbox_min": [
        -1539.0,
        -3923.5,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3909.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1523.5,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        670.0
      ],
      "bbox_max": [
        -1523.5,
        -3915.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1532.699951171875,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        670.0
      ],
      "bbox_max": [
        -1532.699951171875,
        -3915.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1539.0,
        -3913.0,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3909.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1514.5,
        -3913.0,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3913.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1539.0,
        -3913.0,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3909.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1535.0,
        -3913.0,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3909.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3925.669921875,
      "bbox_min": [
        -1535.0,
        -3931.522216796875,
        670.0
      ],
      "bbox_max": [
        -1527.043212890625,
        -3925.669921875,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 635.6712646484375,
      "bbox_min": [
        -1535.0,
        -3931.522216796875,
        670.0
      ],
      "bbox_max": [
        -1527.043212890625,
        -3925.669921875,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 3285.70166015625,
      "bbox_min": [
        -1527.5,
        -3926.4609375,
        670.0
      ],
      "bbox_max": [
        -1527.043212890625,
        -3925.669921875,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 771.5,
      "bbox_min": [
        -1546.5,
        -3937.0,
        771.5
      ],
      "bbox_max": [
        -1545.7747802734375,
        -3912.0,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.0,
      "bbox_min": [
        -1546.5,
        -3937.0,
        771.5
      ],
      "bbox_max": [
        -1545.7747802734375,
        -3912.0,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1546.5,
        -3912.0,
        771.5
      ],
      "bbox_max": [
        -1545.7747802734375,
        -3912.0,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -1547.5,
        -3920.0,
        794.0
      ],
      "bbox_max": [
        -1547.187744140625,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1547.5,
        -3920.0,
        794.0
      ],
      "bbox_max": [
        -1547.187744140625,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3920.0,
      "bbox_min": [
        -1547.5,
        -3920.0,
        794.0
      ],
      "bbox_max": [
        -1547.187744140625,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1547.5,
        -3912.0,
        794.0
      ],
      "bbox_max": [
        -1547.187744140625,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9981783628463745,
        0.06033017858862877
      ],
      "plane_d": -3944.4365234375,
      "bbox_min": [
        -1548.3494873046875,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3900.0,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 728.0,
      "bbox_min": [
        -1539.0,
        -3911.10986328125,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3900.0,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -729.04541015625,
      "bbox_min": [
        -1536.0,
        -3907.63427734375,
        728.0
      ],
      "bbox_max": [
        -1513.5,
        -3900.0,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1513.5,
      "bbox_min": [
        -1536.0,
        -3907.63427734375,
        728.0
      ],
      "bbox_max": [
        -1513.5,
        -3905.0,
        729.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1536.0,
      "bbox_min": [
        -1536.0,
        -3907.63427734375,
        728.0
      ],
      "bbox_max": [
        -1536.0,
        -3905.0,
        729.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 788.0,
      "bbox_min": [
        -1525.0,
        -3904.008056640625,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3900.0,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.04541015625,
      "bbox_min": [
        -1525.0,
        -3904.008056640625,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3900.0,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        -1525.0,
        -3904.008056640625,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3900.0,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1513.5,
      "bbox_min": [
        -1513.5,
        -3904.008056640625,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3900.0,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        -1539.0,
        -3911.10986328125,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3907.5,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.04541015625,
      "bbox_min": [
        -1536.0,
        -3909.32666015625,
        700.0
      ],
      "bbox_max": [
        -1513.5,
        -3907.5,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1536.0,
      "bbox_min": [
        -1536.0,
        -3909.32666015625,
        700.0
      ],
      "bbox_max": [
        -1536.0,
        -3907.5,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1539.0,
        -3911.10986328125,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3909.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3910.0,
      "bbox_min": [
        -1513.5,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.5,
      "bbox_min": [
        -1513.5,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1511.5,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1539.0,
        -3911.10986328125,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3909.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3910.0,
      "bbox_min": [
        -1538.0,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1538.0,
      "bbox_min": [
        -1538.0,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.0,
      "bbox_min": [
        -1536.0,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5659196376800537,
        -0.8212736248970032,
        0.07241922616958618
      ],
      "plane_d": -2392.38525390625,
      "bbox_min": [
        -1548.3494873046875,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3902.527099609375,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1538.0,
      "bbox_min": [
        -1541.5,
        -3913.175048828125,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3909.263671875,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3910.0,
      "bbox_min": [
        -1538.0,
        -3913.0,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3909.263671875,
        712.37744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1538.0,
        -3913.0,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.0,
        696.7483520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1538.0,
        -3913.0,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.0,
        696.7483520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1538.0,
        -3912.193359375,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.082275390625,
        689.6947021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3912.0,
      "bbox_min": [
        -1538.0,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1537.7191162109375,
        -3912.0,
        689.6947021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.082275390625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1536.0,
      "bbox_min": [
        -1536.0,
        -3909.713134765625,
        700.0
      ],
      "bbox_max": [
        -1535.439208984375,
        -3909.263671875,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        -1536.0,
        -3909.713134765625,
        700.0
      ],
      "bbox_max": [
        -1535.439208984375,
        -3909.263671875,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1541.5,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1538.0,
        -3910.082275390625,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1541.5,
        -3913.0,
        692.0
      ],
      "bbox_max": [
        -1538.2947998046875,
        -3912.0,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1540.0,
        -3913.0,
        692.0
      ],
      "bbox_max": [
        -1538.2947998046875,
        -3912.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1541.5,
        -3912.092041015625,
        716.0
      ],
      "bbox_max": [
        -1541.3662109375,
        -3912.0,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 716.0,
      "bbox_min": [
        -1541.5,
        -3912.092041015625,
        716.0
      ],
      "bbox_max": [
        -1541.3662109375,
        -3912.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1540.0,
        -3913.175048828125,
        692.0
      ],
      "bbox_max": [
        -1539.7459716796875,
        -3913.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3910.0,
      "bbox_min": [
        -1514.5604248046875,
        -3913.7138671875,
        670.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3909.263671875,
        716.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1514.5,
        -3913.7138671875,
        670.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3910.0,
        716.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1514.5,
        -3913.0,
        670.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        700.6519165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1514.5,
        -3913.0,
        670.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        700.6519165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1513.5,
        -3912.53759765625,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.082275390625,
        693.5952758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3912.0,
      "bbox_min": [
        -1512.280029296875,
        -3912.140625,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3912.0,
        693.5952758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1511.7041015625,
        -3912.140625,
        692.0
      ],
      "bbox_max": [
        -1511.5,
        -3912.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1511.5,
        -3913.7138671875,
        670.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3910.082275390625,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1511.5,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3910.082275390625,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1511.5,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1507.0,
        -3910.082275390625,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1511.5,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1510.5,
        -3910.082275390625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1509.6568603515625,
        -3912.9951171875,
        708.0
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1510.2530517578125,
        -3913.7138671875,
        692.0
      ],
      "bbox_max": [
        -1508.2191162109375,
        -3913.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1510.1253662109375,
        -3913.6689453125,
        693.0
      ],
      "bbox_max": [
        -1508.21923828125,
        -3913.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.04541015625,
      "bbox_min": [
        -1514.5604248046875,
        -3910.0,
        700.0
      ],
      "bbox_max": [
        -1513.5,
        -3909.263671875,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        -1514.5604248046875,
        -3910.0,
        700.0
      ],
      "bbox_max": [
        -1513.5,
        -3909.32666015625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3912.0,
      "bbox_min": [
        -1547.5,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3903.94482421875,
        806.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.0,
      "bbox_min": [
        -1538.0,
        -3912.0,
        670.5
      ],
      "bbox_max": [
        -1511.5,
        -3903.94482421875,
        806.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1538.0,
      "bbox_min": [
        -1538.0,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3910.0,
      "bbox_min": [
        -1538.0,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -806.0,
      "bbox_min": [
        -1538.0,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1537.7193603515625,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.5,
      "bbox_min": [
        -1536.0,
        -3912.0,
        670.5
      ],
      "bbox_max": [
        -1511.5,
        -3903.94482421875,
        806.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1513.5,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3910.0,
      "bbox_min": [
        -1513.5,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -806.0,
      "bbox_min": [
        -1513.5,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3910.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1513.5,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1512.2801513671875,
        -3911.159423828125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -729.04541015625,
      "bbox_min": [
        -1536.0,
        -3911.5,
        728.0
      ],
      "bbox_max": [
        -1513.5,
        -3903.94482421875,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3911.5,
      "bbox_min": [
        -1536.0,
        -3911.5,
        728.0
      ],
      "bbox_max": [
        -1513.5,
        -3911.5,
        729.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.04541015625,
      "bbox_min": [
        -1525.0,
        -3911.5,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3903.94482421875,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 788.0,
      "bbox_min": [
        -1525.0,
        -3911.5,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3903.94482421875,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3911.5,
      "bbox_min": [
        -1525.0,
        -3911.5,
        788.0
      ],
      "bbox_max": [
        -1513.5,
        -3903.94482421875,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        -1525.0,
        -3911.5,
        788.0
      ],
      "bbox_max": [
        -1525.0,
        -3903.94482421875,
        789.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        -1536.0,
        -3912.0,
        670.5
      ],
      "bbox_max": [
        -1513.5,
        -3909.263671875,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3911.5,
      "bbox_min": [
        -1536.0,
        -3911.5,
        700.0
      ],
      "bbox_max": [
        -1513.5,
        -3909.263671875,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.04541015625,
      "bbox_min": [
        -1536.0,
        -3911.5,
        701.04541015625
      ],
      "bbox_max": [
        -1513.5,
        -3909.263671875,
        701.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1536.0,
        -3912.0,
        670.5
      ],
      "bbox_max": [
        -1513.5,
        -3910.1259765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1514.5,
        -3912.0,
        670.5
      ],
      "bbox_max": [
        -1513.5,
        -3910.470458984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1514.5,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1513.5,
        -3910.470458984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 771.5,
      "bbox_min": [
        -1547.5,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -772.5,
      "bbox_min": [
        -1547.5,
        -3937.0,
        771.5
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1545.8375244140625,
        -3937.0,
        771.5
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.0,
      "bbox_min": [
        -1545.8375244140625,
        -3937.0,
        771.5
      ],
      "bbox_max": [
        -1541.781005859375,
        -3937.0,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1547.5,
        -3937.0,
        779.0
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -1547.2506103515625,
        -3920.0,
        779.0
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3920.0,
      "bbox_min": [
        -1547.2506103515625,
        -3920.0,
        794.0
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3920.0,
        794.0
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        779.0
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 779.0,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        779.0
      ],
      "bbox_max": [
        -1506.8209228515625,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        779.0
      ],
      "bbox_max": [
        -1513.0,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -802.5,
      "bbox_min": [
        -1547.5,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3929.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 801.5,
      "bbox_min": [
        -1547.5,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3929.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3929.0,
      "bbox_min": [
        -1547.5,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3929.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.0,
      "bbox_min": [
        -1547.5,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3929.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3933.2236328125,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3929.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 740.5,
      "bbox_min": [
        -1543.5,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1506.821044921875,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -741.5,
      "bbox_min": [
        -1543.5,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1506.821044921875,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1543.5,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        741.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.0,
      "bbox_min": [
        -1543.5,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1541.7808837890625,
        -3937.0,
        741.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -748.5,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        747.5
      ],
      "bbox_max": [
        -1506.821044921875,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 747.5,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        747.5
      ],
      "bbox_max": [
        -1506.821044921875,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        747.5
      ],
      "bbox_max": [
        -1513.0,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1541.5,
        -3936.79931640625,
        670.5
      ],
      "bbox_max": [
        -1508.1500244140625,
        -3912.0,
        717.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1541.5,
        -3936.79931640625,
        692.0
      ],
      "bbox_max": [
        -1508.1500244140625,
        -3912.0,
        717.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        692.0
      ],
      "bbox_max": [
        -1513.0,
        -3912.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        -1541.5,
        -3936.79931640625,
        708.0
      ],
      "bbox_max": [
        -1508.1500244140625,
        -3912.0,
        717.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1541.5,
        -3936.79931640625,
        708.0
      ],
      "bbox_max": [
        -1508.212646484375,
        -3912.0,
        709.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3925.0,
      "bbox_min": [
        -1541.5,
        -3925.0,
        708.0
      ],
      "bbox_max": [
        -1536.5,
        -3925.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3916.418701171875,
        708.0
      ],
      "bbox_max": [
        -1513.0,
        -3912.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -717.0,
      "bbox_min": [
        -1541.5,
        -3917.5,
        716.0
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 716.0,
      "bbox_min": [
        -1541.5,
        -3917.5,
        716.0
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1541.5,
        -3917.5,
        716.0
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3917.5,
      "bbox_min": [
        -1541.5,
        -3917.5,
        716.0
      ],
      "bbox_max": [
        -1536.5,
        -3917.5,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1539.0,
        -3913.0,
        670.5
      ],
      "bbox_max": [
        -1510.8287353515625,
        -3912.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3912.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -3294.36181640625,
      "bbox_min": [
        -1535.0,
        -3931.522216796875,
        670.5
      ],
      "bbox_max": [
        -1527.043212890625,
        -3925.669921875,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 3285.70166015625,
      "bbox_min": [
        -1535.0,
        -3931.522216796875,
        670.5
      ],
      "bbox_max": [
        -1527.043212890625,
        -3925.669921875,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -685.0,
      "bbox_min": [
        -1535.0,
        -3931.522216796875,
        685.0
      ],
      "bbox_max": [
        -1527.043212890625,
        -3925.669921875,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3923.5,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        670.5
      ],
      "bbox_max": [
        -1523.5,
        -3915.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3915.0,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        670.5
      ],
      "bbox_max": [
        -1523.5,
        -3915.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1523.5,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        670.5
      ],
      "bbox_max": [
        -1523.5,
        -3915.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1532.699951171875,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        670.5
      ],
      "bbox_max": [
        -1523.5,
        -3915.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        -1532.699951171875,
        -3923.5,
        680.0
      ],
      "bbox_max": [
        -1523.5,
        -3915.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.5,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.0
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3934.330078125,
      "bbox_min": [
        -1539.0,
        -3940.0,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3926.4609375,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -644.33154296875,
      "bbox_min": [
        -1534.12109375,
        -3934.330078125,
        670.0
      ],
      "bbox_max": [
        -1525.0,
        -3926.4609375,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -3294.36181640625,
      "bbox_min": [
        -1534.12109375,
        -3934.330078125,
        670.0
      ],
      "bbox_max": [
        -1532.5,
        -3931.522216796875,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1539.0,
      "bbox_min": [
        -1539.0,
        -3940.0,
        670.0
      ],
      "bbox_max": [
        -1539.0,
        -3936.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1514.5,
        -3940.0,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3936.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3936.0,
      "bbox_min": [
        -1514.5,
        -3936.0,
        670.0
      ],
      "bbox_max": [
        -1510.5,
        -3936.0,
        670.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9981783628463745,
        0.06033017858862877
      ],
      "plane_d": 3891.263671875,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 716.0,
      "bbox_min": [
        -1539.0,
        -3943.0,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3938.890380859375,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -717.04541015625,
      "bbox_min": [
        -1536.0,
        -3943.0,
        716.0
      ],
      "bbox_max": [
        -1513.5,
        -3941.64013671875,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1536.0,
      "bbox_min": [
        -1536.0,
        -3943.0,
        716.0
      ],
      "bbox_max": [
        -1513.5,
        -3941.64013671875,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1513.5,
      "bbox_min": [
        -1513.5,
        -3943.0,
        716.0
      ],
      "bbox_max": [
        -1513.5,
        -3941.64013671875,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1539.0,
        -3940.0,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3938.890380859375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1539.0,
      "bbox_min": [
        -1539.0,
        -3940.0,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3938.890380859375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3940.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3939.917724609375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1514.5,
        -3940.0,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3938.890380859375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1514.5,
        -3940.0,
        687.5
      ],
      "bbox_max": [
        -1510.5,
        -3939.917724609375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5659196972846985,
        0.821273684501648,
        0.07241950184106827
      ],
      "plane_d": 4054.61279296875,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1540.0,
        -3939.917724609375,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3936.0,
        701.0419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1539.0,
      "bbox_min": [
        -1540.0,
        -3939.917724609375,
        670.5
      ],
      "bbox_max": [
        -1535.0,
        -3936.0,
        701.0419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1538.0,
      "bbox_min": [
        -1539.0,
        -3939.0,
        670.5
      ],
      "bbox_max": [
        -1536.267822265625,
        -3936.0,
        701.0419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1538.0,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1536.267822265625,
        -3937.806396484375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1538.0,
        -3937.117431640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3939.917724609375,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3939.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1540.0,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1539.7454833984375,
        -3936.82470703125,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1540.0,
        -3937.0,
        693.0
      ],
      "bbox_max": [
        -1539.8736572265625,
        -3936.912841796875,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659196376800537,
        0.8212736248970032,
        0.07241922616958618
      ],
      "plane_d": 2328.557861328125,
      "bbox_min": [
        -1541.781005859375,
        -3947.472900390625,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1514.5,
        -3941.703369140625,
        670.5
      ],
      "bbox_max": [
        -1506.0,
        -3934.757568359375,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3939.0,
      "bbox_min": [
        -1514.5,
        -3941.703369140625,
        670.5
      ],
      "bbox_max": [
        -1506.0,
        -3934.757568359375,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1513.73193359375,
        -3939.0,
        670.5
      ],
      "bbox_max": [
        -1506.0,
        -3934.757568359375,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1513.73193359375,
        -3939.0,
        670.5
      ],
      "bbox_max": [
        -1511.5,
        -3936.0,
        689.313720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1510.254150390625,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1506.0,
        -3934.845947265625,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.0,
      "bbox_min": [
        -1510.254150390625,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1507.0,
        -3937.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1508.2066650390625,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1506.0,
        -3935.4794921875,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        -1508.2066650390625,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1506.0,
        -3935.567626953125,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.0,
      "bbox_min": [
        -1508.2066650390625,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1506.0,
        -3937.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3936.0,
      "bbox_min": [
        -1511.5,
        -3939.0,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3936.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1511.5,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1510.5,
        -3936.77294921875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1514.5,
        -3941.703369140625,
        687.5
      ],
      "bbox_max": [
        -1510.5,
        -3939.0,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 716.0,
      "bbox_min": [
        -1513.916748046875,
        -3941.703369140625,
        716.0
      ],
      "bbox_max": [
        -1513.5,
        -3941.35302734375,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -717.04541015625,
      "bbox_min": [
        -1513.87451171875,
        -3941.703369140625,
        717.04541015625
      ],
      "bbox_max": [
        -1513.5,
        -3941.4453125,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.0,
      "bbox_min": [
        -1541.781005859375,
        -3941.703369140625,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        806.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3937.0,
      "bbox_min": [
        -1541.781005859375,
        -3939.1845703125,
        670.5
      ],
      "bbox_max": [
        -1536.0,
        -3933.2236328125,
        806.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1538.0,
      "bbox_min": [
        -1539.0,
        -3939.1845703125,
        686.1680908203125
      ],
      "bbox_max": [
        -1536.0,
        -3937.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3939.0,
      "bbox_min": [
        -1538.0,
        -3939.1845703125,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3937.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -806.0,
      "bbox_min": [
        -1538.0,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3937.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1538.0,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.267822265625,
        -3939.1845703125,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3939.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1539.0,
      "bbox_min": [
        -1539.0,
        -3937.806396484375,
        686.1680908203125
      ],
      "bbox_max": [
        -1538.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3937.806396484375,
        687.5
      ],
      "bbox_max": [
        -1538.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 740.5,
      "bbox_min": [
        -1541.781005859375,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1536.0,
        -3933.2236328125,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -772.5,
      "bbox_min": [
        -1541.781005859375,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 771.5,
      "bbox_min": [
        -1541.781005859375,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3937.0,
        771.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        772.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -741.5,
      "bbox_min": [
        -1541.7808837890625,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        741.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3937.0,
        740.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        741.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -802.5,
      "bbox_min": [
        -1541.7808837890625,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 801.5,
      "bbox_min": [
        -1541.7808837890625,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3937.0,
        801.5
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1541.5,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1536.0,
        -3933.2236328125,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        -1541.5,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3936.0,
      "bbox_min": [
        -1540.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1536.0,
        -3933.2236328125,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1539.0,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1536.5,
        -3936.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1539.0,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1536.5,
        -3936.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1536.5,
        -3936.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1540.0,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1539.0,
        -3936.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1536.5,
        -3936.0,
        692.0
      ],
      "bbox_max": [
        -1536.5,
        -3933.2236328125,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3937.0,
      "bbox_min": [
        -1536.0,
        -3941.703369140625,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        806.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.5,
      "bbox_min": [
        -1536.0,
        -3941.703369140625,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3937.0,
        806.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1513.5,
        -3940.660888671875,
        687.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3937.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3939.0,
      "bbox_min": [
        -1513.5,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3937.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -806.0,
      "bbox_min": [
        -1513.5,
        -3939.0,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3937.0,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1513.5,
        -3938.84033203125,
        687.5
      ],
      "bbox_max": [
        -1511.5,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980340003967285,
        9.878495802695397e-06,
        0.06267527490854263
      ],
      "plane_d": -1549.5830078125,
      "bbox_min": [
        -1511.5,
        -3940.660888671875,
        687.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3937.0,
        789.4187622070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -717.04541015625,
      "bbox_min": [
        -1536.0,
        -3941.703369140625,
        716.0
      ],
      "bbox_max": [
        -1513.5,
        -3937.5,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3937.5,
      "bbox_min": [
        -1536.0,
        -3937.5,
        716.0
      ],
      "bbox_max": [
        -1513.5,
        -3937.5,
        717.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1536.0,
        -3939.87353515625,
        670.5
      ],
      "bbox_max": [
        -1513.5,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3939.87353515625,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1514.5,
        -3939.529296875,
        670.5
      ],
      "bbox_max": [
        -1513.5,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1514.5,
        -3939.529296875,
        687.5
      ],
      "bbox_max": [
        -1513.5,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980341792106628,
        3.236443080822937e-05,
        0.06267155706882477
      ],
      "plane_d": -1549.49267578125,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3909.339111328125,
        789.4187622070312
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -748.5,
      "bbox_min": [
        -1505.7322998046875,
        -3937.0,
        747.5
      ],
      "bbox_max": [
        -1505.0,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1505.7322998046875,
        -3912.0,
        747.5
      ],
      "bbox_max": [
        -1505.0,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        -1509.2181396484375,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3912.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1509.2181396484375,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3912.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1506.8209228515625,
        -3912.0,
        708.0
      ],
      "bbox_max": [
        -1506.0,
        -3912.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1509.2181396484375,
        -3936.331298828125,
        692.0
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3912.128173828125,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1509.2181396484375,
        -3936.2861328125,
        692.0
      ],
      "bbox_max": [
        -1507.0,
        -3912.128173828125,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3162277638912201,
        0.9486832618713379
      ],
      "plane_d": 583.2822265625,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.4165649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        0.9486833214759827
      ],
      "plane_d": -1898.94775390625,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.4165649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -3939.6181640625,
      "bbox_min": [
        -1509.05419921875,
        -3929.5,
        694.6040649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 3507.071533203125,
      "bbox_min": [
        -1509.05419921875,
        -3929.5,
        694.6040649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": 3948.630859375,
      "bbox_min": [
        -1508.8304443359375,
        -3929.5,
        698.1665649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": -3498.05908203125,
      "bbox_min": [
        -1508.8304443359375,
        -3928.3125,
        698.1665649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833214759827
      ],
      "plane_d": 1907.9600830078125,
      "bbox_min": [
        -1508.606689453125,
        -3928.3125,
        701.7290649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3921.1875,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        -0.9486833214759827
      ],
      "plane_d": -574.2697143554688,
      "bbox_min": [
        -1508.606689453125,
        -3924.75,
        701.7290649414062
      ],
      "bbox_max": [
        -1503.0999755859375,
        -3921.1875,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 779.0,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1504.0,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -1513.0,
        -3937.0,
        779.0
      ],
      "bbox_max": [
        -1504.0,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3937.0,
        779.0
      ],
      "bbox_max": [
        -1504.0,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1506.8209228515625,
        -3912.0,
        779.0
      ],
      "bbox_max": [
        -1504.0,
        -3912.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 747.5,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1505.6695556640625,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -748.5,
      "bbox_min": [
        -1513.0,
        -3937.0,
        747.5
      ],
      "bbox_max": [
        -1505.6695556640625,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3937.0,
        747.5
      ],
      "bbox_max": [
        -1505.6695556640625,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -1506.821044921875,
        -3912.0,
        747.5
      ],
      "bbox_max": [
        -1505.6695556640625,
        -3912.0,
        748.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1508.1500244140625,
        -3912.950439453125,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        -1513.0,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1508.1500244140625,
        -3912.950439453125,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3937.0,
        708.0
      ],
      "bbox_max": [
        -1513.0,
        -3916.418701171875,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1509.1546630859375,
        -3913.6689453125,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 692.0,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1509.2174072265625,
        -3913.7138671875,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1513.0,
      "bbox_min": [
        -1513.0,
        -3937.0,
        692.0
      ],
      "bbox_max": [
        -1513.0,
        -3916.418701171875,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1514.5,
      "bbox_min": [
        -1536.0,
        -3937.0,
        670.5
      ],
      "bbox_max": [
        -1510.5,
        -3936.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3937.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3936.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 3285.70166015625,
      "bbox_min": [
        -1534.12109375,
        -3934.330078125,
        670.5
      ],
      "bbox_max": [
        -1525.0,
        -3926.4609375,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -3294.36181640625,
      "bbox_min": [
        -1534.12109375,
        -3934.330078125,
        670.5
      ],
      "bbox_max": [
        -1525.0,
        -3926.4609375,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -685.0,
      "bbox_min": [
        -1534.12109375,
        -3934.330078125,
        685.0
      ],
      "bbox_max": [
        -1525.0,
        -3926.4609375,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659196972846985,
        -0.821273684501648,
        0.07241950184106827
      ],
      "plane_d": -4118.4404296875,
      "bbox_min": [
        -1503.0999755859375,
        -3909.339111328125,
        789.4187622070312
      ],
      "bbox_max": [
        -1501.6505126953125,
        -3907.303955078125,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980340003967285,
        0.0,
        0.06267467886209488
      ],
      "plane_d": -1549.6214599609375,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3908.302734375,
        812.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0019376554992049932,
        -0.16185809671878815,
        0.986812174320221
      ],
      "plane_d": -1314.5433349609375,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006553501822054386,
        -0.16748885810375214,
        0.9858521223068237
      ],
      "plane_d": -1329.19189453125,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11765758693218231,
        -0.9214613437652588,
        -0.37022385001182556
      ],
      "plane_d": -3174.705322265625,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2624799311161041,
        -0.9374282956123352,
        -0.22876274585723877
      ],
      "plane_d": -3892.44091796875,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26568931341171265,
        0.9488904476165771,
        -0.17034120857715607
      ],
      "plane_d": 3474.0751953125,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12868881225585938,
        0.9806114435195923,
        -0.147785022854805
      ],
      "plane_d": 4159.74951171875,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.046708062291145325,
        -0.975179135799408,
        -0.21643495559692383
      ],
      "plane_d": -3596.98583984375,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26056161522865295,
        -0.9370196461677551,
        -0.23259812593460083
      ],
      "plane_d": -3885.3603515625,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2638090252876282,
        0.9486978650093079,
        -0.1742907017469406
      ],
      "plane_d": 3478.8203125,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7437391877174377,
        0.29513460397720337,
        0.5997896790504456
      ],
      "plane_d": -331.9893798828125,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7437391877174377,
        -0.29513460397720337,
        0.5997896790504456
      ],
      "plane_d": -2651.3046875,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02009190246462822,
        0.16182571649551392,
        0.9866148233413696
      ],
      "plane_d": -16.044567108154297,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.015833238139748573,
        0.16747146844863892,
        0.9857497811317444
      ],
      "plane_d": 0.5133323669433594,
      "bbox_min": [
        -1475.689697265625,
        -3939.5546875,
        690.5
      ],
      "bbox_max": [
        -1461.25,
        -3928.46435546875,
        692.4765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24147915840148926,
        0.16253572702407837,
        0.9566975235939026
      ],
      "plane_d": 334.0849914550781,
      "bbox_min": [
        -1475.689697265625,
        -3939.5546875,
        690.625
      ],
      "bbox_max": [
        -1475.3125,
        -3928.46435546875,
        692.4765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020331501960754395,
        -0.16745783388614655,
        0.9856695532798767
      ],
      "plane_d": -1308.616943359375,
      "bbox_min": [
        -1475.689697265625,
        -3928.65625,
        690.625
      ],
      "bbox_max": [
        -1475.3125,
        -3928.464599609375,
        690.665283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020331501960754395,
        -0.16745783388614655,
        0.9856695532798767
      ],
      "plane_d": -1308.616943359375,
      "bbox_min": [
        -1475.5933837890625,
        -3928.65625,
        690.625
      ],
      "bbox_max": [
        -1475.3125,
        -3928.46435546875,
        690.663330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020331501960754395,
        -0.16745783388614655,
        0.9856695532798767
      ],
      "plane_d": -1308.616943359375,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5672225952148438,
        0.36361002922058105,
        0.7389494180679321
      ],
      "plane_d": 96.1610107421875,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5672225952148438,
        -0.36361002922058105,
        0.7389494180679321
      ],
      "plane_d": -2761.2685546875,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18699008226394653,
        -0.15900349617004395,
        0.9694083333015442
      ],
      "plane_d": -1567.380126953125,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13308829069137573,
        -0.22181592881679535,
        0.9659633040428162
      ],
      "plane_d": -1733.043212890625,
      "bbox_min": [
        -1461.25,
        -3931.110107421875,
        690.5
      ],
      "bbox_max": [
        -1447.1875,
        -3920.5,
        693.9444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13308829069137573,
        0.22181592881679535,
        0.9659633636474609
      ],
      "plane_d": 10.09722900390625,
      "bbox_min": [
        -1461.25,
        -3931.110107421875,
        690.5
      ],
      "bbox_max": [
        -1447.1875,
        -3929.25,
        692.7578735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13308829069137573,
        0.22181592881679535,
        0.9659633636474609
      ],
      "plane_d": 10.09722900390625,
      "bbox_min": [
        -1461.25,
        -3938.0,
        690.5
      ],
      "bbox_max": [
        -1447.9625244140625,
        -3929.25,
        693.9444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30869561433792114,
        -0.7874839305877686,
        0.5334568619728088
      ],
      "plane_d": -3905.38623046875,
      "bbox_min": [
        -1461.25,
        -3917.4375,
        692.4375
      ],
      "bbox_max": [
        -1460.802734375,
        -3913.5,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19909550249576569,
        -0.7110553979873657,
        0.6743597984313965
      ],
      "plane_d": -3544.515380859375,
      "bbox_min": [
        -1461.25,
        -3913.71484375,
        698.1178588867188
      ],
      "bbox_max": [
        -1460.802734375,
        -3913.5,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19909550249576569,
        -0.7110553979873657,
        0.6743597984313965
      ],
      "plane_d": -3544.515380859375,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.665283203125
      ],
      "bbox_max": [
        -1442.5,
        -3913.625244140625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30869561433792114,
        -0.7874839305877686,
        0.5334568619728088
      ],
      "plane_d": -3905.38623046875,
      "bbox_min": [
        -1461.25,
        -3920.5,
        692.4375
      ],
      "bbox_max": [
        -1450.8333740234375,
        -3913.71484375,
        698.1178588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8938567638397217,
        -0.3571607172489166,
        -0.2710281312465668
      ],
      "plane_d": -2503.5166015625,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.665283203125
      ],
      "bbox_max": [
        -1442.5,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8935255408287048,
        -0.35457363724708557,
        -0.27548080682754517
      ],
      "plane_d": -2489.7646484375,
      "bbox_min": [
        -1448.5703125,
        -3929.25,
        698.25
      ],
      "bbox_max": [
        -1442.5,
        -3917.4375,
        704.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09087786078453064,
        0.833444356918335,
        0.5450796484947205
      ],
      "plane_d": 3040.01806640625,
      "bbox_min": [
        -1503.0999755859375,
        -3945.0,
        690.665283203125
      ],
      "bbox_max": [
        -1442.5,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.097518190741539,
        0.8239725828170776,
        0.5581750273704529
      ],
      "plane_d": 3003.32470703125,
      "bbox_min": [
        -1475.3125,
        -3945.0,
        692.4375
      ],
      "bbox_max": [
        -1460.900634765625,
        -3941.0625,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30869561433792114,
        0.7874838709831238,
        0.5334568023681641
      ],
      "plane_d": 2283.05615234375,
      "bbox_min": [
        -1461.25,
        -3945.0,
        692.4375
      ],
      "bbox_max": [
        -1460.900634765625,
        -3941.0625,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19909551739692688,
        0.7110554575920105,
        0.6743597984313965
      ],
      "plane_d": 2043.313720703125,
      "bbox_min": [
        -1461.25,
        -3945.0,
        698.1400146484375
      ],
      "bbox_max": [
        -1460.900634765625,
        -3944.821044921875,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19909551739692688,
        0.7110554575920105,
        0.6743597984313965
      ],
      "plane_d": 2043.313720703125,
      "bbox_min": [
        -1503.0999755859375,
        -3944.902099609375,
        690.665283203125
      ],
      "bbox_max": [
        -1442.5,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30869561433792114,
        0.7874838709831238,
        0.5334568023681641
      ],
      "plane_d": 2283.05615234375,
      "bbox_min": [
        -1461.25,
        -3944.821044921875,
        692.4375
      ],
      "bbox_max": [
        -1450.8333740234375,
        -3938.0,
        698.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8992502093315125,
        0.35931581258773804,
        -0.24948179721832275
      ],
      "plane_d": 288.873779296875,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1442.5,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8989719748497009,
        0.3567349314689636,
        -0.2541448473930359
      ],
      "plane_d": 282.3902587890625,
      "bbox_min": [
        -1448.5703125,
        -3941.0625,
        698.25
      ],
      "bbox_max": [
        -1442.5,
        -3929.25,
        704.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1687573939561844,
        -0.31558758020401,
        0.9337694644927979
      ],
      "plane_d": -1632.4189453125,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1444.1875,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17073573172092438,
        -0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": -1614.43212890625,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1444.1875,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1444.1875,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29177701473236084,
        -0.11658614128828049,
        -0.949354350566864
      ],
      "plane_d": -211.0938720703125,
      "bbox_min": [
        -1460.2806396484375,
        -3940.608154296875,
        704.0625
      ],
      "bbox_max": [
        -1444.1875,
        -3915.21240234375,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31587088108062744,
        0.12621335685253143,
        -0.9403700828552246
      ],
      "plane_d": 701.8499755859375,
      "bbox_min": [
        -1460.2806396484375,
        -3940.608154296875,
        704.0625
      ],
      "bbox_max": [
        -1444.1875,
        -3915.21240234375,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09887856245040894,
        -0.35558247566223145,
        -0.9293999075889587
      ],
      "plane_d": -882.2156982421875,
      "bbox_min": [
        -1460.2806396484375,
        -3940.608154296875,
        704.0625
      ],
      "bbox_max": [
        -1448.5703125,
        -3915.21240234375,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30636030435562134,
        0.13251300156116486,
        -0.9426472187042236
      ],
      "plane_d": 742.05322265625,
      "bbox_min": [
        -1454.3125,
        -3940.608154296875,
        704.0625
      ],
      "bbox_max": [
        -1448.5703125,
        -3930.5625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12733206152915955,
        0.45790573954582214,
        -0.8798345327377319
      ],
      "plane_d": 2239.34375,
      "bbox_min": [
        -1449.7095947265625,
        -3940.608154296875,
        704.0625
      ],
      "bbox_max": [
        -1448.5703125,
        -3939.865478515625,
        704.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9084702134132385,
        -0.36423513293266296,
        -0.2049747109413147
      ],
      "plane_d": -2607.8671875,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1449.2962646484375,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30636030435562134,
        0.13251300156116486,
        -0.9426472187042236
      ],
      "plane_d": 742.05322265625,
      "bbox_min": [
        -1454.3125,
        -3940.671875,
        704.0625
      ],
      "bbox_max": [
        -1449.2962646484375,
        -3930.5625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12733206152915955,
        0.45790573954582214,
        -0.8798345327377319
      ],
      "plane_d": 2239.34375,
      "bbox_min": [
        -1450.0426025390625,
        -3940.671875,
        704.0625
      ],
      "bbox_max": [
        -1449.2962646484375,
        -3939.70751953125,
        704.6392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9281693696975708,
        0.37213316559791565,
        -0.004303516820073128
      ],
      "plane_d": 115.715087890625,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1449.5257568359375,
        -3914.125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30636030435562134,
        0.13251300156116486,
        -0.9426472187042236
      ],
      "plane_d": 742.05322265625,
      "bbox_min": [
        -1459.66796875,
        -3943.4921875,
        704.0625
      ],
      "bbox_max": [
        -1449.5257568359375,
        -3930.5625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1456.8671875,
        -3936.46875,
        707.3125
      ],
      "bbox_max": [
        -1454.3125,
        -3930.5625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12733206152915955,
        0.45790573954582214,
        -0.8798345327377319
      ],
      "plane_d": 2239.34375,
      "bbox_min": [
        -1459.66796875,
        -3943.4921875,
        704.0625
      ],
      "bbox_max": [
        -1449.5257568359375,
        -3936.46875,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1466.0625,
        -3939.203125,
        707.3125
      ],
      "bbox_max": [
        -1457.032470703125,
        -3922.6875,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1464.53125,
        -3925.796875,
        707.3125
      ],
      "bbox_max": [
        -1457.032470703125,
        -3922.6875,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23827627301216125,
        0.9275754690170288,
        0.2877989411354065
      ],
      "plane_d": 3100.67138671875,
      "bbox_min": [
        -1459.89208984375,
        -3939.134765625,
        712.9061279296875
      ],
      "bbox_max": [
        -1457.671875,
        -3938.4111328125,
        714.4840087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11627884209156036,
        0.45265692472457886,
        -0.8840705752372742
      ],
      "plane_d": 2237.781005859375,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1456.8671875,
        -3914.125,
        712.9063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23827627301216125,
        0.9275754690170288,
        0.2877989411354065
      ],
      "plane_d": 3100.67138671875,
      "bbox_min": [
        -1464.53125,
        -3938.9814453125,
        707.3125
      ],
      "bbox_max": [
        -1456.8671875,
        -3936.46875,
        712.9063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09045987576246262,
        -0.3521473705768585,
        -0.9315627813339233
      ],
      "plane_d": -854.939453125,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1456.8671875,
        -3914.125,
        708.4617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1464.53125,
        -3924.82275390625,
        707.3125
      ],
      "bbox_max": [
        -1456.8671875,
        -3922.6875,
        708.4617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12733206152915955,
        0.45790573954582214,
        -0.8798345327377319
      ],
      "plane_d": 2239.34375,
      "bbox_min": [
        -1503.0999755859375,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1456.8671875,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24147915840148926,
        0.16253572702407837,
        0.9566975235939026
      ],
      "plane_d": 334.0849914550781,
      "bbox_min": [
        -1478.451416015625,
        -3940.314697265625,
        691.6055297851562
      ],
      "bbox_max": [
        -1475.3125,
        -3934.227294921875,
        693.6384887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7706506252288818,
        0.5916789770126343,
        0.2366715967655182
      ],
      "plane_d": 3304.0126953125,
      "bbox_min": [
        -1478.451416015625,
        -3940.314697265625,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3935.50830078125,
        693.6384887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7667779922485352,
        0.5372213125228882,
        0.3513472378253937
      ],
      "plane_d": 3004.350341796875,
      "bbox_min": [
        -1476.6348876953125,
        -3940.314697265625,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3938.09228515625,
        693.6384887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17073573172092438,
        0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": 831.3506469726562,
      "bbox_min": [
        -1503.0999755859375,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04210839793086052,
        0.2674064636230469,
        0.9626632928848267
      ],
      "plane_d": 446.2228088378906,
      "bbox_min": [
        -1503.0999755859375,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.022897079586982727,
        0.31667372584342957,
        0.948258101940155
      ],
      "plane_d": 621.0333862304688,
      "bbox_min": [
        -1494.5211181640625,
        -3941.830322265625,
        690.665283203125
      ],
      "bbox_max": [
        -1475.3125,
        -3924.420166015625,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24147915840148926,
        0.16253572702407837,
        0.9566975235939026
      ],
      "plane_d": 334.0849914550781,
      "bbox_min": [
        -1483.5,
        -3941.830322265625,
        690.665283203125
      ],
      "bbox_max": [
        -1475.3125,
        -3924.5,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23230266571044922,
        0.26032206416130066,
        0.9371594190597534
      ],
      "plane_d": 718.209228515625,
      "bbox_min": [
        -1483.5,
        -3929.0,
        690.665283203125
      ],
      "bbox_max": [
        -1475.588134765625,
        -3924.5,
        692.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7706506252288818,
        0.5916789770126343,
        0.2366715967655182
      ],
      "plane_d": 3304.0126953125,
      "bbox_min": [
        -1483.5,
        -3941.830322265625,
        692.5814208984375
      ],
      "bbox_max": [
        -1475.3125,
        -3929.0,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7667779922485352,
        0.5372213125228882,
        0.3513472378253937
      ],
      "plane_d": 3004.350341796875,
      "bbox_min": [
        -1479.0841064453125,
        -3941.830322265625,
        693.1264038085938
      ],
      "bbox_max": [
        -1475.3125,
        -3935.383544921875,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03725166991353035,
        -0.3168686032295227,
        0.9477375745773315
      ],
      "plane_d": -1843.6485595703125,
      "bbox_min": [
        -1494.5211181640625,
        -3924.75,
        691.5
      ],
      "bbox_max": [
        -1483.5,
        -3924.420166015625,
        691.9595336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03725166991353035,
        -0.3168686032295227,
        0.9477375745773315
      ],
      "plane_d": -1843.6485595703125,
      "bbox_min": [
        -1494.5126953125,
        -3924.5,
        691.5
      ],
      "bbox_max": [
        -1475.3125,
        -3917.410888671875,
        693.037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766676664352417,
        -0.8971255421638489,
        0.35885024070739746
      ],
      "plane_d": -3383.0771484375,
      "bbox_min": [
        -1483.5,
        -3920.0,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3917.410888671875,
        693.0069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3259982168674469,
        -0.7911874651908875,
        0.5174433588981628
      ],
      "plane_d": -2977.049072265625,
      "bbox_min": [
        -1476.255859375,
        -3917.84326171875,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3917.410888671875,
        693.0069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09023689478635788,
        0.9246887564659119,
        0.3698755204677582
      ],
      "plane_d": 3510.7373046875,
      "bbox_min": [
        -1503.0999755859375,
        -3943.1875,
        692.75
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8398571610450745,
        0.5427680015563965,
        0.006555740721523762
      ],
      "plane_d": 3374.7119140625,
      "bbox_min": [
        -1503.0999755859375,
        -3943.1875,
        692.75
      ],
      "bbox_max": [
        -1475.3125,
        -3928.3125,
        704.5570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055315032601356506,
        0.947230875492096,
        0.315743625164032
      ],
      "plane_d": 3584.84619140625,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        692.7757568359375
      ],
      "bbox_max": [
        -1484.41552734375,
        -3928.3125,
        698.5020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0677989199757576,
        0.9480533599853516,
        0.3108023405075073
      ],
      "plane_d": 3610.1728515625,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        692.7757568359375
      ],
      "bbox_max": [
        -1484.41552734375,
        -3928.3125,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05635448172688484,
        0.9484681487083435,
        0.31182095408439636
      ],
      "plane_d": 3593.99365234375,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        693.037109375
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3928.3125,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": 3862.86083984375,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        696.599609375
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3929.38818359375,
        698.5020751953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7706506252288818,
        0.5916789770126343,
        0.2366715967655182
      ],
      "plane_d": 3304.0126953125,
      "bbox_min": [
        -1484.480712890625,
        -3935.383544921875,
        692.75
      ],
      "bbox_max": [
        -1479.0841064453125,
        -3928.938232421875,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0677989199757576,
        0.9480533599853516,
        0.3108023405075073
      ],
      "plane_d": 3610.1728515625,
      "bbox_min": [
        -1484.480712890625,
        -3929.04296875,
        692.75
      ],
      "bbox_max": [
        -1483.5,
        -3928.938232421875,
        693.0807495117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7066319584846497,
        0.15649612247943878,
        -0.6900581121444702
      ],
      "plane_d": 2146.375,
      "bbox_min": [
        -1481.412353515625,
        -3941.094970703125,
        701.5438232421875
      ],
      "bbox_max": [
        -1476.7149658203125,
        -3932.721435546875,
        704.5570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13298223912715912,
        -0.9202303290367126,
        0.3680921196937561
      ],
      "plane_d": -3665.01953125,
      "bbox_min": [
        -1503.0999755859375,
        -3934.246826171875,
        692.75
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3259982168674469,
        -0.7911874651908875,
        0.5174433588981628
      ],
      "plane_d": -2977.049072265625,
      "bbox_min": [
        -1503.0999755859375,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        701.2632446289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05531502515077591,
        -0.9472308158874512,
        0.3157435655593872
      ],
      "plane_d": -3850.4423828125,
      "bbox_min": [
        -1503.0999755859375,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        699.0739135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1107676699757576,
        -0.9453705549240112,
        0.3066026568412781
      ],
      "plane_d": -3753.927734375,
      "bbox_min": [
        -1503.0999755859375,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05635448172688484,
        -0.9484681487083435,
        0.31182095408439636
      ],
      "plane_d": -3851.007080078125,
      "bbox_min": [
        -1503.0999755859375,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766676664352417,
        -0.8971255421638489,
        0.35885024070739746
      ],
      "plane_d": -3383.0771484375,
      "bbox_min": [
        -1483.5,
        -3920.0,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        -0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": -3582.535888671875,
      "bbox_min": [
        -1503.0999755859375,
        -3920.302490234375,
        696.599609375
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3920.0,
        699.0739135742188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4923037588596344,
        -0.8081678748130798,
        -0.3232671618461609
      ],
      "plane_d": -2211.3173828125,
      "bbox_min": [
        -1483.5,
        -3918.5,
        696.5
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        701.2632446289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5230034589767456,
        -0.8185674548149109,
        -0.23751790821552277
      ],
      "plane_d": -2266.5869140625,
      "bbox_min": [
        -1479.0975341796875,
        -3916.841064453125,
        698.03125
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        701.2632446289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": 3862.86083984375,
      "bbox_min": [
        -1503.0999755859375,
        -3934.246826171875,
        696.5
      ],
      "bbox_max": [
        -1476.01806640625,
        -3915.513671875,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7016903758049011,
        0.19069144129753113,
        -0.6864892244338989
      ],
      "plane_d": 2270.8984375,
      "bbox_min": [
        -1483.5,
        -3934.246826171875,
        700.25
      ],
      "bbox_max": [
        -1478.1319580078125,
        -3925.97705078125,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7066319584846497,
        0.15649612247943878,
        -0.6900581121444702
      ],
      "plane_d": 2146.375,
      "bbox_min": [
        -1483.5,
        -3934.246826171875,
        700.25
      ],
      "bbox_max": [
        -1478.1319580078125,
        -3928.84375,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5069491863250732,
        -0.12048893421888351,
        -0.8535131812095642
      ],
      "plane_d": 877.9398193359375,
      "bbox_min": [
        -1481.402099609375,
        -3928.84375,
        703.0487670898438
      ],
      "bbox_max": [
        -1478.642333984375,
        -3925.97705078125,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06449536979198456,
        0.9265435934066772,
        -0.37061744928359985
      ],
      "plane_d": 3995.593505859375,
      "bbox_min": [
        -1494.1556396484375,
        -3931.821044921875,
        696.5
      ],
      "bbox_max": [
        -1482.2584228515625,
        -3928.3125,
        700.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08551756292581558,
        0.9432168006896973,
        -0.32098114490509033
      ],
      "plane_d": 4057.742431640625,
      "bbox_min": [
        -1494.1556396484375,
        -3930.5,
        696.5
      ],
      "bbox_max": [
        -1483.5,
        -3928.3125,
        700.162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.053676117211580276,
        0.9473156332969666,
        -0.31577184796333313
      ],
      "plane_d": 3862.257568359375,
      "bbox_min": [
        -1503.0999755859375,
        -3929.398681640625,
        696.5
      ],
      "bbox_max": [
        -1476.01806640625,
        -3915.513671875,
        704.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5069491863250732,
        -0.12048893421888351,
        -0.8535131812095642
      ],
      "plane_d": 877.9398193359375,
      "bbox_min": [
        -1481.402099609375,
        -3926.644287109375,
        703.0487670898438
      ],
      "bbox_max": [
        -1478.6412353515625,
        -3925.9716796875,
        704.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15748168528079987,
        0.3159121870994568,
        -0.9356275796890259
      ],
      "plane_d": 1660.833740234375,
      "bbox_min": [
        -1503.0999755859375,
        -3928.3125,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3922.307861328125,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        0.31219446659088135,
        -0.9365835189819336
      ],
      "plane_d": 1644.32568359375,
      "bbox_min": [
        -1503.0999755859375,
        -3928.3125,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3924.5,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025872355327010155,
        0.26755428314208984,
        -0.9631953835487366
      ],
      "plane_d": 1764.0799560546875,
      "bbox_min": [
        -1493.8817138671875,
        -3928.3125,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3924.5,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15748168528079987,
        -0.3159121870994568,
        -0.9356275796890259
      ],
      "plane_d": -818.9189453125,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        701.349609375
      ],
      "bbox_max": [
        -1493.7904052734375,
        -3922.307861328125,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        -0.31219449639320374,
        -0.9365835785865784
      ],
      "plane_d": -806.2449951171875,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        701.7962036132812
      ],
      "bbox_max": [
        -1499.3504638671875,
        -3922.307861328125,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387420654296875,
        -0.267442911863327,
        -0.9627945423126221
      ],
      "plane_d": -316.7054748535156,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        696.54345703125
      ],
      "bbox_max": [
        -1483.5,
        -3919.154052734375,
        702.1025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.053676117211580276,
        -0.9473156332969666,
        -0.31577184796333313
      ],
      "plane_d": -3573.696533203125,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        699.5934448242188
      ],
      "bbox_max": [
        -1483.5,
        -3920.4755859375,
        702.1025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        -0.31219449639320374,
        -0.9365835785865784
      ],
      "plane_d": -806.2449951171875,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        700.162109375
      ],
      "bbox_max": [
        -1493.7904052734375,
        -3921.1875,
        702.1025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5230034589767456,
        -0.8185674548149109,
        -0.23751790821552277
      ],
      "plane_d": -2266.5869140625,
      "bbox_min": [
        -1488.1456298828125,
        -3927.73583984375,
        696.5
      ],
      "bbox_max": [
        -1476.01806640625,
        -3915.513671875,
        704.5936889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4923037588596344,
        -0.8081678748130798,
        -0.3232671618461609
      ],
      "plane_d": -2211.3173828125,
      "bbox_min": [
        -1488.1456298828125,
        -3920.0,
        696.5
      ],
      "bbox_max": [
        -1479.0975341796875,
        -3916.841064453125,
        700.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10869894176721573,
        -0.9229751825332642,
        -0.3691900670528412
      ],
      "plane_d": -3198.282470703125,
      "bbox_min": [
        -1488.1456298828125,
        -3920.0,
        696.5
      ],
      "bbox_max": [
        -1483.5,
        -3918.5,
        700.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12899142503738403,
        -0.9377398490905762,
        -0.32249829173088074
      ],
      "plane_d": -3258.5546875,
      "bbox_min": [
        -1488.1456298828125,
        -3919.33935546875,
        696.5
      ],
      "bbox_max": [
        -1483.5,
        -3918.5,
        697.6436767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5069491863250732,
        -0.12048893421888351,
        -0.8535131812095642
      ],
      "plane_d": 877.9398193359375,
      "bbox_min": [
        -1485.9952392578125,
        -3927.73583984375,
        700.5341186523438
      ],
      "bbox_max": [
        -1476.7149658203125,
        -3916.885009765625,
        704.5936889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025872355327010155,
        0.26755428314208984,
        -0.9631953835487366
      ],
      "plane_d": 1764.0799560546875,
      "bbox_min": [
        -1485.9952392578125,
        -3927.73583984375,
        700.5341186523438
      ],
      "bbox_max": [
        -1483.5,
        -3924.5,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025872355327010155,
        0.26755428314208984,
        -0.9631953835487366
      ],
      "plane_d": 1764.0799560546875,
      "bbox_min": [
        -1485.8846435546875,
        -3927.727783203125,
        700.5393676757812
      ],
      "bbox_max": [
        -1481.402099609375,
        -3924.5,
        703.0487670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7016903758049011,
        0.19069144129753113,
        -0.6864892244338989
      ],
      "plane_d": 2270.8984375,
      "bbox_min": [
        -1483.5,
        -3927.553466796875,
        700.65185546875
      ],
      "bbox_max": [
        -1481.402099609375,
        -3924.5,
        703.0487670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659196376800537,
        0.8212736248970032,
        0.07241922616958618
      ],
      "plane_d": 2328.557861328125,
      "bbox_min": [
        -1503.0999755859375,
        -3942.696044921875,
        789.4187622070312
      ],
      "bbox_max": [
        -1501.6505126953125,
        -3940.660888671875,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -977.5,
      "bbox_min": [
        -1708.0,
        -4033.199951171875,
        812.5
      ],
      "bbox_max": [
        -1263.0,
        -3830.0,
        1086.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.999853789806366,
        0.00017472774197813123,
        0.01709909364581108
      ],
      "plane_d": 1540.871826171875,
      "bbox_min": [
        -1555.45703125,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999011158943176,
        -0.004258743952959776,
        0.013403600081801414
      ],
      "plane_d": 1526.70458984375,
      "bbox_min": [
        -1555.45703125,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6178556680679321,
        0.7852272987365723,
        0.04089659824967384
      ],
      "plane_d": 4037.095458984375,
      "bbox_min": [
        -1555.4541015625,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6658845543861389,
        0.7455488443374634,
        0.02747277170419693
      ],
      "plane_d": 3965.502197265625,
      "bbox_min": [
        -1555.4541015625,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.782225489616394,
        -0.6227227449417114,
        0.018431877717375755
      ],
      "plane_d": -1221.1552734375,
      "bbox_min": [
        -1555.213623046875,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7796240448951721,
        -0.6259950399398804,
        0.017789822071790695
      ],
      "plane_d": -1237.33447265625,
      "bbox_min": [
        -1551.32177734375,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004700719844549894,
        -0.9998874664306641,
        0.014245511963963509
      ],
      "plane_d": -3894.679443359375,
      "bbox_min": [
        -1544.65576171875,
        -3973.0234375,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3875.318359375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.000275469443295151,
        -1.0,
        1.7972455452763825e-06
      ],
      "plane_d": -3888.109375,
      "bbox_min": [
        -1539.7081298828125,
        -3887.684814453125,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3887.683837890625,
        813.6593017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9988258481025696,
        0.04844515025615692
      ],
      "plane_d": 3926.4765625,
      "bbox_min": [
        -1541.75,
        -3970.769775390625,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3887.00439453125,
        818.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3316125273704529,
        0.10155961662530899,
        0.9379333257675171
      ],
      "plane_d": -877.82568359375,
      "bbox_min": [
        -1539.7081298828125,
        -3887.684814453125,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3887.00439453125,
        813.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.000275469443295151,
        -1.0,
        1.7972455452763825e-06
      ],
      "plane_d": -3888.109375,
      "bbox_min": [
        -1539.7081298828125,
        -3887.684814453125,
        812.5
      ],
      "bbox_max": [
        -1536.0,
        -3887.683837890625,
        813.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9995907545089722,
        0.0054229446686804295,
        0.028087837621569633
      ],
      "plane_d": -1447.8048095703125,
      "bbox_min": [
        -1464.0,
        -3978.554931640625,
        812.5
      ],
      "bbox_max": [
        -1444.762939453125,
        -3880.857666015625,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15322236716747284,
        0.2036793977022171,
        0.9669734239578247
      ],
      "plane_d": 198.18923950195312,
      "bbox_min": [
        -1464.0,
        -3978.554931640625,
        812.5
      ],
      "bbox_max": [
        -1444.762939453125,
        -3880.857666015625,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977974891662598,
        0.01664278469979763,
        0.06421087682247162
      ],
      "plane_d": -1442.605224609375,
      "bbox_min": [
        -1464.0,
        -3964.777099609375,
        812.5
      ],
      "bbox_max": [
        -1445.800048828125,
        -3881.46533203125,
        862.1455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15677239000797272,
        0.24685148894786835,
        0.9562880396842957
      ],
      "plane_d": -73.10897827148438,
      "bbox_min": [
        -1456.5343017578125,
        -3961.324462890625,
        839.8536376953125
      ],
      "bbox_max": [
        -1445.800048828125,
        -3884.4921875,
        860.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18331149220466614,
        0.28863954544067383,
        0.9397255778312683
      ],
      "plane_d": 64.98672485351562,
      "bbox_min": [
        -1456.5343017578125,
        -3895.464599609375,
        839.8536376953125
      ],
      "bbox_max": [
        -1445.800048828125,
        -3884.4921875,
        843.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1456.5343017578125,
        -3888.669189453125,
        839.8536376953125
      ],
      "bbox_max": [
        -1445.800048828125,
        -3884.4921875,
        843.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1456.499267578125,
        -3888.669189453125,
        840.3994140625
      ],
      "bbox_max": [
        -1445.800048828125,
        -3884.49658203125,
        844.016357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9952711462974548,
        0.0006573323043994606,
        0.09713354706764221
      ],
      "plane_d": -1528.957763671875,
      "bbox_min": [
        -1464.0,
        -3964.777099609375,
        812.5
      ],
      "bbox_max": [
        -1456.2669677734375,
        -3881.46533203125,
        862.1455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18331149220466614,
        0.28863954544067383,
        0.9397255778312683
      ],
      "plane_d": 64.98672485351562,
      "bbox_min": [
        -1456.8311767578125,
        -3895.464599609375,
        839.76025390625
      ],
      "bbox_max": [
        -1456.2669677734375,
        -3884.376708984375,
        844.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1456.8311767578125,
        -3884.526123046875,
        839.76025390625
      ],
      "bbox_max": [
        -1456.2669677734375,
        -3884.376708984375,
        844.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4281797707080841,
        0.9012303352355957,
        0.06667863577604294
      ],
      "plane_d": 2889.06103515625,
      "bbox_min": [
        -1464.0,
        -3964.777099609375,
        812.5
      ],
      "bbox_max": [
        -1456.4150390625,
        -3881.46533203125,
        862.1455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3268859386444092,
        -0.9423353672027588,
        0.07176199555397034
      ],
      "plane_d": -4207.455078125,
      "bbox_min": [
        -1464.0,
        -3964.777099609375,
        812.5
      ],
      "bbox_max": [
        -1456.4150390625,
        -3881.46533203125,
        862.1455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18331149220466614,
        0.28863954544067383,
        0.9397255778312683
      ],
      "plane_d": 64.98672485351562,
      "bbox_min": [
        -1464.0,
        -3896.76416015625,
        812.5
      ],
      "bbox_max": [
        -1456.4150390625,
        -3881.46533203125,
        844.5969848632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3852156400680542,
        -0.9228231906890869,
        0.0025133017916232347
      ],
      "plane_d": -4160.28857421875,
      "bbox_min": [
        -1464.0,
        -3896.76416015625,
        812.5
      ],
      "bbox_max": [
        -1459.5,
        -3894.8740234375,
        816.8230590820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1464.0,
        -3884.467529296875,
        837.5050048828125
      ],
      "bbox_max": [
        -1456.4150390625,
        -3881.46533203125,
        844.5969848632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4066848158836365,
        0.9120557904243469,
        0.05255300551652908
      ],
      "plane_d": 2975.403076171875,
      "bbox_min": [
        -1464.0,
        -3964.777099609375,
        846.8538818359375
      ],
      "bbox_max": [
        -1456.5045166015625,
        -3961.324462890625,
        862.1455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1464.0,
        -3978.554931640625,
        843.23046875
      ],
      "bbox_max": [
        -1444.762939453125,
        -3880.857666015625,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3317689895629883,
        -0.9429503679275513,
        0.027818001806735992
      ],
      "plane_d": -4169.95068359375,
      "bbox_min": [
        -1456.4268798828125,
        -3888.669189453125,
        843.23046875
      ],
      "bbox_max": [
        -1444.762939453125,
        -3883.845458984375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42148998379707336,
        0.9063196182250977,
        0.03050910122692585
      ],
      "plane_d": 2961.93310546875,
      "bbox_min": [
        -1464.0,
        -3978.554931640625,
        860.23046875
      ],
      "bbox_max": [
        -1445.1158447265625,
        -3952.99267578125,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1842150092124939,
        0.24487809836864471,
        0.951892614364624
      ],
      "plane_d": 419.50457763671875,
      "bbox_min": [
        -1464.0,
        -3978.08349609375,
        860.23046875
      ],
      "bbox_max": [
        -1445.7603759765625,
        -3961.324462890625,
        865.9923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4066848158836365,
        0.9120557904243469,
        0.05255300551652908
      ],
      "plane_d": 2975.403076171875,
      "bbox_min": [
        -1464.0,
        -3964.802001953125,
        860.23046875
      ],
      "bbox_max": [
        -1456.5045166015625,
        -3961.324462890625,
        862.5756225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3084544539451599,
        0.1285535991191864,
        0.9425125122070312
      ],
      "plane_d": 147.72979736328125,
      "bbox_min": [
        -1464.0,
        -3969.618896484375,
        860.23046875
      ],
      "bbox_max": [
        -1456.5045166015625,
        -3961.324462890625,
        863.8148193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4066848158836365,
        0.9120557904243469,
        0.05255300551652908
      ],
      "plane_d": 2975.403076171875,
      "bbox_min": [
        -1464.0,
        -3964.835693359375,
        860.23046875
      ],
      "bbox_max": [
        -1456.5045166015625,
        -3961.324462890625,
        863.1624145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3934.89990234375,
      "bbox_min": [
        -1536.0,
        -3985.392333984375,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3875.359130859375,
        880.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.10009765625,
      "bbox_min": [
        -1536.0,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3875.359130859375,
        880.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.004700719844549894,
        -0.9998874664306641,
        0.014245511963963509
      ],
      "plane_d": -3894.679443359375,
      "bbox_min": [
        -1536.0,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3875.359130859375,
        880.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.000275469443295151,
        -1.0,
        1.7972455452763825e-06
      ],
      "plane_d": -3888.109375,
      "bbox_min": [
        -1536.0,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3887.684814453125,
        835.5115356445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3268859386444092,
        -0.9423353672027588,
        0.07176199555397034
      ],
      "plane_d": -4207.455078125,
      "bbox_min": [
        -1479.1204833984375,
        -3894.8740234375,
        816.8230590820312
      ],
      "bbox_max": [
        -1464.0,
        -3888.522705078125,
        835.5115356445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 125.052001953125,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826742172241211,
        -0.0
      ],
      "plane_d": -2856.97509765625,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 2847.41943359375,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        -0.9238833785057068,
        -0.0
      ],
      "plane_d": -4168.53369140625,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -3043.854248046875,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826742172241211,
        0.0
      ],
      "plane_d": -137.6693115234375,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -827.513427734375,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 2849.425537109375,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826742172241211,
        0.0
      ],
      "plane_d": -134.13232421875,
      "bbox_min": [
        -1478.5,
        -3903.300048828125,
        812.5
      ],
      "bbox_max": [
        -1467.732177734375,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -3037.86279296875,
      "bbox_min": [
        -1478.5,
        -3902.56787109375,
        812.5
      ],
      "bbox_max": [
        -1469.5,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        -0.9238833785057068,
        -0.0
      ],
      "plane_d": -4167.13427734375,
      "bbox_min": [
        -1478.5,
        -3899.300048828125,
        812.5
      ],
      "bbox_max": [
        -1470.0250244140625,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 128.5889892578125,
      "bbox_min": [
        -1478.5,
        -3899.300048828125,
        812.5
      ],
      "bbox_max": [
        -1470.0250244140625,
        -3893.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826742172241211,
        -0.0
      ],
      "plane_d": -2854.96875,
      "bbox_min": [
        -1475.853515625,
        -3899.300048828125,
        812.5
      ],
      "bbox_max": [
        -1470.0250244140625,
        -3894.0322265625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 2851.431884765625,
      "bbox_min": [
        -1475.5,
        -3899.153564453125,
        812.5
      ],
      "bbox_max": [
        -1470.0250244140625,
        -3894.0322265625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826742172241211,
        0.0
      ],
      "plane_d": -130.59521484375,
      "bbox_min": [
        -1475.5,
        -3899.153564453125,
        812.5
      ],
      "bbox_max": [
        -1471.878662109375,
        -3894.0322265625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 3035.315185546875,
      "bbox_min": [
        -1475.5,
        -3899.153564453125,
        820.0
      ],
      "bbox_max": [
        -1472.5,
        -3894.0322265625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 819.9999389648438,
      "bbox_min": [
        -1475.5,
        -3899.153564453125,
        820.0
      ],
      "bbox_max": [
        -1472.5,
        -3895.446533203125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1475.4998779296875,
        -3899.153564453125,
        820.0134887695312
      ],
      "bbox_max": [
        -1472.5,
        -3895.446533203125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1474.6212158203125,
        -3896.178466796875,
        820.0134887695312
      ],
      "bbox_max": [
        -1472.853515625,
        -3894.0322265625,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 3035.315185546875,
      "bbox_min": [
        -1472.853515625,
        -3897.80029296875,
        820.0
      ],
      "bbox_max": [
        -1470.0250244140625,
        -3895.300048828125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 819.9999389648438,
      "bbox_min": [
        -1472.853515625,
        -3897.80029296875,
        820.0
      ],
      "bbox_max": [
        -1470.0250244140625,
        -3895.300048828125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1475.853515625,
        -3899.300048828125,
        820.0134887695312
      ],
      "bbox_max": [
        -1475.1463623046875,
        -3898.300048828125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1478.5,
        -3899.153564453125,
        820.0134887695312
      ],
      "bbox_max": [
        -1473.732177734375,
        -3893.300048828125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826742172241211,
        -0.0
      ],
      "plane_d": -2854.96875,
      "bbox_min": [
        -1475.146484375,
        -3902.56787109375,
        812.5
      ],
      "bbox_max": [
        -1469.5,
        -3897.032470703125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 3038.310791015625,
      "bbox_min": [
        -1475.146484375,
        -3902.56787109375,
        812.5
      ],
      "bbox_max": [
        -1469.5,
        -3897.032470703125,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826742172241211,
        -0.0
      ],
      "plane_d": -2852.962646484375,
      "bbox_min": [
        -1474.9749755859375,
        -3902.56787109375,
        812.5
      ],
      "bbox_max": [
        -1469.5,
        -3897.4462890625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 132.1260986328125,
      "bbox_min": [
        -1473.12158203125,
        -3902.56787109375,
        812.5
      ],
      "bbox_max": [
        -1469.5,
        -3897.4462890625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -3040.8583984375,
      "bbox_min": [
        -1472.5,
        -3902.56787109375,
        820.0
      ],
      "bbox_max": [
        -1469.5,
        -3897.4462890625,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 819.9999389648438,
      "bbox_min": [
        -1472.5,
        -3901.153564453125,
        820.0
      ],
      "bbox_max": [
        -1469.5,
        -3897.4462890625,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1472.5,
        -3901.153564453125,
        820.0134887695312
      ],
      "bbox_max": [
        -1469.5,
        -3897.446533203125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1472.146484375,
        -3902.56787109375,
        820.0134887695312
      ],
      "bbox_max": [
        -1470.378662109375,
        -3900.421142578125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -3040.8583984375,
      "bbox_min": [
        -1474.9749755859375,
        -3901.300048828125,
        820.0
      ],
      "bbox_max": [
        -1472.1466064453125,
        -3898.7998046875,
        827.5134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 819.9999389648438,
      "bbox_min": [
        -1474.9749755859375,
        -3901.300048828125,
        820.0
      ],
      "bbox_max": [
        -1472.1466064453125,
        -3898.7998046875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 819.9999389648438,
      "bbox_min": [
        -1475.146484375,
        -3899.567626953125,
        820.0
      ],
      "bbox_max": [
        -1469.8536376953125,
        -3897.032470703125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1471.267822265625,
        -3903.300048828125,
        820.0134887695312
      ],
      "bbox_max": [
        -1467.732177734375,
        -3898.300048828125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 3038.310791015625,
      "bbox_min": [
        -1469.853515625,
        -3902.56787109375,
        812.5
      ],
      "bbox_max": [
        -1466.5,
        -3897.300048828125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -820.013427734375,
      "bbox_min": [
        -1469.853515625,
        -3902.56787109375,
        820.0134887695312
      ],
      "bbox_max": [
        -1466.5,
        -3897.300048828125,
        820.0134887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3316125273704529,
        0.10155961662530899,
        0.9379333257675171
      ],
      "plane_d": -877.82568359375,
      "bbox_min": [
        -1536.0,
        -3893.45068359375,
        813.6593017578125
      ],
      "bbox_max": [
        -1464.0,
        -3875.63330078125,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.000275469443295151,
        -1.0,
        1.7972455452763825e-06
      ],
      "plane_d": -3888.109375,
      "bbox_min": [
        -1536.0,
        -3893.45068359375,
        813.6593017578125
      ],
      "bbox_max": [
        -1464.0,
        -3876.300048828125,
        839.855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1477.587646484375,
        -3881.587158203125,
        833.23046875
      ],
      "bbox_max": [
        -1464.0,
        -3876.300048828125,
        838.6049194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3268859386444092,
        -0.9423353672027588,
        0.07176199555397034
      ],
      "plane_d": -4207.455078125,
      "bbox_min": [
        -1481.0947265625,
        -3893.45068359375,
        830.8259887695312
      ],
      "bbox_max": [
        -1464.0,
        -3887.699951171875,
        839.855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3852156400680542,
        -0.9228231906890869,
        0.0025133017916232347
      ],
      "plane_d": -4160.28857421875,
      "bbox_min": [
        -1481.0947265625,
        -3888.522705078125,
        830.8259887695312
      ],
      "bbox_max": [
        -1479.1204833984375,
        -3887.699951171875,
        833.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1481.0789794921875,
        -3893.119873046875,
        833.23046875
      ],
      "bbox_max": [
        -1464.0,
        -3875.63330078125,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3268859386444092,
        -0.9423353672027588,
        0.07176199555397034
      ],
      "plane_d": -4207.455078125,
      "bbox_min": [
        -1481.0789794921875,
        -3893.119873046875,
        833.23046875
      ],
      "bbox_max": [
        -1464.0,
        -3876.300048828125,
        840.1790771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18331149220466614,
        0.28863954544067383,
        0.9397255778312683
      ],
      "plane_d": 64.98672485351562,
      "bbox_min": [
        -1477.587646484375,
        -3888.648681640625,
        833.23046875
      ],
      "bbox_max": [
        -1464.0,
        -3876.300048828125,
        839.6738891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -818.5,
      "bbox_min": [
        -1527.5693359375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        856.012939453125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        0.0,
        0.8073849081993103
      ],
      "plane_d": -1539.9820556640625,
      "bbox_min": [
        -1526.8499755859375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        818.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5900251865386963,
        -0.0,
        0.8073849081993103
      ],
      "plane_d": 206.49249267578125,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        818.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 818.0,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        818.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        -1490.6842041015625,
        -3931.60009765625,
        818.0
      ],
      "bbox_max": [
        -1469.3157958984375,
        -3922.39990234375,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        -1490.6842041015625,
        -3931.60009765625,
        818.0
      ],
      "bbox_max": [
        -1490.0,
        -3922.39990234375,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3922.39990234375,
      "bbox_min": [
        -1490.6842041015625,
        -3931.60009765625,
        818.0
      ],
      "bbox_max": [
        -1490.0,
        -3922.39990234375,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3922.39990234375,
      "bbox_min": [
        -1470.0,
        -3922.39990234375,
        818.0
      ],
      "bbox_max": [
        -1469.3157958984375,
        -3922.39990234375,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3932.0,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        818.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3932.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3934.5,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3932.0,
        817.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -1548.0,
      "bbox_min": [
        -1492.5999755859375,
        -3934.5,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3932.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": 228.00006103515625,
      "bbox_min": [
        -1492.0,
        -3934.5,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3932.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        -0.0,
        -0.800000011920929
      ],
      "plane_d": -244.00006103515625,
      "bbox_min": [
        -1492.0,
        -3934.5,
        812.5
      ],
      "bbox_max": [
        -1468.0,
        -3932.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 1532.0,
      "bbox_min": [
        -1492.0,
        -3934.5,
        812.5
      ],
      "bbox_max": [
        -1468.0,
        -3932.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.0,
      "bbox_min": [
        -1492.0,
        -3934.5,
        814.0
      ],
      "bbox_max": [
        -1468.0,
        -3932.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1468.0,
      "bbox_min": [
        -1468.0,
        -3934.5,
        814.0
      ],
      "bbox_max": [
        -1468.0,
        -3932.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1469.3157958984375,
        -3934.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3932.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1467.4000244140625,
      "bbox_min": [
        -1467.4000244140625,
        -3934.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3932.0,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1492.5999755859375,
        -3934.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1490.6842041015625,
        -3932.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.5999755859375,
      "bbox_min": [
        -1492.5999755859375,
        -3934.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1492.5999755859375,
        -3932.0,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3934.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.5999755859375,
      "bbox_min": [
        -1492.5999755859375,
        -3934.89990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1492.5999755859375,
        -3934.5,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1469.3157958984375,
        -3934.89990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3934.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1467.4000244140625,
      "bbox_min": [
        -1467.4000244140625,
        -3934.89990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3934.5,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1490.6842041015625,
        -3934.89990234375,
        817.5
      ],
      "bbox_max": [
        -1469.3157958984375,
        -3932.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1470.0,
        -3934.89990234375,
        817.5
      ],
      "bbox_max": [
        -1469.3157958984375,
        -3932.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3922.0,
      "bbox_min": [
        -1492.5999755859375,
        -3932.0,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        818.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1492.5999755859375,
        -3922.0,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3919.5,
      "bbox_min": [
        -1492.5999755859375,
        -3922.0,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        817.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -1548.0,
      "bbox_min": [
        -1492.5999755859375,
        -3922.0,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": 228.00006103515625,
      "bbox_min": [
        -1492.0,
        -3922.0,
        812.5
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        -0.0,
        -0.800000011920929
      ],
      "plane_d": -244.00006103515625,
      "bbox_min": [
        -1492.0,
        -3922.0,
        812.5
      ],
      "bbox_max": [
        -1468.0,
        -3919.5,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 1532.0,
      "bbox_min": [
        -1492.0,
        -3922.0,
        812.5
      ],
      "bbox_max": [
        -1468.0,
        -3919.5,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.0,
      "bbox_min": [
        -1492.0,
        -3922.0,
        814.0
      ],
      "bbox_max": [
        -1468.0,
        -3919.5,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1468.0,
      "bbox_min": [
        -1468.0,
        -3922.0,
        814.0
      ],
      "bbox_max": [
        -1468.0,
        -3919.5,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1469.3157958984375,
        -3922.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1467.4000244140625,
      "bbox_min": [
        -1467.4000244140625,
        -3922.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.5,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1492.5999755859375,
        -3922.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1490.6842041015625,
        -3919.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.5999755859375,
      "bbox_min": [
        -1492.5999755859375,
        -3922.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1492.5999755859375,
        -3919.5,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1492.5999755859375,
        -3919.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1467.4000244140625,
      "bbox_min": [
        -1467.4000244140625,
        -3919.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3919.10009765625,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1492.5999755859375,
        -3919.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1490.6842041015625,
        -3919.10009765625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.5999755859375,
      "bbox_min": [
        -1492.5999755859375,
        -3919.5,
        816.0999755859375
      ],
      "bbox_max": [
        -1492.5999755859375,
        -3919.10009765625,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1490.6842041015625,
        -3922.0,
        817.5
      ],
      "bbox_max": [
        -1490.0,
        -3919.10009765625,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3923.0,
      "bbox_min": [
        -1492.5999755859375,
        -3931.0,
        815.0
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3922.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.0,
        -0.44721364974975586
      ],
      "plane_d": -962.8509521484375,
      "bbox_min": [
        -1485.5,
        -3931.0,
        815.0
      ],
      "bbox_max": [
        -1471.0,
        -3923.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 1681.5233154296875,
      "bbox_min": [
        -1472.5,
        -3931.0,
        815.0
      ],
      "bbox_max": [
        -1471.0,
        -3923.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1492.5999755859375,
        -3922.39990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3922.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3922.39990234375,
      "bbox_min": [
        -1470.0,
        -3922.39990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3922.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1467.4000244140625,
      "bbox_min": [
        -1467.4000244140625,
        -3922.39990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3922.0,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1492.5999755859375,
        -3922.39990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1490.0,
        -3922.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3922.39990234375,
      "bbox_min": [
        -1492.5999755859375,
        -3922.39990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1490.0,
        -3922.0,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.5999755859375,
      "bbox_min": [
        -1492.5999755859375,
        -3922.39990234375,
        816.0999755859375
      ],
      "bbox_max": [
        -1492.5999755859375,
        -3922.0,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5900251865386963,
        0.0,
        -0.8073849081993103
      ],
      "plane_d": 1539.578369140625,
      "bbox_min": [
        -1492.5999755859375,
        -3932.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3931.60009765625,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3931.60009765625,
      "bbox_min": [
        -1492.5999755859375,
        -3932.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1490.0,
        -3931.60009765625,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1492.5999755859375,
      "bbox_min": [
        -1492.5999755859375,
        -3932.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1492.5999755859375,
        -3931.60009765625,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900251865386963,
        -0.0,
        -0.8073849081993103
      ],
      "plane_d": -206.89617919921875,
      "bbox_min": [
        -1470.0,
        -3932.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3931.60009765625,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3931.60009765625,
      "bbox_min": [
        -1470.0,
        -3932.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3931.60009765625,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1467.4000244140625,
      "bbox_min": [
        -1467.4000244140625,
        -3932.0,
        816.0999755859375
      ],
      "bbox_max": [
        -1467.4000244140625,
        -3931.60009765625,
        816.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1526.449951171875,
      "bbox_min": [
        -1526.8499755859375,
        -3924.449951171875,
        817.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1526.8499755859375,
      "bbox_min": [
        -1526.8499755859375,
        -3924.449951171875,
        817.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3924.449951171875,
      "bbox_min": [
        -1526.8499755859375,
        -3924.449951171875,
        817.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3924.0498046875,
      "bbox_min": [
        -1526.8499755859375,
        -3924.0498046875,
        817.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        818.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1526.449951171875,
      "bbox_min": [
        -1527.5693359375,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3920.39990234375,
        856.012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3924.449951171875,
      "bbox_min": [
        -1527.5693359375,
        -3926.0,
        818.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3922.0,
        855.9824829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3924.0498046875,
      "bbox_min": [
        -1527.5693359375,
        -3924.449951171875,
        818.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3922.0,
        855.9824829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1526.8499755859375,
      "bbox_min": [
        -1527.5693359375,
        -3924.449951171875,
        818.5
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        855.9824829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.891017735004425,
        0.0,
        0.4539685845375061
      ],
      "plane_d": -1748.6832275390625,
      "bbox_min": [
        -1526.8499755859375,
        -3924.449951171875,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        855.9824829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4539879858493805,
        -0.0,
        -0.8910079002380371
      ],
      "plane_d": 66.2314453125,
      "bbox_min": [
        -1526.8499755859375,
        -3924.449951171875,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.0498046875,
        852.2965698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.891017735004425,
        0.0,
        0.4539685845375061
      ],
      "plane_d": -1748.6832275390625,
      "bbox_min": [
        -1527.5693359375,
        -3924.449951171875,
        852.2965698242188
      ],
      "bbox_max": [
        -1526.8499755859375,
        -3924.0498046875,
        855.1973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510598182678223,
        -0.0,
        -0.30900704860687256
      ],
      "plane_d": -1188.984130859375,
      "bbox_min": [
        -1527.5693359375,
        -3924.449951171875,
        852.2965698242188
      ],
      "bbox_max": [
        -1526.8499755859375,
        -3924.0498046875,
        853.7854614257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4539879858493805,
        -0.0,
        -0.8910079002380371
      ],
      "plane_d": 66.2314453125,
      "bbox_min": [
        -1527.13232421875,
        -3924.449951171875,
        852.2965698242188
      ],
      "bbox_max": [
        -1526.8499755859375,
        -3924.0498046875,
        852.4404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.891017735004425,
        0.0,
        0.4539685845375061
      ],
      "plane_d": -1748.6832275390625,
      "bbox_min": [
        -1527.5693359375,
        -3924.0498046875,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3922.0,
        855.9824829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3922.0,
      "bbox_min": [
        -1527.5693359375,
        -3924.0498046875,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3922.0,
        855.9824829101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510598182678223,
        -0.0,
        -0.30900704860687256
      ],
      "plane_d": -1188.984130859375,
      "bbox_min": [
        -1527.5693359375,
        -3924.0498046875,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3922.0,
        853.7854614257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4539879858493805,
        -0.0,
        -0.8910079002380371
      ],
      "plane_d": 66.2314453125,
      "bbox_min": [
        -1527.13232421875,
        -3924.0498046875,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3922.0,
        852.4404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.891017735004425,
        0.0,
        0.4539685845375061
      ],
      "plane_d": -1748.6832275390625,
      "bbox_min": [
        -1527.5693359375,
        -3926.0,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.449951171875,
        855.9824829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4539879858493805,
        -0.0,
        -0.8910079002380371
      ],
      "plane_d": 66.2314453125,
      "bbox_min": [
        -1527.13232421875,
        -3926.0,
        852.0927734375
      ],
      "bbox_max": [
        -1526.449951171875,
        -3924.449951171875,
        852.4404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284786581993103,
        -0.0,
        0.371385782957077
      ],
      "plane_d": 1062.184326171875,
      "bbox_min": [
        -1478.0,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1471.4000244140625,
        -3920.39990234375,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3932.0,
      "bbox_min": [
        -1478.0,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1471.4000244140625,
        -3920.39990234375,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3922.0,
      "bbox_min": [
        -1478.0,
        -3922.0,
        818.5
      ],
      "bbox_max": [
        -1471.4000244140625,
        -3920.39990234375,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3920.39990234375,
      "bbox_min": [
        -1476.4000244140625,
        -3922.0,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3920.39990234375,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.7000122070312,
      "bbox_min": [
        -1476.4000244140625,
        -3922.0,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3920.39990234375,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1476.4000244140625,
      "bbox_min": [
        -1476.4000244140625,
        -3922.0,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3920.39990234375,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1473.5999755859375,
      "bbox_min": [
        -1473.5999755859375,
        -3922.0,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3920.39990234375,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3933.60009765625,
      "bbox_min": [
        -1476.4000244140625,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3932.0,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.7000122070312,
      "bbox_min": [
        -1476.4000244140625,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3932.0,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1476.4000244140625,
      "bbox_min": [
        -1476.4000244140625,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3932.0,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1473.5999755859375,
      "bbox_min": [
        -1473.5999755859375,
        -3933.60009765625,
        818.5
      ],
      "bbox_max": [
        -1473.5999755859375,
        -3932.0,
        820.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3926.0,
      "bbox_min": [
        -1485.199951171875,
        -3931.39990234375,
        818.5
      ],
      "bbox_max": [
        -1476.5999755859375,
        -3926.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3931.39990234375,
      "bbox_min": [
        -1485.199951171875,
        -3931.39990234375,
        818.5
      ],
      "bbox_max": [
        -1476.5999755859375,
        -3926.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1485.199951171875,
      "bbox_min": [
        -1485.199951171875,
        -3931.39990234375,
        818.5
      ],
      "bbox_max": [
        -1485.199951171875,
        -3926.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3926.0,
      "bbox_min": [
        -1526.449951171875,
        -3931.39990234375,
        822.5
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3922.0,
        856.012939453125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3931.39990234375,
      "bbox_min": [
        -1485.199951171875,
        -3931.39990234375,
        822.5
      ],
      "bbox_max": [
        -1476.5999755859375,
        -3926.0,
        831.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9422163963317871,
        0.0,
        0.33500516414642334
      ],
      "plane_d": -1674.9215087890625,
      "bbox_min": [
        -1485.199951171875,
        -3931.39990234375,
        822.5
      ],
      "bbox_max": [
        -1476.5999755859375,
        -3926.0,
        831.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1476.5999755859375,
      "bbox_min": [
        -1482.0,
        -3931.39990234375,
        822.5
      ],
      "bbox_max": [
        -1476.5999755859375,
        -3926.0,
        831.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -831.5,
      "bbox_min": [
        -1482.0,
        -3931.39990234375,
        831.5
      ],
      "bbox_max": [
        -1476.5999755859375,
        -3926.0,
        831.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8910062909126282,
        0.0,
        0.4539909362792969
      ],
      "plane_d": -1694.684814453125,
      "bbox_min": [
        -1526.449951171875,
        -3926.0,
        822.5
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3922.0,
        856.012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3924.7998046875,
      "bbox_min": [
        -1479.7728271484375,
        -3925.39990234375,
        822.5
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3922.39990234375,
        831.4974975585938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3923.0,
      "bbox_min": [
        -1479.7728271484375,
        -3924.7998046875,
        822.5
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3922.39990234375,
        831.4974975585938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.4539877772331238,
        -0.0,
        0.8910080194473267
      ],
      "plane_d": -69.73162841796875,
      "bbox_min": [
        -1479.7728271484375,
        -3924.7998046875,
        823.3298950195312
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3923.0,
        831.4974975585938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4540001153945923,
        -0.0,
        -0.8910017013549805
      ],
      "plane_d": 64.10821533203125,
      "bbox_min": [
        -1479.7728271484375,
        -3924.7998046875,
        823.3298950195312
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3923.0,
        828.6463012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9111109972000122,
        -0.0,
        -0.41216132044792175
      ],
      "plane_d": -1006.7013549804688,
      "bbox_min": [
        -1479.7728271484375,
        -3924.7998046875,
        823.3298950195312
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3923.0,
        828.6463012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2021128386259079,
        0.0,
        -0.9793623089790344
      ],
      "plane_d": 1104.37890625,
      "bbox_min": [
        -1474.6253662109375,
        -3924.7998046875,
        823.3298950195312
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3923.0,
        826.9575805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910062909126282,
        0.0,
        -0.4539909362792969
      ],
      "plane_d": 1684.684814453125,
      "bbox_min": [
        -1470.86279296875,
        -3924.7998046875,
        824.1063842773438
      ],
      "bbox_max": [
        -1469.4100341796875,
        -3923.0,
        826.9575805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3922.399658203125,
      "bbox_min": [
        -1476.199951171875,
        -3923.0,
        822.5
      ],
      "bbox_max": [
        -1473.4000244140625,
        -3922.39990234375,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9844274520874023,
        0.0,
        0.17579138278961182
      ],
      "plane_d": -1597.8001708984375,
      "bbox_min": [
        -1476.199951171875,
        -3923.0,
        822.5
      ],
      "bbox_max": [
        -1473.4000244140625,
        -3922.39990234375,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9844274520874023,
        -0.0,
        0.17579138278961182
      ],
      "plane_d": 1305.8670654296875,
      "bbox_min": [
        -1475.199951171875,
        -3923.0,
        822.5
      ],
      "bbox_max": [
        -1473.4000244140625,
        -3922.39990234375,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -828.0999755859375,
      "bbox_min": [
        -1475.199951171875,
        -3923.0,
        828.0999755859375
      ],
      "bbox_max": [
        -1474.4000244140625,
        -3922.39990234375,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3925.399658203125,
      "bbox_min": [
        -1476.199951171875,
        -3925.39990234375,
        822.5
      ],
      "bbox_max": [
        -1473.4000244140625,
        -3924.7998046875,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9844274520874023,
        0.0,
        0.17579138278961182
      ],
      "plane_d": -1597.8001708984375,
      "bbox_min": [
        -1476.199951171875,
        -3925.39990234375,
        822.5
      ],
      "bbox_max": [
        -1473.4000244140625,
        -3924.7998046875,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9844274520874023,
        -0.0,
        0.17579138278961182
      ],
      "plane_d": 1305.8670654296875,
      "bbox_min": [
        -1475.199951171875,
        -3925.39990234375,
        822.5
      ],
      "bbox_max": [
        -1473.4000244140625,
        -3924.7998046875,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -828.0999755859375,
      "bbox_min": [
        -1475.199951171875,
        -3925.39990234375,
        828.0999755859375
      ],
      "bbox_max": [
        -1474.4000244140625,
        -3924.7998046875,
        828.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45398980379104614,
        -0.0,
        -0.8910069465637207
      ],
      "plane_d": 67.227783203125,
      "bbox_min": [
        -1526.449951171875,
        -3926.0,
        829.2699584960938
      ],
      "bbox_max": [
        -1478.5469970703125,
        -3922.0,
        856.012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3923.5,
      "bbox_min": [
        -1526.449951171875,
        -3926.0,
        829.2699584960938
      ],
      "bbox_max": [
        -1478.5469970703125,
        -3922.0,
        856.012939453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.45398974418640137,
        -0.0,
        0.8910068869590759
      ],
      "plane_d": -69.22784423828125,
      "bbox_min": [
        -1526.449951171875,
        -3926.0,
        829.2699584960938
      ],
      "bbox_max": [
        -1478.5469970703125,
        -3923.5,
        856.012939453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3924.5,
      "bbox_min": [
        -1524.00537109375,
        -3926.0,
        829.2699584960938
      ],
      "bbox_max": [
        -1478.5469970703125,
        -3923.5,
        853.75146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4539922773838043,
        -0.0,
        -0.8910056352615356
      ],
      "plane_d": 67.72296142578125,
      "bbox_min": [
        -1524.00537109375,
        -3924.5,
        840.6196899414062
      ],
      "bbox_max": [
        -1500.822265625,
        -3923.5,
        853.75146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8909955620765686,
        0.0,
        0.45401203632354736
      ],
      "plane_d": -1722.6865234375,
      "bbox_min": [
        -1523.7783203125,
        -3924.5,
        841.065185546875
      ],
      "bbox_max": [
        -1500.822265625,
        -3923.5,
        853.75146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910120725631714,
        0.0,
        -0.4539797604084015
      ],
      "plane_d": 1719.68408203125,
      "bbox_min": [
        -1501.5032958984375,
        -3924.5,
        841.065185546875
      ],
      "bbox_max": [
        -1500.822265625,
        -3923.5,
        842.4017333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910030722618103,
        0.0,
        -0.45399752259254456
      ],
      "plane_d": 1744.6854248046875,
      "bbox_min": [
        -1523.7783203125,
        -3924.5,
        852.4149780273438
      ],
      "bbox_max": [
        -1523.097412109375,
        -3923.5,
        853.75146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8909955620765686,
        0.0,
        0.45401203632354736
      ],
      "plane_d": -1722.6865234375,
      "bbox_min": [
        -1524.00537109375,
        -3924.5,
        840.6196899414062
      ],
      "bbox_max": [
        -1501.5032958984375,
        -3923.5,
        852.4149780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910120725631714,
        0.0,
        -0.4539797604084015
      ],
      "plane_d": 1719.68408203125,
      "bbox_min": [
        -1501.730224609375,
        -3924.5,
        840.6196899414062
      ],
      "bbox_max": [
        -1501.5032958984375,
        -3923.5,
        841.065185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910030722618103,
        0.0,
        -0.45399752259254456
      ],
      "plane_d": 1744.6854248046875,
      "bbox_min": [
        -1524.00537109375,
        -3924.5,
        851.969482421875
      ],
      "bbox_max": [
        -1523.7783203125,
        -3923.5,
        852.4149780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910030722618103,
        0.0,
        -0.45399752259254456
      ],
      "plane_d": 1744.6854248046875,
      "bbox_min": [
        -1524.00537109375,
        -3926.0,
        840.6196899414062
      ],
      "bbox_max": [
        -1500.822265625,
        -3924.5,
        853.75146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910120725631714,
        0.0,
        -0.4539797604084015
      ],
      "plane_d": 1719.68408203125,
      "bbox_min": [
        -1504.4031982421875,
        -3925.0,
        840.6196899414062
      ],
      "bbox_max": [
        -1500.822265625,
        -3924.5,
        843.763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8909955620765686,
        0.0,
        0.45401203632354736
      ],
      "plane_d": -1722.6865234375,
      "bbox_min": [
        -1504.4031982421875,
        -3925.0,
        841.981689453125
      ],
      "bbox_max": [
        -1503.4952392578125,
        -3924.5,
        843.763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45400410890579224,
        -0.0,
        0.8909996151924133
      ],
      "plane_d": -69.7001953125,
      "bbox_min": [
        -1526.449951171875,
        -3926.0,
        842.4017333984375
      ],
      "bbox_max": [
        -1500.59521484375,
        -3923.5,
        856.012939453125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3925.0,
      "bbox_min": [
        -1503.4952392578125,
        -3925.0,
        842.4017333984375
      ],
      "bbox_max": [
        -1500.59521484375,
        -3923.5,
        844.209228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8909955620765686,
        0.0,
        0.45401203632354736
      ],
      "plane_d": -1722.6865234375,
      "bbox_min": [
        -1503.4952392578125,
        -3925.0,
        842.4017333984375
      ],
      "bbox_max": [
        -1500.59521484375,
        -3923.5,
        844.209228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3922.0,
      "bbox_min": [
        -1526.449951171875,
        -3923.5,
        851.969482421875
      ],
      "bbox_max": [
        -1522.870361328125,
        -3922.0,
        856.012939453125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4539633095264435,
        -0.0,
        0.8910204768180847
      ],
      "plane_d": -69.77978515625,
      "bbox_min": [
        -1526.449951171875,
        -3923.5,
        854.197021484375
      ],
      "bbox_max": [
        -1522.870361328125,
        -3922.0,
        856.012939453125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.891017735004425,
        0.0,
        0.4539685845375061
      ],
      "plane_d": -1748.6832275390625,
      "bbox_min": [
        -1526.449951171875,
        -3923.5,
        855.9824829101562
      ],
      "bbox_max": [
        -1526.4344482421875,
        -3922.0,
        856.012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8909955620765686,
        0.0,
        0.45401203632354736
      ],
      "plane_d": -1722.6865234375,
      "bbox_min": [
        -1504.4031982421875,
        -3923.5,
        840.6196899414062
      ],
      "bbox_max": [
        -1500.59521484375,
        -3923.0,
        844.209228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4539879858493805,
        -0.0,
        -0.8910079002380371
      ],
      "plane_d": 66.2314453125,
      "bbox_min": [
        -1526.449951171875,
        -3926.0,
        851.532470703125
      ],
      "bbox_max": [
        -1524.00537109375,
        -3922.0,
        853.2150268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3922.0,
      "bbox_min": [
        -1526.449951171875,
        -3922.0,
        851.532470703125
      ],
      "bbox_max": [
        -1524.00537109375,
        -3922.0,
        853.2150268554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3923.0,
      "bbox_min": [
        -1504.6302490234375,
        -3925.0,
        840.1741943359375
      ],
      "bbox_max": [
        -1501.730224609375,
        -3923.0,
        841.981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8909955620765686,
        0.0,
        0.45401203632354736
      ],
      "plane_d": -1722.6865234375,
      "bbox_min": [
        -1504.6302490234375,
        -3925.0,
        840.1741943359375
      ],
      "bbox_max": [
        -1501.730224609375,
        -3923.0,
        841.981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910120725631714,
        0.0,
        -0.4539797604084015
      ],
      "plane_d": 1719.68408203125,
      "bbox_min": [
        -1501.9571533203125,
        -3925.0,
        840.1741943359375
      ],
      "bbox_max": [
        -1501.730224609375,
        -3923.0,
        840.6196899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9988258481025696,
        0.04844515025615692
      ],
      "plane_d": 3926.4765625,
      "bbox_min": [
        -1536.0,
        -3985.392333984375,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3950.0,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0246159378439188,
        0.995328426361084,
        0.09335536509752274
      ],
      "plane_d": 3920.978759765625,
      "bbox_min": [
        -1516.0067138671875,
        -3985.392333984375,
        864.6927490234375
      ],
      "bbox_max": [
        -1464.0,
        -3973.03173828125,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25812944769859314,
        0.1075797900557518,
        0.9601019620895386
      ],
      "plane_d": -25.497467041015625,
      "bbox_min": [
        -1516.0067138671875,
        -3985.392333984375,
        864.6927490234375
      ],
      "bbox_max": [
        -1464.0,
        -3973.03173828125,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3084544539451599,
        0.1285535991191864,
        0.9425125122070312
      ],
      "plane_d": 147.72979736328125,
      "bbox_min": [
        -1482.0694580078125,
        -3984.46533203125,
        864.6927490234375
      ],
      "bbox_max": [
        -1464.0,
        -3973.03173828125,
        870.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42148998379707336,
        0.9063196182250977,
        0.03050910122692585
      ],
      "plane_d": 2961.93310546875,
      "bbox_min": [
        -1477.4161376953125,
        -3985.392333984375,
        865.8436889648438
      ],
      "bbox_max": [
        -1464.0,
        -3977.505859375,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5992714166641235,
        0.7940782904624939,
        0.10155502706766129
      ],
      "plane_d": 2190.22802734375,
      "bbox_min": [
        -1477.4161376953125,
        -3985.392333984375,
        870.23046875
      ],
      "bbox_max": [
        -1474.237548828125,
        -3983.31591796875,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1842150092124939,
        0.24487809836864471,
        0.951892614364624
      ],
      "plane_d": 419.50457763671875,
      "bbox_min": [
        -1477.4161376953125,
        -3984.46533203125,
        865.8436889648438
      ],
      "bbox_max": [
        -1464.0,
        -3977.505859375,
        870.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011711918748915195,
        0.9992701411247253,
        0.036359161138534546
      ],
      "plane_d": 3956.1171875,
      "bbox_min": [
        -1536.0,
        -3973.774169921875,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3950.0,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29397791624069214,
        -0.12484616041183472,
        0.9476234912872314
      ],
      "plane_d": -885.0064086914062,
      "bbox_min": [
        -1513.762451171875,
        -3973.774169921875,
        870.23046875
      ],
      "bbox_max": [
        -1482.0694580078125,
        -3973.286376953125,
        880.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4066848158836365,
        0.9120557904243469,
        0.05255300551652908
      ],
      "plane_d": 2975.403076171875,
      "bbox_min": [
        -1486.0,
        -3973.300048828125,
        812.5
      ],
      "bbox_max": [
        -1464.0,
        -3950.0,
        870.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3084544539451599,
        0.1285535991191864,
        0.9425125122070312
      ],
      "plane_d": 147.72979736328125,
      "bbox_min": [
        -1482.0694580078125,
        -3973.300048828125,
        863.1624145507812
      ],
      "bbox_max": [
        -1464.0,
        -3964.835693359375,
        870.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1486.0,
        -3963.0,
        812.5
      ],
      "bbox_max": [
        -1470.0,
        -3950.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3955.0,
      "bbox_min": [
        -1475.0,
        -3955.0,
        812.5
      ],
      "bbox_max": [
        -1470.0,
        -3950.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3950.0,
      "bbox_min": [
        -1475.0,
        -3955.0,
        812.5
      ],
      "bbox_max": [
        -1470.0,
        -3950.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        -1475.0,
        -3955.0,
        812.5
      ],
      "bbox_max": [
        -1470.0,
        -3950.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -822.5,
      "bbox_min": [
        -1475.0,
        -3955.0,
        822.5
      ],
      "bbox_max": [
        -1470.0,
        -3950.0,
        822.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1486.0,
      "bbox_min": [
        -1486.0,
        -3963.0,
        812.5
      ],
      "bbox_max": [
        -1481.0,
        -3958.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3963.0,
      "bbox_min": [
        -1486.0,
        -3963.0,
        812.5
      ],
      "bbox_max": [
        -1481.0,
        -3958.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1486.0,
        -3963.0,
        812.5
      ],
      "bbox_max": [
        -1481.0,
        -3958.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3958.0,
      "bbox_min": [
        -1486.0,
        -3963.0,
        812.5
      ],
      "bbox_max": [
        -1481.0,
        -3958.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1481.0,
      "bbox_min": [
        -1481.0,
        -3963.0,
        812.5
      ],
      "bbox_max": [
        -1481.0,
        -3958.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999597430229187,
        0.005798146594315767,
        0.027776530012488365
      ],
      "plane_d": -1446.057373046875,
      "bbox_min": [
        -1572.812255859375,
        -3971.845703125,
        880.0
      ],
      "bbox_max": [
        -1429.44677734375,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999993443489075,
        -0.0007319787400774658,
        -0.0008959260885603726
      ],
      "plane_d": -1431.47705078125,
      "bbox_min": [
        -1442.515869140625,
        -3971.845703125,
        957.2897338867188
      ],
      "bbox_max": [
        -1429.44677734375,
        -3872.23583984375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12116607278585434,
        0.17957724630832672,
        0.9762534499168396
      ],
      "plane_d": -414.30517578125,
      "bbox_min": [
        -1442.515869140625,
        -3971.845703125,
        957.2897338867188
      ],
      "bbox_max": [
        -1429.44677734375,
        -3872.23583984375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1435849517583847,
        0.2128037065267563,
        0.9664875268936157
      ],
      "plane_d": -308.1363525390625,
      "bbox_min": [
        -1442.504150390625,
        -3886.378662109375,
        957.2897338867188
      ],
      "bbox_max": [
        -1429.5,
        -3872.9931640625,
        960.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3460525870323181,
        -0.9353697299957275,
        0.07301384210586548
      ],
      "plane_d": -4191.78857421875,
      "bbox_min": [
        -1442.504150390625,
        -3877.607177734375,
        957.2897338867188
      ],
      "bbox_max": [
        -1429.5,
        -3872.9931640625,
        960.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005916026420891285,
        0.19805555045604706,
        0.9801729917526245
      ],
      "plane_d": -180.00694274902344,
      "bbox_min": [
        -1442.515869140625,
        -3971.845703125,
        957.7694091796875
      ],
      "bbox_max": [
        -1429.44677734375,
        -3872.23583984375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36218133568763733,
        -0.9316588640213013,
        0.028919856995344162
      ],
      "plane_d": -4158.115234375,
      "bbox_min": [
        -1442.4906005859375,
        -3877.607177734375,
        957.7694091796875
      ],
      "bbox_max": [
        -1429.5,
        -3872.23583984375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3460525870323181,
        -0.9353697299957275,
        0.07301384210586548
      ],
      "plane_d": -4191.78857421875,
      "bbox_min": [
        -1442.4906005859375,
        -3877.607177734375,
        957.7694091796875
      ],
      "bbox_max": [
        -1429.5,
        -3872.4814453125,
        965.3356323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9995907545089722,
        0.0054229446686804295,
        0.028087837621569633
      ],
      "plane_d": -1447.8048095703125,
      "bbox_min": [
        -1572.812255859375,
        -3971.845703125,
        880.0
      ],
      "bbox_max": [
        -1441.93798828125,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1435849517583847,
        0.2128037065267563,
        0.9664875268936157
      ],
      "plane_d": -308.1363525390625,
      "bbox_min": [
        -1442.5101318359375,
        -3886.378662109375,
        957.2883911132812
      ],
      "bbox_max": [
        -1442.2774658203125,
        -3872.4814453125,
        965.3356323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3460525870323181,
        -0.9353697299957275,
        0.07301384210586548
      ],
      "plane_d": -4191.78857421875,
      "bbox_min": [
        -1442.5101318359375,
        -3873.025634765625,
        957.2883911132812
      ],
      "bbox_max": [
        -1442.2774658203125,
        -3872.4814453125,
        965.3356323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009739757515490055,
        -0.9992896914482117,
        0.036404166370630264
      ],
      "plane_d": -3908.230224609375,
      "bbox_min": [
        -1572.812255859375,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1441.93798828125,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9979248046875,
        0.06438945233821869
      ],
      "plane_d": -3915.197998046875,
      "bbox_min": [
        -1552.3212890625,
        -3862.027587890625,
        950.23046875
      ],
      "bbox_max": [
        -1470.6650390625,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3460525870323181,
        -0.9353697299957275,
        0.07301384210586548
      ],
      "plane_d": -4191.78857421875,
      "bbox_min": [
        -1473.7210693359375,
        -3862.027587890625,
        950.23046875
      ],
      "bbox_max": [
        -1470.6650390625,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36218133568763733,
        -0.9316588640213013,
        0.028919856995344162
      ],
      "plane_d": -4158.115234375,
      "bbox_min": [
        -1472.723388671875,
        -3861.09375,
        976.6776123046875
      ],
      "bbox_max": [
        -1470.6650390625,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004638694226741791,
        -0.9998871088027954,
        0.014288756065070629
      ],
      "plane_d": -3894.6220703125,
      "bbox_min": [
        -1572.812255859375,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1441.93798828125,
        -3860.26806640625,
        977.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.247871533036232,
        -0.11960845440626144,
        0.9613810181617737
      ],
      "plane_d": -1740.758056640625,
      "bbox_min": [
        -1568.84716796875,
        -3874.684326171875,
        923.1052856445312
      ],
      "bbox_max": [
        -1441.93798828125,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3523317873477936,
        -0.17001494765281677,
        0.9203028082847595
      ],
      "plane_d": -2059.265625,
      "bbox_min": [
        -1564.060302734375,
        -3874.615478515625,
        923.1052856445312
      ],
      "bbox_max": [
        -1545.2252197265625,
        -3862.0,
        930.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.684315025806427,
        -0.7247431874275208,
        0.08037566393613815
      ],
      "plane_d": -1812.14453125,
      "bbox_min": [
        -1564.060302734375,
        -3874.615478515625,
        923.1052856445312
      ],
      "bbox_max": [
        -1551.3052978515625,
        -3862.0,
        930.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2796148657798767,
        0.06662706285715103,
        0.9577977061271667
      ],
      "plane_d": -1064.8873291015625,
      "bbox_min": [
        -1568.84716796875,
        -3874.684326171875,
        925.3764038085938
      ],
      "bbox_max": [
        -1441.93798828125,
        -3860.26806640625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3460525870323181,
        -0.9353697299957275,
        0.07301384210586548
      ],
      "plane_d": -4191.78857421875,
      "bbox_min": [
        -1476.7244873046875,
        -3874.684326171875,
        950.23046875
      ],
      "bbox_max": [
        -1442.4283447265625,
        -3862.027587890625,
        960.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2602529227733612,
        0.06201345473527908,
        0.9635469317436218
      ],
      "plane_d": -1059.63427734375,
      "bbox_min": [
        -1476.7244873046875,
        -3874.646728515625,
        950.23046875
      ],
      "bbox_max": [
        -1457.5418701171875,
        -3862.027587890625,
        955.41259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3460525870323181,
        -0.9353697299957275,
        0.07301384210586548
      ],
      "plane_d": -4191.78857421875,
      "bbox_min": [
        -1473.7210693359375,
        -3872.8330078125,
        950.23046875
      ],
      "bbox_max": [
        -1441.93798828125,
        -3861.063720703125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36218133568763733,
        -0.9316588640213013,
        0.028919856995344162
      ],
      "plane_d": -4158.115234375,
      "bbox_min": [
        -1470.6767578125,
        -3872.4814453125,
        965.3356323242188
      ],
      "bbox_max": [
        -1441.93798828125,
        -3861.063720703125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3317689895629883,
        -0.9429503679275513,
        0.027818001806735992
      ],
      "plane_d": -4169.95068359375,
      "bbox_min": [
        -1572.812255859375,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1442.5,
        -3873.814697265625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669443130493164,
        -0.9301058650016785,
        0.015966827049851418
      ],
      "plane_d": -4160.86572265625,
      "bbox_min": [
        -1477.2425537109375,
        -3886.378662109375,
        880.0
      ],
      "bbox_max": [
        -1442.5,
        -3874.632080078125,
        960.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2602529227733612,
        0.06201345473527908,
        0.9635469317436218
      ],
      "plane_d": -1059.63427734375,
      "bbox_min": [
        -1476.7244873046875,
        -3886.378662109375,
        950.23046875
      ],
      "bbox_max": [
        -1442.5,
        -3874.632080078125,
        960.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1435849517583847,
        0.2128037065267563,
        0.9664875268936157
      ],
      "plane_d": -308.1363525390625,
      "bbox_min": [
        -1457.5418701171875,
        -3886.378662109375,
        955.41259765625
      ],
      "bbox_max": [
        -1442.5,
        -3874.646728515625,
        960.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9976535439491272,
        0.0,
        0.06846491247415543
      ],
      "plane_d": 1502.197265625,
      "bbox_min": [
        -1572.812255859375,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1544.65576171875,
        -3873.814697265625,
        977.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7796240448951721,
        -0.6259950399398804,
        0.017789822071790695
      ],
      "plane_d": -1237.33447265625,
      "bbox_min": [
        -1572.812255859375,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1544.65576171875,
        -3873.814697265625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27127769589424133,
        -0.429828017950058,
        0.8611946105957031
      ],
      "plane_d": -2885.706298828125,
      "bbox_min": [
        -1572.812255859375,
        -3888.93310546875,
        919.8519287109375
      ],
      "bbox_max": [
        -1545.2252197265625,
        -3873.814697265625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3523317873477936,
        -0.17001494765281677,
        0.9203028082847595
      ],
      "plane_d": -2059.265625,
      "bbox_min": [
        -1568.882080078125,
        -3879.705322265625,
        920.23046875
      ],
      "bbox_max": [
        -1545.2252197265625,
        -3874.60009765625,
        930.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18638136982917786,
        -0.20272767543792725,
        0.961334228515625
      ],
      "plane_d": -1378.76220703125,
      "bbox_min": [
        -1568.882080078125,
        -3879.952392578125,
        920.1708374023438
      ],
      "bbox_max": [
        -1568.843017578125,
        -3879.705322265625,
        920.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.782225489616394,
        -0.6227227449417114,
        0.018431877717375755
      ],
      "plane_d": -1221.1552734375,
      "bbox_min": [
        -1556.496826171875,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1551.32177734375,
        -3883.620361328125,
        920.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16137851774692535,
        -0.25569742918014526,
        0.953192412853241
      ],
      "plane_d": -2122.371337890625,
      "bbox_min": [
        -1556.496826171875,
        -3888.93603515625,
        919.851806640625
      ],
      "bbox_max": [
        -1555.750732421875,
        -3887.992919921875,
        920.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999011158943176,
        -0.004258743952959776,
        0.013403600081801414
      ],
      "plane_d": 1526.70458984375,
      "bbox_min": [
        -1556.49267578125,
        -3889.862548828125,
        880.0
      ],
      "bbox_max": [
        -1555.213623046875,
        -3887.992919921875,
        920.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16137851774692535,
        -0.25569742918014526,
        0.953192412853241
      ],
      "plane_d": -2122.371337890625,
      "bbox_min": [
        -1556.49267578125,
        -3889.47509765625,
        919.8327026367188
      ],
      "bbox_max": [
        -1555.750732421875,
        -3887.992919921875,
        920.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9986860156059265,
        -0.010753817856311798,
        0.050107408314943314
      ],
      "plane_d": 1478.988525390625,
      "bbox_min": [
        -1572.812255859375,
        -3994.642578125,
        880.0
      ],
      "bbox_max": [
        -1442.515869140625,
        -3877.06494140625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9976535439491272,
        0.0,
        0.06846491247415543
      ],
      "plane_d": 1502.197265625,
      "bbox_min": [
        -1572.812255859375,
        -3977.845703125,
        920.3544311523438
      ],
      "bbox_max": [
        -1568.890625,
        -3877.06494140625,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5992714166641235,
        0.7940782904624939,
        0.10155502706766129
      ],
      "plane_d": 2190.22802734375,
      "bbox_min": [
        -1548.0714111328125,
        -3994.642578125,
        880.0
      ],
      "bbox_max": [
        -1472.723388671875,
        -3983.439453125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25812944769859314,
        0.1075797900557518,
        0.9601019620895386
      ],
      "plane_d": -25.497467041015625,
      "bbox_min": [
        -1548.0714111328125,
        -3984.5,
        880.0
      ],
      "bbox_max": [
        -1513.74609375,
        -3983.439453125,
        889.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5992714166641235,
        0.7940782904624939,
        0.10155502706766129
      ],
      "plane_d": 2190.22802734375,
      "bbox_min": [
        -1572.812255859375,
        -3994.642578125,
        880.0
      ],
      "bbox_max": [
        -1442.515869140625,
        -3879.923828125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42148998379707336,
        0.9063196182250977,
        0.03050910122692585
      ],
      "plane_d": 2961.93310546875,
      "bbox_min": [
        -1474.237548828125,
        -3983.31591796875,
        880.0
      ],
      "bbox_max": [
        -1442.515869140625,
        -3969.84375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18638136982917786,
        -0.20272767543792725,
        0.961334228515625
      ],
      "plane_d": -1378.76220703125,
      "bbox_min": [
        -1572.812255859375,
        -3994.642578125,
        880.0
      ],
      "bbox_max": [
        -1513.5552978515625,
        -3879.923828125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999011158943176,
        -0.004258743952959776,
        0.013403600081801414
      ],
      "plane_d": 1526.70458984375,
      "bbox_min": [
        -1568.9000244140625,
        -3985.051025390625,
        880.0
      ],
      "bbox_max": [
        -1513.5552978515625,
        -3889.51611328125,
        915.604736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3092588484287262,
        -0.3363819718360901,
        0.8894977569580078
      ],
      "plane_d": -1652.5277099609375,
      "bbox_min": [
        -1568.9000244140625,
        -3981.21923828125,
        893.3043212890625
      ],
      "bbox_max": [
        -1555.7852783203125,
        -3962.51806640625,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4795033633708954,
        0.8688876032829285,
        0.12292567640542984
      ],
      "plane_d": 4095.0791015625,
      "bbox_min": [
        -1568.9000244140625,
        -3981.21923828125,
        893.3043212890625
      ],
      "bbox_max": [
        -1555.7852783203125,
        -3974.561767578125,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29397791624069214,
        -0.12484616041183472,
        0.9476234912872314
      ],
      "plane_d": -885.0064086914062,
      "bbox_min": [
        -1555.826904296875,
        -3985.051025390625,
        880.0
      ],
      "bbox_max": [
        -1513.5552978515625,
        -3945.6513671875,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011711918748915195,
        0.9992701411247253,
        0.036359161138534546
      ],
      "plane_d": 3956.1171875,
      "bbox_min": [
        -1555.71240234375,
        -3973.286376953125,
        880.0
      ],
      "bbox_max": [
        -1513.5552978515625,
        -3945.6513671875,
        895.064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.999853789806366,
        0.00017472774197813123,
        0.01709909364581108
      ],
      "plane_d": 1540.871826171875,
      "bbox_min": [
        -1555.71240234375,
        -3973.273681640625,
        880.0
      ],
      "bbox_max": [
        -1543.116943359375,
        -3945.6513671875,
        895.064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6658845543861389,
        0.7455488443374634,
        0.02747277170419693
      ],
      "plane_d": 3965.502197265625,
      "bbox_min": [
        -1555.7022705078125,
        -3973.273681640625,
        880.0
      ],
      "bbox_max": [
        -1543.116943359375,
        -3962.08154296875,
        894.5100708007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6178556680679321,
        0.7852272987365723,
        0.04089659824967384
      ],
      "plane_d": 4037.095458984375,
      "bbox_min": [
        -1544.626708984375,
        -3973.273681640625,
        880.0
      ],
      "bbox_max": [
        -1543.116943359375,
        -3971.752197265625,
        889.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25812944769859314,
        0.1075797900557518,
        0.9601019620895386
      ],
      "plane_d": -25.497467041015625,
      "bbox_min": [
        -1555.826904296875,
        -3985.051025390625,
        880.0
      ],
      "bbox_max": [
        -1514.1810302734375,
        -3958.2109375,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3092588484287262,
        -0.3363819718360901,
        0.8894977569580078
      ],
      "plane_d": -1652.5277099609375,
      "bbox_min": [
        -1555.826904296875,
        -3985.051025390625,
        889.23046875
      ],
      "bbox_max": [
        -1543.3038330078125,
        -3958.2109375,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6658845543861389,
        0.7455488443374634,
        0.02747277170419693
      ],
      "plane_d": 3965.502197265625,
      "bbox_min": [
        -1555.800048828125,
        -3973.273681640625,
        889.23046875
      ],
      "bbox_max": [
        -1543.3038330078125,
        -3958.2109375,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.999853789806366,
        0.00017472774197813123,
        0.01709909364581108
      ],
      "plane_d": 1540.871826171875,
      "bbox_min": [
        -1555.800048828125,
        -3962.51806640625,
        894.5100708007812
      ],
      "bbox_max": [
        -1555.7022705078125,
        -3958.2109375,
        900.23046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4795033633708954,
        0.8688876032829285,
        0.12292567640542984
      ],
      "plane_d": 4095.0791015625,
      "bbox_min": [
        -1555.826904296875,
        -3985.051025390625,
        889.23046875
      ],
      "bbox_max": [
        -1548.0714111328125,
        -3980.8193359375,
        896.2918701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16137851774692535,
        -0.25569742918014526,
        0.953192412853241
      ],
      "plane_d": -2122.371337890625,
      "bbox_min": [
        -1572.812255859375,
        -3994.642578125,
        900.23046875
      ],
      "bbox_max": [
        -1552.3212890625,
        -3879.952392578125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999011158943176,
        -0.004258743952959776,
        0.013403600081801414
      ],
      "plane_d": 1526.70458984375,
      "bbox_min": [
        -1555.800048828125,
        -3962.51806640625,
        900.23046875
      ],
      "bbox_max": [
        -1555.6951904296875,
        -3889.47509765625,
        919.8327026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6326169371604919,
        0.7717466950416565,
        0.06482905149459839
      ],
      "plane_d": 4001.506591796875,
      "bbox_min": [
        -1572.812255859375,
        -3994.642578125,
        900.23046875
      ],
      "bbox_max": [
        -1552.3212890625,
        -3974.561767578125,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -1708.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3846.60009765625,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9783772826194763,
        -0.2068280577659607
      ],
      "plane_d": 4144.7412109375,
      "bbox_min": [
        -1708.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3846.60009765625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1467.0,
      "bbox_min": [
        -1599.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        -1461.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1401.0,
      "bbox_min": [
        -1401.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        -1335.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1329.0,
      "bbox_min": [
        -1329.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1533.0,
      "bbox_min": [
        -1599.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1599.0,
      "bbox_min": [
        -1599.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1593.0,
      "bbox_min": [
        -1593.0,
        -4033.199951171875,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -4015.0556640625,
        1046.7733154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.978434681892395,
        -0.2065565288066864
      ],
      "plane_d": -3565.376220703125,
      "bbox_min": [
        -1708.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3846.60009765625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1467.0,
      "bbox_min": [
        -1599.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        -1461.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.0,
      "bbox_min": [
        -1401.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        -1335.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1329.0,
      "bbox_min": [
        -1329.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1533.0,
      "bbox_min": [
        -1599.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1599.0,
      "bbox_min": [
        -1599.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1593.0,
      "bbox_min": [
        -1593.0,
        -3864.9423828125,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -3846.60009765625,
        1046.7713623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1467.0,
      "bbox_min": [
        -1708.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.8756473660469055,
        -0.0,
        -0.48295092582702637
      ],
      "plane_d": -622.6165771484375,
      "bbox_min": [
        -1395.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1284.357177734375,
        -4010.0,
        1000.7767333984375
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1039.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4010.0,
      "bbox_min": [
        -1281.599609375,
        -4010.0,
        1000.7767333984375
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1034.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3929.999755859375,
      "bbox_min": [
        -1281.599609375,
        -3930.0,
        1000.7767333984375
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1034.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1274.705322265625,
        -3930.0,
        1020.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1274.705322265625,
        -3930.0,
        1020.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3924.0,
      "bbox_min": [
        -1274.705322265625,
        -3924.0,
        1020.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.5,
      "bbox_min": [
        -1284.357177734375,
        -4001.0,
        1034.5
      ],
      "bbox_max": [
        -1278.0,
        -3940.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4001.0,
      "bbox_min": [
        -1284.357177734375,
        -4001.0,
        1034.5
      ],
      "bbox_max": [
        -1278.0,
        -3940.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3940.0,
      "bbox_min": [
        -1284.357177734375,
        -3940.0,
        1034.5
      ],
      "bbox_max": [
        -1278.0,
        -3940.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3924.0,
      "bbox_min": [
        -1395.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1395.0,
        -3924.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1334.9998779296875,
      "bbox_min": [
        -1373.20458984375,
        -3894.30615234375,
        1041.5001220703125
      ],
      "bbox_max": [
        -1329.0,
        -3863.829345703125,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1328.9998779296875,
      "bbox_min": [
        -1335.0,
        -3894.30615234375,
        1041.5001220703125
      ],
      "bbox_max": [
        -1329.0,
        -3863.829345703125,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1335.0,
        -3884.681884765625,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3880.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826800584793091,
        0.923880934715271,
        0.0
      ],
      "plane_d": 4098.41162109375,
      "bbox_min": [
        -1373.20458984375,
        -3884.187255859375,
        1051.010986328125
      ],
      "bbox_max": [
        -1340.79541015625,
        -3874.0,
        1060.5374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826800584793091,
        0.923880934715271,
        0.0
      ],
      "plane_d": 3059.81787109375,
      "bbox_min": [
        -1373.20458984375,
        -3884.187255859375,
        1051.010986328125
      ],
      "bbox_max": [
        -1340.79541015625,
        -3874.0,
        1060.5374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08096685260534286,
        0.19547328352928162,
        0.9773610234260559
      ],
      "plane_d": -167.401123046875,
      "bbox_min": [
        -1373.20458984375,
        -3884.187255859375,
        1057.03662109375
      ],
      "bbox_max": [
        -1340.79541015625,
        -3874.0,
        1060.5374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08096685260534286,
        0.1954732984304428,
        0.9773610234260559
      ],
      "plane_d": -387.14508056640625,
      "bbox_min": [
        -1373.20458984375,
        -3884.187255859375,
        1057.03662109375
      ],
      "bbox_max": [
        -1340.79541015625,
        -3874.0,
        1060.5374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1954732984304428,
        0.08096685260534286,
        0.9773610234260559
      ],
      "plane_d": -458.13287353515625,
      "bbox_min": [
        -1373.20458984375,
        -3882.68701171875,
        1057.03662109375
      ],
      "bbox_max": [
        -1340.79541015625,
        -3880.443603515625,
        1059.134521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1954732984304428,
        0.08096685260534286,
        0.9773610234260559
      ],
      "plane_d": -988.6473999023438,
      "bbox_min": [
        -1373.20458984375,
        -3882.68701171875,
        1057.03662109375
      ],
      "bbox_max": [
        -1340.79541015625,
        -3880.443603515625,
        1059.134521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880934715271,
        0.3826800584793091,
        0.0
      ],
      "plane_d": 2724.302734375,
      "bbox_min": [
        -1373.20458984375,
        -3882.008544921875,
        1057.03662109375
      ],
      "bbox_max": [
        -1340.79541015625,
        -3880.443603515625,
        1058.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880934715271,
        0.3826800584793091,
        0.0
      ],
      "plane_d": 216.8896484375,
      "bbox_min": [
        -1373.20458984375,
        -3882.008544921875,
        1057.03662109375
      ],
      "bbox_max": [
        -1372.556396484375,
        -3880.443603515625,
        1058.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880934715271,
        0.3826800584793091,
        0.0
      ],
      "plane_d": 2724.302734375,
      "bbox_min": [
        -1395.0,
        -3924.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880934715271,
        -0.3826800584793091,
        0.0
      ],
      "plane_d": -257.5404052734375,
      "bbox_min": [
        -1395.0,
        -3924.0,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -3869.67041015625,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826800584793091,
        -0.923880934715271,
        0.0
      ],
      "plane_d": -3100.468505859375,
      "bbox_min": [
        -1395.0,
        -3922.32958984375,
        977.5
      ],
      "bbox_max": [
        -1335.0,
        -3869.67041015625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826800584793091,
        -0.923880934715271,
        -0.0
      ],
      "plane_d": -4139.0625,
      "bbox_min": [
        -1395.0,
        -3920.164794921875,
        977.5
      ],
      "bbox_max": [
        -1335.0,
        -3869.67041015625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880934715271,
        -0.3826800584793091,
        -0.0
      ],
      "plane_d": -2764.953369140625,
      "bbox_min": [
        -1395.0,
        -3918.0,
        977.5
      ],
      "bbox_max": [
        -1335.0,
        -3869.67041015625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880934715271,
        0.3826800584793091,
        0.0
      ],
      "plane_d": 216.8896484375,
      "bbox_min": [
        -1381.164794921875,
        -3918.0,
        977.5
      ],
      "bbox_max": [
        -1335.0,
        -3869.67041015625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826800584793091,
        0.923880934715271,
        0.0
      ],
      "plane_d": 4098.41162109375,
      "bbox_min": [
        -1379.0,
        -3918.0,
        977.5
      ],
      "bbox_max": [
        -1335.0,
        -3869.67041015625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826800584793091,
        0.923880934715271,
        0.0
      ],
      "plane_d": 3059.81787109375,
      "bbox_min": [
        -1379.0,
        -3918.0,
        977.5
      ],
      "bbox_max": [
        -1335.0,
        -3871.835205078125,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1379.0,
        -3918.0,
        1058.5
      ],
      "bbox_max": [
        -1335.0,
        -3882.008544921875,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1377.34326171875,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1336.6568603515625,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1377.34326171875,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1336.6568603515625,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1375.6865234375,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1338.3135986328125,
        -3904.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08096685260534286,
        -0.1954732984304428,
        0.9773610234260559
      ],
      "plane_d": -1910.2730712890625,
      "bbox_min": [
        -1379.0,
        -3918.0,
        1058.5
      ],
      "bbox_max": [
        -1335.0,
        -3882.008544921875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08096685260534286,
        -0.1954732984304428,
        0.9773610234260559
      ],
      "plane_d": -1690.5289306640625,
      "bbox_min": [
        -1379.0,
        -3918.0,
        1058.5
      ],
      "bbox_max": [
        -1335.0,
        -3882.008544921875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19547328352928162,
        -0.08096685260534286,
        0.9773610234260559
      ],
      "plane_d": -1089.0267333984375,
      "bbox_min": [
        -1379.0,
        -3911.556396484375,
        1058.5
      ],
      "bbox_max": [
        -1335.0,
        -3882.008544921875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19547328352928162,
        -0.08096686005592346,
        0.9773610830307007
      ],
      "plane_d": -1619.541259765625,
      "bbox_min": [
        -1379.0,
        -3911.556396484375,
        1058.5
      ],
      "bbox_max": [
        -1335.0,
        -3882.008544921875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1954732984304428,
        0.08096685260534286,
        0.9773610234260559
      ],
      "plane_d": -458.13287353515625,
      "bbox_min": [
        -1379.0,
        -3896.0,
        1058.5
      ],
      "bbox_max": [
        -1335.0,
        -3882.008544921875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1954732984304428,
        0.08096685260534286,
        0.9773610234260559
      ],
      "plane_d": -988.6473999023438,
      "bbox_min": [
        -1379.0,
        -3896.0,
        1058.5
      ],
      "bbox_max": [
        -1343.68701171875,
        -3882.008544921875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08096685260534286,
        0.19547328352928162,
        0.9773610234260559
      ],
      "plane_d": -167.401123046875,
      "bbox_min": [
        -1370.31298828125,
        -3896.0,
        1059.134521484375
      ],
      "bbox_max": [
        -1343.68701171875,
        -3882.68701171875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08096685260534286,
        0.1954732984304428,
        0.9773610234260559
      ],
      "plane_d": -387.14508056640625,
      "bbox_min": [
        -1370.31298828125,
        -3896.0,
        1059.134521484375
      ],
      "bbox_max": [
        -1357.0,
        -3882.68701171875,
        1062.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21637113392353058,
        -0.21637113392353058,
        -0.9520330429077148
      ],
      "plane_d": -146.00723266601562,
      "bbox_min": [
        -1372.556396484375,
        -3880.443603515625,
        1035.5
      ],
      "bbox_max": [
        -1357.0,
        -3871.835205078125,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637116372585297,
        0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": 145.0552978515625,
      "bbox_min": [
        -1372.556396484375,
        -3880.443603515625,
        1035.5
      ],
      "bbox_max": [
        -1357.0,
        -3871.835205078125,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25936803221702576,
        -0.0,
        -0.9657785892486572
      ],
      "plane_d": 648.101318359375,
      "bbox_min": [
        -1370.9359130859375,
        -3876.531494140625,
        1035.5
      ],
      "bbox_max": [
        -1357.0,
        -3871.835205078125,
        1039.8201904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        0.9238817691802979,
        0.0
      ],
      "plane_d": 3055.82373046875,
      "bbox_min": [
        -1370.3916015625,
        -3875.21728515625,
        1036.903564453125
      ],
      "bbox_max": [
        -1362.2264404296875,
        -3871.835205078125,
        1039.8201904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.259367972612381,
        0.0,
        0.9657785296440125
      ],
      "plane_d": -649.0670776367188,
      "bbox_min": [
        -1370.9359130859375,
        -3876.531494140625,
        1036.5
      ],
      "bbox_max": [
        -1357.0,
        -3871.835205078125,
        1040.24267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        0.9238817691802979,
        0.0
      ],
      "plane_d": 3055.82373046875,
      "bbox_min": [
        -1370.3916015625,
        -3875.21728515625,
        1037.19580078125
      ],
      "bbox_max": [
        -1362.2264404296875,
        -3871.835205078125,
        1040.096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637116372585297,
        -0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": -1531.3885498046875,
      "bbox_min": [
        -1362.2264404296875,
        -3880.443603515625,
        1030.5
      ],
      "bbox_max": [
        -1341.443603515625,
        -3869.67041015625,
        1037.903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25936803221702576,
        -0.0,
        -0.9657785892486572
      ],
      "plane_d": 648.101318359375,
      "bbox_min": [
        -1362.2264404296875,
        -3880.443603515625,
        1030.5
      ],
      "bbox_max": [
        -1341.443603515625,
        -3869.67041015625,
        1037.903564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25936803221702576,
        0.0,
        0.9657785892486572
      ],
      "plane_d": -649.0670166015625,
      "bbox_min": [
        -1362.2264404296875,
        -3876.531494140625,
        1031.903564453125
      ],
      "bbox_max": [
        -1343.064208984375,
        -3869.67041015625,
        1037.903564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        0.9238817691802979,
        0.0
      ],
      "plane_d": 3055.82373046875,
      "bbox_min": [
        -1362.2264404296875,
        -3871.835205078125,
        1035.5
      ],
      "bbox_max": [
        -1357.0,
        -3869.67041015625,
        1037.903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21637116372585297,
        0.21637116372585297,
        -0.9520330429077148
      ],
      "plane_d": 1530.436279296875,
      "bbox_min": [
        -1357.0,
        -3880.443603515625,
        1030.5
      ],
      "bbox_max": [
        -1341.443603515625,
        -3874.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.25936803221702576,
        0.9657785892486572
      ],
      "plane_d": -0.189453125,
      "bbox_min": [
        -1381.164794921875,
        -3896.0,
        1039.096435546875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637116372585297,
        0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": 145.0552978515625,
      "bbox_min": [
        -1381.164794921875,
        -3896.0,
        1039.096435546875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.21637116372585297,
        -0.21637116372585297,
        -0.9520330429077148
      ],
      "plane_d": -146.00735473632812,
      "bbox_min": [
        -1381.164794921875,
        -3896.0,
        1039.096435546875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1045.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        0.9238817691802979,
        0.0
      ],
      "plane_d": 3055.82373046875,
      "bbox_min": [
        -1375.617919921875,
        -3877.382080078125,
        1039.096435546875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25936803221702576,
        -0.0,
        -0.9657785892486572
      ],
      "plane_d": 648.101318359375,
      "bbox_min": [
        -1375.617919921875,
        -3877.382080078125,
        1039.096435546875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1040.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.25936803221702576,
        -0.9657785892486572
      ],
      "plane_d": -0.77630615234375,
      "bbox_min": [
        -1381.164794921875,
        -3896.0,
        1040.5
      ],
      "bbox_max": [
        -1375.617919921875,
        -3877.382080078125,
        1045.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238817691802979,
        0.38267815113067627,
        0.0
      ],
      "plane_d": 212.881103515625,
      "bbox_min": [
        -1381.164794921875,
        -3890.773681640625,
        1040.5
      ],
      "bbox_max": [
        -1375.617919921875,
        -3877.382080078125,
        1044.8043212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        0.9238817691802979,
        0.0
      ],
      "plane_d": 3055.82373046875,
      "bbox_min": [
        -1375.617919921875,
        -3877.382080078125,
        1039.8201904296875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.259367972612381,
        0.0,
        0.9657785296440125
      ],
      "plane_d": -649.0670776367188,
      "bbox_min": [
        -1375.617919921875,
        -3877.382080078125,
        1040.096435546875
      ],
      "bbox_max": [
        -1370.3916015625,
        -3875.21728515625,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1395.0,
        -3911.556396484375,
        1010.5
      ],
      "bbox_max": [
        -1372.556396484375,
        -3890.773681640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1395.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1375.6865234375,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1390.799560546875,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1375.6865234375,
        -3904.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637113392353058,
        -0.21637113392353058,
        -0.9520330429077148
      ],
      "plane_d": 450.744384765625,
      "bbox_min": [
        -1383.32958984375,
        -3911.556396484375,
        1010.5
      ],
      "bbox_max": [
        -1372.556396484375,
        -3890.773681640625,
        1051.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.259367972612381,
        0.9657785296440125
      ],
      "plane_d": -0.18963623046875,
      "bbox_min": [
        -1383.32958984375,
        -3911.556396484375,
        1044.096435546875
      ],
      "bbox_max": [
        -1372.556396484375,
        -3890.773681640625,
        1051.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.25936803221702576,
        -0.9657785892486572
      ],
      "plane_d": -0.7763671875,
      "bbox_min": [
        -1383.32958984375,
        -3909.93603515625,
        1044.096435546875
      ],
      "bbox_max": [
        -1376.4683837890625,
        -3890.773681640625,
        1050.096435546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238817691802979,
        0.38267815113067627,
        0.0
      ],
      "plane_d": 212.881103515625,
      "bbox_min": [
        -1383.32958984375,
        -3896.0,
        1044.096435546875
      ],
      "bbox_max": [
        -1381.164794921875,
        -3890.773681640625,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1011.5,
      "bbox_min": [
        -1383.32958984375,
        -3911.556396484375,
        1010.5
      ],
      "bbox_max": [
        -1372.556396484375,
        -3896.0,
        1011.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3896.0,
      "bbox_min": [
        -1383.32958984375,
        -3896.0,
        1010.5
      ],
      "bbox_max": [
        -1379.0,
        -3896.0,
        1011.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25936803221702576,
        0.0,
        0.9657785892486572
      ],
      "plane_d": -1372.3074951171875,
      "bbox_min": [
        -1395.0,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3902.260009765625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637116372585297,
        -0.21637116372585297,
        -0.9520330429077148
      ],
      "plane_d": 450.7442626953125,
      "bbox_min": [
        -1377.78271484375,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3909.3916015625,
        1056.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.21637116372585297,
        0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": -451.69635009765625,
      "bbox_min": [
        -1377.78271484375,
        -3920.164794921875,
        1049.096435546875
      ],
      "bbox_max": [
        -1357.0,
        -3909.3916015625,
        1056.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238817691802979,
        -0.38267815113067627,
        0.0
      ],
      "plane_d": -2768.947021484375,
      "bbox_min": [
        -1377.78271484375,
        -3914.617919921875,
        1049.096435546875
      ],
      "bbox_max": [
        -1375.617919921875,
        -3909.3916015625,
        1051.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.25936803221702576,
        -0.9657785892486572
      ],
      "plane_d": -0.7763671875,
      "bbox_min": [
        -1377.78271484375,
        -3914.617919921875,
        1049.096435546875
      ],
      "bbox_max": [
        -1375.617919921875,
        -3909.3916015625,
        1050.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238817691802979,
        -0.38267815113067627,
        0.0
      ],
      "plane_d": -2768.947021484375,
      "bbox_min": [
        -1377.78271484375,
        -3914.617919921875,
        1049.8201904296875
      ],
      "bbox_max": [
        -1375.617919921875,
        -3909.3916015625,
        1051.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.259367972612381,
        0.9657785296440125
      ],
      "plane_d": -0.18963623046875,
      "bbox_min": [
        -1377.78271484375,
        -3914.617919921875,
        1050.096435546875
      ],
      "bbox_max": [
        -1375.617919921875,
        -3909.3916015625,
        1051.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25936803221702576,
        0.0,
        -0.9657785892486572
      ],
      "plane_d": 1371.341796875,
      "bbox_min": [
        -1377.78271484375,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3909.3916015625,
        1055.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        -0.9238817691802979,
        0.0
      ],
      "plane_d": -4143.06298828125,
      "bbox_min": [
        -1375.617919921875,
        -3920.164794921875,
        1050.5
      ],
      "bbox_max": [
        -1362.2265625,
        -3914.617919921875,
        1054.8040771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637116372585297,
        -0.21637116372585297,
        -0.9520330429077148
      ],
      "plane_d": 412.6629638671875,
      "bbox_min": [
        -1377.78271484375,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3909.3916015625,
        1016.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21637116372585297,
        0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": -413.61505126953125,
      "bbox_min": [
        -1377.78271484375,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3909.3916015625,
        1016.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25936803221702576,
        0.0,
        0.9657785892486572
      ],
      "plane_d": -1333.6763916015625,
      "bbox_min": [
        -1376.9066162109375,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3910.267578125,
        1016.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1010.4999389648438,
      "bbox_min": [
        -1376.9066162109375,
        -3914.617919921875,
        1010.5
      ],
      "bbox_max": [
        -1372.556396484375,
        -3910.267578125,
        1011.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1010.4999389648438,
      "bbox_min": [
        -1377.78271484375,
        -3911.506591796875,
        1010.5
      ],
      "bbox_max": [
        -1375.667724609375,
        -3909.3916015625,
        1010.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25936803221702576,
        0.0,
        -0.9657785892486572
      ],
      "plane_d": 1332.7105712890625,
      "bbox_min": [
        -1375.617919921875,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1357.0,
        -3914.617919921875,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        -0.9238817691802979,
        0.0
      ],
      "plane_d": -4143.06298828125,
      "bbox_min": [
        -1375.617919921875,
        -3920.164794921875,
        1010.5
      ],
      "bbox_max": [
        -1362.2265625,
        -3914.617919921875,
        1014.8041381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1395.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1390.799560546875,
        -3902.260009765625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1395.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1390.799560546875,
        -3902.260009765625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637113392353058,
        0.21637113392353058,
        -0.9520330429077148
      ],
      "plane_d": 2108.1474609375,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1014.0963745117188
      ],
      "bbox_max": [
        -1341.443603515625,
        -3911.556396484375,
        1056.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.259367972612381,
        0.0,
        0.9657785296440125
      ],
      "plane_d": -1333.67626953125,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1014.0963745117188
      ],
      "bbox_max": [
        -1341.443603515625,
        -3911.556396484375,
        1056.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25936803221702576,
        0.0,
        -0.9657785892486572
      ],
      "plane_d": 1332.7105712890625,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1014.0963745117188
      ],
      "bbox_max": [
        -1343.0640869140625,
        -3915.468505859375,
        1020.096435546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        -0.9238817691802979,
        0.0
      ],
      "plane_d": -4143.06298828125,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1014.0963745117188
      ],
      "bbox_max": [
        -1357.0,
        -3920.164794921875,
        1016.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21637116372585297,
        -0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": -2109.099609375,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1016.5
      ],
      "bbox_max": [
        -1341.443603515625,
        -3911.556396484375,
        1056.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1055.4998779296875,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1054.0963134765625
      ],
      "bbox_max": [
        -1341.443603515625,
        -3911.556396484375,
        1056.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267815113067627,
        -0.9238817691802979,
        0.0
      ],
      "plane_d": -4143.06298828125,
      "bbox_min": [
        -1362.2265625,
        -3922.32958984375,
        1054.0963134765625
      ],
      "bbox_max": [
        -1357.0,
        -3919.542236328125,
        1055.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1335.0,
        -3924.0,
        1022.6928100585938
      ],
      "bbox_max": [
        -1329.0,
        -3896.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1335.0,
        -3924.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3896.000732421875,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1329.0,
      "bbox_min": [
        -1329.0,
        -3924.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3910.485595703125,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.25936803221702576,
        0.9657785892486572
      ],
      "plane_d": -2001.86962890625,
      "bbox_min": [
        -1335.0,
        -3906.45263671875,
        1022.6928100585938
      ],
      "bbox_max": [
        -1332.8353271484375,
        -3896.0,
        1026.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.25936803221702576,
        -0.9657785892486572
      ],
      "plane_d": 2000.90380859375,
      "bbox_min": [
        -1335.0,
        -3906.45263671875,
        1022.6928100585938
      ],
      "bbox_max": [
        -1332.8353271484375,
        -3896.0,
        1025.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238817691802979,
        -0.38267815113067627,
        0.0
      ],
      "plane_d": -261.531982421875,
      "bbox_min": [
        -1335.0,
        -3906.45263671875,
        1022.6928100585938
      ],
      "bbox_max": [
        -1332.8353271484375,
        -3901.2265625,
        1025.0963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21637116372585297,
        -0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": -2109.099609375,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1019.096435546875
      ],
      "bbox_max": [
        -1335.0,
        -3896.0,
        1067.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21637116372585297,
        0.21637116372585297,
        -0.9520330429077148
      ],
      "plane_d": 2108.1474609375,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1019.096435546875
      ],
      "bbox_max": [
        -1335.0,
        -3896.0,
        1026.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38267815113067627,
        -0.9238817691802979,
        0.0
      ],
      "plane_d": -3104.474609375,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1019.096435546875
      ],
      "bbox_max": [
        -1338.382080078125,
        -3914.617919921875,
        1021.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25936803221702576,
        0.0,
        -0.9657785892486572
      ],
      "plane_d": 1332.7105712890625,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1019.096435546875
      ],
      "bbox_max": [
        -1338.382080078125,
        -3914.617919921875,
        1020.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.25936803221702576,
        -0.9657785892486572
      ],
      "plane_d": 2000.90380859375,
      "bbox_min": [
        -1338.382080078125,
        -3914.617919921875,
        1020.5
      ],
      "bbox_max": [
        -1335.0,
        -3896.0,
        1025.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238817691802979,
        -0.38267815113067627,
        0.0
      ],
      "plane_d": -261.531982421875,
      "bbox_min": [
        -1338.382080078125,
        -3914.617919921875,
        1020.5
      ],
      "bbox_max": [
        -1335.0,
        -3906.45263671875,
        1023.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.5,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1019.8204956054688
      ],
      "bbox_max": [
        -1335.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 3714.43212890625,
      "bbox_min": [
        -1341.443603515625,
        -3914.617919921875,
        1055.5
      ],
      "bbox_max": [
        -1338.382080078125,
        -3911.556396484375,
        1056.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267815113067627,
        -0.9238817691802979,
        0.0
      ],
      "plane_d": -3104.474609375,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1019.8204956054688
      ],
      "bbox_max": [
        -1338.382080078125,
        -3914.617919921875,
        1021.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.259367972612381,
        0.0,
        0.9657785296440125
      ],
      "plane_d": -1333.67626953125,
      "bbox_min": [
        -1343.6083984375,
        -3916.78271484375,
        1020.096435546875
      ],
      "bbox_max": [
        -1338.382080078125,
        -3914.617919921875,
        1021.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1338.3135986328125,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1338.3135986328125,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1338.3135986328125,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1336.6568603515625,
        -3900.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9875810146331787,
        -0.0,
        -0.1571105420589447
      ],
      "plane_d": -1105.8656005859375,
      "bbox_min": [
        -1343.6085205078125,
        -3924.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -993.2631225585938,
      "bbox_min": [
        -1277.7864990234375,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1263.0,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8660246729850769,
        0.5000013709068298
      ],
      "plane_d": 2881.94580078125,
      "bbox_min": [
        -1277.7864990234375,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1263.0,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8660246729850769,
        0.5000013709068298
      ],
      "plane_d": -3879.974609375,
      "bbox_min": [
        -1277.7864990234375,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1263.0,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8660246729850769,
        -0.5000013709068298
      ],
      "plane_d": 3870.44873046875,
      "bbox_min": [
        -1277.02880859375,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1263.0,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8660246729850769,
        -0.5000013709068298
      ],
      "plane_d": -2891.471923828125,
      "bbox_min": [
        -1277.02880859375,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1263.0,
        -3901.25,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 983.7368774414062,
      "bbox_min": [
        -1276.27099609375,
        -3906.75,
        983.7368774414062
      ],
      "bbox_max": [
        -1263.0,
        -3901.25,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5176934003829956,
        -0.8284903764724731,
        -0.21353508532047272
      ],
      "plane_d": -3660.0,
      "bbox_min": [
        -1343.6085205078125,
        -3911.111083984375,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5042335987091064,
        -0.8345399498939514,
        -0.22201697528362274
      ],
      "plane_d": -3657.353759765625,
      "bbox_min": [
        -1343.6085205078125,
        -3911.111083984375,
        977.5
      ],
      "bbox_max": [
        -1276.27099609375,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        -1343.6085205078125,
        -3911.111083984375,
        977.5
      ],
      "bbox_max": [
        -1276.27099609375,
        -3850.318359375,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1329.0,
      "bbox_min": [
        -1329.0,
        -3870.000732421875,
        977.5
      ],
      "bbox_max": [
        -1308.735107421875,
        -3850.318359375,
        1047.2711181640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19455039501190186,
        -0.6444506049156189,
        -0.739482045173645
      ],
      "plane_d": -1976.09521484375,
      "bbox_min": [
        -1318.47021484375,
        -3870.000732421875,
        1041.5
      ],
      "bbox_max": [
        -1315.6754150390625,
        -3863.82958984375,
        1047.2708740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3819081783294678,
        -0.6320832371711731,
        -0.6742530465126038
      ],
      "plane_d": -2242.99169921875,
      "bbox_min": [
        -1335.0,
        -3911.111083984375,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3868.8095703125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19455039501190186,
        -0.6444506049156189,
        -0.739482045173645
      ],
      "plane_d": -1976.09521484375,
      "bbox_min": [
        -1335.0,
        -3911.111083984375,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3868.917724609375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8660246729850769,
        0.5000013709068298
      ],
      "plane_d": 2881.94580078125,
      "bbox_min": [
        -1335.0,
        -3910.48583984375,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3868.917724609375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8660246729850769,
        0.5000013709068298
      ],
      "plane_d": -3879.974609375,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -993.2631225585938,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8660246729850769,
        -0.5000013709068298
      ],
      "plane_d": 3870.44873046875,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 983.7368774414062,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1276.27099609375,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8660246729850769,
        -0.5000013709068298
      ],
      "plane_d": -2891.471923828125,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1276.27099609375,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35899996757507324,
        0.0,
        0.9333375692367554
      ],
      "plane_d": -1399.924560546875,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19175128638744354,
        0.8454047441482544,
        0.49852004647254944
      ],
      "plane_d": 2550.39892578125,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19175128638744354,
        -0.8454047441482544,
        0.4985200762748718
      ],
      "plane_d": -4050.521240234375,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9223248958587646,
        0.0,
        0.3864155113697052
      ],
      "plane_d": -1605.2020263671875,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17947378754615784,
        0.8519628047943115,
        0.4918827414512634
      ],
      "plane_d": 2598.748046875,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        993.2631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.489383727312088,
        0.8476236462593079,
        0.20503129065036774
      ],
      "plane_d": 2455.074951171875,
      "bbox_min": [
        -1328.2420654296875,
        -3908.878173828125,
        983.737060546875
      ],
      "bbox_max": [
        -1322.9990234375,
        -3899.121826171875,
        990.0299682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48731523752212524,
        0.8486713171005249,
        0.2056233137845993
      ],
      "plane_d": 2461.318115234375,
      "bbox_min": [
        -1325.6055908203125,
        -3908.878173828125,
        985.95849609375
      ],
      "bbox_max": [
        -1322.9990234375,
        -3899.121826171875,
        990.0299682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48731523752212524,
        -0.8486713171005249,
        0.2056233137845993
      ],
      "plane_d": -4165.107421875,
      "bbox_min": [
        -1325.6055908203125,
        -3908.878173828125,
        985.9586181640625
      ],
      "bbox_max": [
        -1322.9990234375,
        -3906.75,
        990.0299682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17947378754615784,
        -0.8519628047943115,
        0.4918827414512634
      ],
      "plane_d": -4053.377685546875,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3906.75,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.489383727312088,
        -0.8476236462593079,
        0.20503129065036774
      ],
      "plane_d": -4163.1708984375,
      "bbox_min": [
        -1328.2421875,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1321.422607421875,
        -3906.75,
        987.7297973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19175128638744354,
        -0.8454047441482544,
        0.4985200762748718
      ],
      "plane_d": -4050.521240234375,
      "bbox_min": [
        -1322.9990234375,
        -3909.5,
        986.6619262695312
      ],
      "bbox_max": [
        -1321.422607421875,
        -3908.878173828125,
        987.7297973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1841132938861847,
        -0.8434944748878479,
        -0.5045982599258423
      ],
      "plane_d": -2556.332275390625,
      "bbox_min": [
        -1322.237548828125,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3906.75,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1315159946680069,
        -0.8585023283958435,
        -0.49565833806991577
      ],
      "plane_d": -2693.123779296875,
      "bbox_min": [
        -1322.237548828125,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1317.199951171875,
        -3906.75,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48347967863082886,
        -0.8497155904769897,
        -0.21031150221824646
      ],
      "plane_d": -2475.181884765625,
      "bbox_min": [
        -1322.237548828125,
        -3909.5,
        983.7368774414062
      ],
      "bbox_max": [
        -1319.3125,
        -3907.11181640625,
        986.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        -0.8660218715667725,
        -0.0
      ],
      "plane_d": -4047.970703125,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3901.25,
        983.737060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9223248958587646,
        0.0,
        0.3864155113697052
      ],
      "plane_d": -1605.2020263671875,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3901.25,
        983.737060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.489383727312088,
        -0.8476236462593079,
        0.20503129065036774
      ],
      "plane_d": -4163.1708984375,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3901.25,
        983.7368774414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1329.2630615234375,
      "bbox_min": [
        -1329.2630615234375,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3901.25,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1319.73681640625,
      "bbox_min": [
        -1324.5,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3901.25,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999966025352478,
        -0.8660274744033813,
        0.0
      ],
      "plane_d": -2723.48876953125,
      "bbox_min": [
        -1324.5,
        -3909.5,
        977.5000610351562
      ],
      "bbox_max": [
        -1319.73681640625,
        -3906.75,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4892273545265198,
        -0.8473743796348572,
        -0.206430122256279
      ],
      "plane_d": -2462.258544921875,
      "bbox_min": [
        -1324.5,
        -3909.5,
        981.300048828125
      ],
      "bbox_max": [
        -1319.73681640625,
        -3906.75,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48347967863082886,
        -0.8497155904769897,
        -0.21031150221824646
      ],
      "plane_d": -2475.181884765625,
      "bbox_min": [
        -1320.873291015625,
        -3907.999755859375,
        981.300048828125
      ],
      "bbox_max": [
        -1319.73681640625,
        -3906.75,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1315159946680069,
        -0.8585023283958435,
        -0.49565833806991577
      ],
      "plane_d": -2693.123779296875,
      "bbox_min": [
        -1319.73681640625,
        -3907.353271484375,
        983.063720703125
      ],
      "bbox_max": [
        -1317.199951171875,
        -3906.75,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48347967863082886,
        -0.8497155904769897,
        -0.21031150221824646
      ],
      "plane_d": -2475.181884765625,
      "bbox_min": [
        -1319.73681640625,
        -3907.353271484375,
        983.063720703125
      ],
      "bbox_max": [
        -1318.7274169921875,
        -3906.75,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1841132938861847,
        -0.8434944748878479,
        -0.5045982599258423
      ],
      "plane_d": -2556.332275390625,
      "bbox_min": [
        -1319.3125,
        -3907.11181640625,
        983.2938842773438
      ],
      "bbox_max": [
        -1318.7274169921875,
        -3906.75,
        983.7368774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9169987440109253,
        0.0,
        -0.3988903760910034
      ],
      "plane_d": 1601.628173828125,
      "bbox_min": [
        -1319.73681640625,
        -3907.1865234375,
        981.300048828125
      ],
      "bbox_max": [
        -1318.8695068359375,
        -3901.506103515625,
        983.2938842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48347967863082886,
        -0.8497155904769897,
        -0.21031150221824646
      ],
      "plane_d": -2475.181884765625,
      "bbox_min": [
        -1319.73681640625,
        -3907.1865234375,
        981.300048828125
      ],
      "bbox_max": [
        -1318.8695068359375,
        -3906.75,
        983.2938842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48731523752212524,
        0.8486713171005249,
        0.2056233137845993
      ],
      "plane_d": 2461.318115234375,
      "bbox_min": [
        -1329.2630615234375,
        -3904.85107421875,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17947378754615784,
        0.8519628047943115,
        0.4918827414512634
      ],
      "plane_d": 2598.748046875,
      "bbox_min": [
        -1329.2630615234375,
        -3904.85107421875,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9223248958587646,
        0.0,
        0.3864155113697052
      ],
      "plane_d": -1605.2020263671875,
      "bbox_min": [
        -1329.2630615234375,
        -3904.85107421875,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19175128638744354,
        0.8454047441482544,
        0.49852004647254944
      ],
      "plane_d": 2550.39892578125,
      "bbox_min": [
        -1324.5,
        -3904.85107421875,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999966025352478,
        0.8660274744033813,
        0.0
      ],
      "plane_d": 4038.45361328125,
      "bbox_min": [
        -1324.5,
        -3904.85107421875,
        977.5000610351562
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1319.73681640625,
      "bbox_min": [
        -1319.73681640625,
        -3904.85107421875,
        977.5000610351562
      ],
      "bbox_max": [
        -1318.998046875,
        -3901.25,
        982.9984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9169987440109253,
        0.0,
        -0.3988903760910034
      ],
      "plane_d": 1601.628173828125,
      "bbox_min": [
        -1319.73681640625,
        -3902.656982421875,
        981.300048828125
      ],
      "bbox_max": [
        -1318.998046875,
        -3901.25,
        982.9984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48347967863082886,
        0.8497155904769897,
        -0.21031150221824646
      ],
      "plane_d": 4159.3974609375,
      "bbox_min": [
        -1324.5,
        -3901.676513671875,
        981.300048828125
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9169987440109253,
        0.0,
        -0.3988903760910034
      ],
      "plane_d": 1601.628173828125,
      "bbox_min": [
        -1319.73681640625,
        -3901.676513671875,
        981.300048828125
      ],
      "bbox_max": [
        -1318.479248046875,
        -3901.25,
        983.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25646165013313293,
        0.0,
        -0.9665544033050537
      ],
      "plane_d": 1288.646484375,
      "bbox_min": [
        -1318.8695068359375,
        -3901.506103515625,
        983.2938842773438
      ],
      "bbox_max": [
        -1318.479248046875,
        -3901.25,
        983.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4892273545265198,
        0.8473743796348572,
        -0.206430122256279
      ],
      "plane_d": 4154.04052734375,
      "bbox_min": [
        -1324.5,
        -3901.4462890625,
        981.300048828125
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1315159797668457,
        0.8585023283958435,
        -0.49565833806991577
      ],
      "plane_d": 4010.0625,
      "bbox_min": [
        -1322.237548828125,
        -3901.4462890625,
        983.2938842773438
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1841133087873459,
        0.8434943556785583,
        -0.5045982599258423
      ],
      "plane_d": 4029.67236328125,
      "bbox_min": [
        -1322.237548828125,
        -3901.25,
        983.2938842773438
      ],
      "bbox_max": [
        -1317.199951171875,
        -3898.5,
        988.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": -1899.8505859375,
      "bbox_min": [
        -1335.0,
        -3910.48583984375,
        1024.0963134765625
      ],
      "bbox_max": [
        -1329.0,
        -3868.917724609375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1328.9998779296875,
      "bbox_min": [
        -1335.0,
        -3898.524169921875,
        1042.0234375
      ],
      "bbox_max": [
        -1329.0,
        -3868.917724609375,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1335.0,
        -3898.524169921875,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3884.681884765625,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1335.0,
        -3898.524169921875,
        1070.0
      ],
      "bbox_max": [
        -1329.0,
        -3894.30615234375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1333.9547119140625,
        -3910.48583984375,
        1070.0
      ],
      "bbox_max": [
        -1329.0,
        -3898.524169921875,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.259367972612381,
        0.9657785296440125
      ],
      "plane_d": -2001.8692626953125,
      "bbox_min": [
        -1335.0,
        -3901.2265625,
        1024.0963134765625
      ],
      "bbox_max": [
        -1330.67041015625,
        -3885.54736328125,
        1029.30712890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.25936803221702576,
        -0.9657785892486572
      ],
      "plane_d": 2000.90380859375,
      "bbox_min": [
        -1335.0,
        -3901.2265625,
        1024.0963134765625
      ],
      "bbox_max": [
        -1330.67041015625,
        -3885.54736328125,
        1029.30712890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238817691802979,
        0.38267815113067627,
        -0.0
      ],
      "plane_d": 2720.29638671875,
      "bbox_min": [
        -1335.0,
        -3901.2265625,
        1024.0963134765625
      ],
      "bbox_max": [
        -1330.67041015625,
        -3885.54736328125,
        1029.30712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238817691802979,
        -0.38267815113067627,
        0.0
      ],
      "plane_d": -261.531982421875,
      "bbox_min": [
        -1332.8353271484375,
        -3901.2265625,
        1024.0963134765625
      ],
      "bbox_max": [
        -1330.67041015625,
        -3896.0,
        1026.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21637116372585297,
        -0.21637116372585297,
        0.9520330429077148
      ],
      "plane_d": -1531.388427734375,
      "bbox_min": [
        -1343.6085205078125,
        -3896.0,
        1025.5
      ],
      "bbox_max": [
        -1335.0,
        -3875.21728515625,
        1032.903564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.21637113392353058,
        0.21637113392353058,
        -0.9520330429077148
      ],
      "plane_d": 1530.436279296875,
      "bbox_min": [
        -1343.6085205078125,
        -3896.0,
        1025.5
      ],
      "bbox_max": [
        -1335.0,
        -3875.21728515625,
        1032.903564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38267815113067627,
        0.9238817691802979,
        -0.0
      ],
      "plane_d": 4094.412109375,
      "bbox_min": [
        -1343.6085205078125,
        -3877.382080078125,
        1030.5
      ],
      "bbox_max": [
        -1338.382080078125,
        -3875.21728515625,
        1032.903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25936803221702576,
        0.0,
        0.9657785892486572
      ],
      "plane_d": -649.0670166015625,
      "bbox_min": [
        -1343.6085205078125,
        -3877.382080078125,
        1031.5
      ],
      "bbox_max": [
        -1338.382080078125,
        -3875.21728515625,
        1032.903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267815113067627,
        0.9238817691802979,
        -0.0
      ],
      "plane_d": 4094.412109375,
      "bbox_min": [
        -1343.6085205078125,
        -3877.382080078125,
        1030.5
      ],
      "bbox_max": [
        -1338.382080078125,
        -3875.21728515625,
        1032.1796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25936803221702576,
        -0.0,
        -0.9657785892486572
      ],
      "plane_d": 648.101318359375,
      "bbox_min": [
        -1343.6085205078125,
        -3877.382080078125,
        1030.5
      ],
      "bbox_max": [
        -1338.382080078125,
        -3875.21728515625,
        1031.903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.259367972612381,
        0.9657785296440125
      ],
      "plane_d": -2001.8692626953125,
      "bbox_min": [
        -1338.382080078125,
        -3896.0,
        1026.5
      ],
      "bbox_max": [
        -1335.0,
        -3877.382080078125,
        1031.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238817691802979,
        0.38267815113067627,
        -0.0
      ],
      "plane_d": 2720.29638671875,
      "bbox_min": [
        -1338.382080078125,
        -3885.54736328125,
        1028.8756103515625
      ],
      "bbox_max": [
        -1335.0,
        -3877.382080078125,
        1031.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9875810146331787,
        -0.0,
        -0.1571105420589447
      ],
      "plane_d": -1105.8656005859375,
      "bbox_min": [
        -1395.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.5,
      "bbox_min": [
        -1285.1422119140625,
        -4010.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1285.1422119140625,
        -4010.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1039.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4010.0,
      "bbox_min": [
        -1284.3466796875,
        -4010.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1034.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3930.0,
      "bbox_min": [
        -1284.3466796875,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1263.0,
        -3924.0,
        1034.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1282.3582763671875,
        -3930.0,
        1020.5
      ],
      "bbox_max": [
        -1273.8780517578125,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1282.3582763671875,
        -3930.0,
        1022.0
      ],
      "bbox_max": [
        -1274.705322265625,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4001.0,
      "bbox_min": [
        -1285.1422119140625,
        -4001.0,
        1034.5
      ],
      "bbox_max": [
        -1281.5994873046875,
        -3940.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3940.0,
      "bbox_min": [
        -1285.1422119140625,
        -3940.0,
        1034.5
      ],
      "bbox_max": [
        -1281.5994873046875,
        -3940.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1395.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3924.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1328.9998779296875,
      "bbox_min": [
        -1335.0,
        -4016.170166015625,
        1041.5001220703125
      ],
      "bbox_max": [
        -1329.0,
        -3985.693359375,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1334.9998779296875,
      "bbox_min": [
        -1335.0,
        -4016.170166015625,
        1041.5001220703125
      ],
      "bbox_max": [
        -1329.0,
        -3985.693359375,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1335.0,
        -4000.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3995.317626953125,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1353.0,
      "bbox_min": [
        -1395.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3924.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4010.0,
      "bbox_min": [
        -1353.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3924.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3930.0,
      "bbox_min": [
        -1353.0,
        -4010.0,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3924.0,
        1080.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        -1353.0,
        -4010.0,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3930.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5179993510246277,
        0.828294575214386,
        -0.21355277299880981
      ],
      "plane_d": 2867.3466796875,
      "bbox_min": [
        -1308.0,
        -4010.0,
        977.5
      ],
      "bbox_max": [
        -1275.27880859375,
        -3930.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1303.15771484375,
        -4010.0,
        1034.5
      ],
      "bbox_max": [
        -1284.3466796875,
        -3998.23583984375,
        1039.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4001.0,
      "bbox_min": [
        -1290.82763671875,
        -4001.0,
        1034.5
      ],
      "bbox_max": [
        -1284.3468017578125,
        -4001.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1308.0,
        -4010.0,
        1000.5
      ],
      "bbox_max": [
        -1284.3466796875,
        -3930.0,
        1039.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5042064785957336,
        0.8344950675964355,
        -0.2222469598054886
      ],
      "plane_d": 2918.916015625,
      "bbox_min": [
        -1289.9000244140625,
        -4002.7548828125,
        1030.4434814453125
      ],
      "bbox_max": [
        -1288.2711181640625,
        -4000.690185546875,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1014.5,
      "bbox_min": [
        -1308.0,
        -4010.0,
        1000.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3930.0,
        1034.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1008.5,
      "bbox_min": [
        -1308.0,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1290.5,
        -3930.0,
        1008.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1000.5,
      "bbox_min": [
        -1308.0,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1290.5,
        -3930.0,
        1008.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3940.0,
      "bbox_min": [
        -1308.0,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1290.5,
        -3930.0,
        1008.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3931.5,
      "bbox_min": [
        -1308.0,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1290.5,
        -3930.0,
        1008.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1308.0,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1291.5,
        -3930.0,
        1008.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1001.0,
      "bbox_min": [
        -1308.0,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1291.5,
        -3930.0,
        1008.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1291.5,
      "bbox_min": [
        -1291.5,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1291.5,
        -3930.0,
        1008.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        -1290.5,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1290.5,
        -3931.5,
        1008.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.5,
      "bbox_min": [
        -1308.0,
        -4010.0,
        1014.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3930.0,
        1034.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5042064785957336,
        0.8344950675964355,
        -0.2222469598054886
      ],
      "plane_d": 2918.916015625,
      "bbox_min": [
        -1303.6793212890625,
        -4010.0,
        1032.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -4001.67431640625,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3958.0,
      "bbox_min": [
        -1308.0,
        -4010.0,
        1014.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3930.0,
        1032.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5042064785957336,
        0.8344950675964355,
        -0.2222469598054886
      ],
      "plane_d": 2918.916015625,
      "bbox_min": [
        -1302.7977294921875,
        -4010.0,
        1016.2077026367188
      ],
      "bbox_max": [
        -1289.9000244140625,
        -4002.20703125,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3930.699951171875,
      "bbox_min": [
        -1308.0,
        -3954.0,
        1014.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3930.0,
        1032.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1301.0,
      "bbox_min": [
        -1306.0,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1293.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1298.5,
      "bbox_min": [
        -1298.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1293.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1293.5,
      "bbox_min": [
        -1298.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1293.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1030.5,
      "bbox_min": [
        -1298.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1293.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1298.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1293.5,
        -3930.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1306.0,
      "bbox_min": [
        -1306.0,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1301.0,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1030.5,
      "bbox_min": [
        -1306.0,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1301.0,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1306.0,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1301.0,
        -3930.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1293.5,
      "bbox_min": [
        -1293.5,
        -3954.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3934.0,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3949.0,
      "bbox_min": [
        -1293.5,
        -3954.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3934.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3944.0,
      "bbox_min": [
        -1293.5,
        -3949.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3934.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3934.0,
      "bbox_min": [
        -1293.5,
        -3944.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3934.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1293.5,
        -3944.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3934.0,
        1020.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3945.0,
      "bbox_min": [
        -1293.5,
        -3949.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3945.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1293.5,
        -3949.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3945.0,
        1020.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3950.0,
      "bbox_min": [
        -1293.5,
        -3954.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3950.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3954.0,
      "bbox_min": [
        -1293.5,
        -3954.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3950.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1293.5,
        -3954.0,
        1020.5
      ],
      "bbox_max": [
        -1289.9000244140625,
        -3950.0,
        1020.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3940.0,
      "bbox_min": [
        -1308.0,
        -4010.0,
        1034.5
      ],
      "bbox_max": [
        -1284.3468017578125,
        -3940.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5042064785957336,
        0.8344950675964355,
        -0.2222469598054886
      ],
      "plane_d": 2918.916015625,
      "bbox_min": [
        -1308.0,
        -4010.0,
        1034.5
      ],
      "bbox_max": [
        -1286.263427734375,
        -3998.1455078125,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4001.0,
      "bbox_min": [
        -1290.9879150390625,
        -4001.0,
        1034.5
      ],
      "bbox_max": [
        -1288.7667236328125,
        -4001.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4001.0,
      "bbox_min": [
        -1308.0,
        -4001.0,
        1034.5
      ],
      "bbox_max": [
        -1288.7841796875,
        -4001.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1353.0,
        -4010.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1039.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1014.5,
      "bbox_min": [
        -1353.0,
        -4008.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1034.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3931.5,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1014.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1311.5,
      "bbox_min": [
        -1311.5,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1008.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1311.5,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1008.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1001.0,
      "bbox_min": [
        -1311.5,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3940.0,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3931.5,
        1014.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.19996002316474915,
        -0.0,
        -0.9798040986061096
      ],
      "plane_d": 725.18505859375,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3931.5,
        1014.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1008.5,
      "bbox_min": [
        -1339.5,
        -3940.0,
        1008.5
      ],
      "bbox_max": [
        -1308.0,
        -3931.5,
        1014.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1339.5,
      "bbox_min": [
        -1339.5,
        -3940.0,
        1013.5
      ],
      "bbox_max": [
        -1339.5,
        -3931.5,
        1014.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19996002316474915,
        -0.0,
        0.9798040986061096
      ],
      "plane_d": -717.3465576171875,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3931.5,
        1014.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.5,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1005.5
      ],
      "bbox_max": [
        -1339.5,
        -3931.5,
        1007.5408325195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1349.5,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1005.5
      ],
      "bbox_max": [
        -1349.5,
        -3931.5,
        1007.5408325195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1000.5,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1000.5
      ],
      "bbox_max": [
        -1308.0,
        -3931.5,
        1014.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1349.5,
      "bbox_min": [
        -1349.5,
        -3940.0,
        1007.5408325195312
      ],
      "bbox_max": [
        -1349.5,
        -3931.5,
        1014.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4008.0,
      "bbox_min": [
        -1353.0,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.5,
      "bbox_min": [
        -1353.0,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1034.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3986.0,
      "bbox_min": [
        -1343.0352783203125,
        -4003.0,
        1032.5
      ],
      "bbox_max": [
        -1333.9647216796875,
        -3986.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.0,
      "bbox_min": [
        -1343.0352783203125,
        -4003.0,
        1032.5
      ],
      "bbox_max": [
        -1333.9647216796875,
        -4003.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1318.0,
      "bbox_min": [
        -1353.0,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1032.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1316.5,
      "bbox_min": [
        -1318.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1032.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1022.5,
      "bbox_min": [
        -1318.0,
        -3954.0,
        1014.5
      ],
      "bbox_max": [
        -1316.5,
        -3942.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": 3344.62646484375,
      "bbox_min": [
        -1318.0,
        -3954.0,
        1014.5
      ],
      "bbox_max": [
        -1316.5,
        -3942.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": -4048.62890625,
      "bbox_min": [
        -1318.0,
        -3954.0,
        1014.5
      ],
      "bbox_max": [
        -1316.5,
        -3942.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": -3333.390625,
      "bbox_min": [
        -1318.0,
        -3954.0,
        1018.5
      ],
      "bbox_max": [
        -1316.5,
        -3942.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": 4059.86474609375,
      "bbox_min": [
        -1318.0,
        -3954.0,
        1018.5
      ],
      "bbox_max": [
        -1316.5,
        -3952.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3958.0,
      "bbox_min": [
        -1316.5,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3930.699951171875,
      "bbox_min": [
        -1316.5,
        -3930.699951171875,
        1014.5
      ],
      "bbox_max": [
        -1308.0,
        -3930.0,
        1032.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1313.5,
      "bbox_min": [
        -1313.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1308.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1308.5,
      "bbox_min": [
        -1313.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1308.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1030.5,
      "bbox_min": [
        -1313.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1308.5,
        -3930.0,
        1030.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1313.5,
        -3930.699951171875,
        1022.0
      ],
      "bbox_max": [
        -1308.5,
        -3930.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3982.0,
      "bbox_min": [
        -1353.0,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3931.5,
        1032.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3958.0,
      "bbox_min": [
        -1353.0,
        -3982.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3931.5,
        1032.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1022.5,
      "bbox_min": [
        -1334.0,
        -3982.0,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3958.0,
        1022.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1595.4464111328125,
      "bbox_min": [
        -1334.0,
        -3982.0,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3958.0,
        1022.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -880.2078857421875,
      "bbox_min": [
        -1334.0,
        -3982.0,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3958.0,
        1022.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        -0.3511234521865845
      ],
      "plane_d": 1606.682373046875,
      "bbox_min": [
        -1334.0,
        -3982.0,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3958.0,
        1022.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": 891.44384765625,
      "bbox_min": [
        -1334.0,
        -3982.0,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3958.0,
        1022.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3963.0,
      "bbox_min": [
        -1334.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3961.5,
        1022.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3961.5,
      "bbox_min": [
        -1334.0,
        -3963.0,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3961.5,
        1022.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -881.144287109375,
      "bbox_min": [
        -1333.0,
        -3963.0,
        1014.5
      ],
      "bbox_max": [
        -1323.0,
        -3961.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1596.3826904296875,
      "bbox_min": [
        -1333.0,
        -3963.0,
        1014.5
      ],
      "bbox_max": [
        -1323.0,
        -3961.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        -0.3511234521865845
      ],
      "plane_d": 1605.74609375,
      "bbox_min": [
        -1333.0,
        -3963.0,
        1014.5
      ],
      "bbox_max": [
        -1331.5,
        -3961.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        -0.0,
        0.3511234521865845
      ],
      "plane_d": 890.507568359375,
      "bbox_min": [
        -1333.0,
        -3963.0,
        1014.5
      ],
      "bbox_max": [
        -1331.5,
        -3961.5,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3978.5,
      "bbox_min": [
        -1334.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3977.0,
        1022.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3977.0,
      "bbox_min": [
        -1334.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3977.0,
        1022.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -881.144287109375,
      "bbox_min": [
        -1333.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1323.0,
        -3977.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1596.3826904296875,
      "bbox_min": [
        -1333.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1323.0,
        -3977.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        -0.3511234521865845
      ],
      "plane_d": 1605.74609375,
      "bbox_min": [
        -1333.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1331.5,
        -3977.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        -0.0,
        0.3511234521865845
      ],
      "plane_d": 890.507568359375,
      "bbox_min": [
        -1333.0,
        -3978.5,
        1014.5
      ],
      "bbox_max": [
        -1331.5,
        -3977.0,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3931.5,
      "bbox_min": [
        -1353.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3931.5,
        1032.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3956.5,
      "bbox_min": [
        -1335.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1032.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1323.5,
      "bbox_min": [
        -1335.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3956.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        -0.0,
        0.3511234521865845
      ],
      "plane_d": 879.2716064453125,
      "bbox_min": [
        -1323.5,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3956.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1595.4464111328125,
      "bbox_min": [
        -1323.5,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3956.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        -0.3511234521865845
      ],
      "plane_d": 1594.510009765625,
      "bbox_min": [
        -1322.5,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3956.5,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -880.2078857421875,
      "bbox_min": [
        -1323.5,
        -3958.0,
        1018.5
      ],
      "bbox_max": [
        -1322.0,
        -3956.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1322.5,
      "bbox_min": [
        -1322.5,
        -3958.0,
        1022.5
      ],
      "bbox_max": [
        -1322.5,
        -3956.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1332.5,
      "bbox_min": [
        -1335.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1332.5,
        -3956.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1607.6187744140625,
      "bbox_min": [
        -1335.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1332.5,
        -3956.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        -0.0,
        0.3511234521865845
      ],
      "plane_d": 891.4439697265625,
      "bbox_min": [
        -1335.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1332.5,
        -3956.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -892.3802490234375,
      "bbox_min": [
        -1335.0,
        -3958.0,
        1014.5
      ],
      "bbox_max": [
        -1333.5,
        -3956.5,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        -0.3511234521865845
      ],
      "plane_d": 1606.682373046875,
      "bbox_min": [
        -1334.0,
        -3958.0,
        1018.5
      ],
      "bbox_max": [
        -1332.5,
        -3956.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1333.5,
      "bbox_min": [
        -1333.5,
        -3958.0,
        1022.5
      ],
      "bbox_max": [
        -1333.5,
        -3956.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3952.5,
      "bbox_min": [
        -1319.5,
        -3955.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1319.5,
      "bbox_min": [
        -1319.5,
        -3955.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3952.5,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": -4060.801025390625,
      "bbox_min": [
        -1319.5,
        -3955.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3952.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": 3344.626220703125,
      "bbox_min": [
        -1319.5,
        -3955.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3952.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": -3345.5625,
      "bbox_min": [
        -1319.5,
        -3955.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3953.5,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": 4059.86474609375,
      "bbox_min": [
        -1319.5,
        -3954.0,
        1018.5
      ],
      "bbox_max": [
        -1318.0,
        -3952.5,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3953.5,
      "bbox_min": [
        -1319.5,
        -3953.5,
        1022.5
      ],
      "bbox_max": [
        -1318.0,
        -3953.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1319.5,
      "bbox_min": [
        -1319.5,
        -3943.5,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3943.5,
      "bbox_min": [
        -1319.5,
        -3943.5,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": 3332.4541015625,
      "bbox_min": [
        -1319.5,
        -3943.5,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": -4048.62890625,
      "bbox_min": [
        -1319.5,
        -3943.5,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": 4047.692626953125,
      "bbox_min": [
        -1319.5,
        -3942.5,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3941.0,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": -3333.390625,
      "bbox_min": [
        -1319.5,
        -3943.5,
        1018.5
      ],
      "bbox_max": [
        -1318.0,
        -3942.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3942.5,
      "bbox_min": [
        -1319.5,
        -3942.5,
        1022.5
      ],
      "bbox_max": [
        -1318.0,
        -3942.5,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3998.0,
      "bbox_min": [
        -1352.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1328.0,
      "bbox_min": [
        -1352.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1318.0,
        -3998.0,
        1024.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1024.5,
      "bbox_min": [
        -1328.0,
        -4008.0,
        1024.5
      ],
      "bbox_max": [
        -1318.0,
        -3998.0,
        1024.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1019.5,
      "bbox_min": [
        -1352.5,
        -4005.0,
        1014.5
      ],
      "bbox_max": [
        -1347.5,
        -4000.0,
        1019.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4000.0,
      "bbox_min": [
        -1352.5,
        -4005.0,
        1014.5
      ],
      "bbox_max": [
        -1347.5,
        -4000.0,
        1019.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1347.5,
      "bbox_min": [
        -1352.5,
        -4005.0,
        1014.5
      ],
      "bbox_max": [
        -1347.5,
        -4000.0,
        1019.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1352.5,
      "bbox_min": [
        -1352.5,
        -4005.0,
        1014.5
      ],
      "bbox_max": [
        -1347.5,
        -4000.0,
        1019.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4005.0,
      "bbox_min": [
        -1352.5,
        -4005.0,
        1014.5
      ],
      "bbox_max": [
        -1347.5,
        -4005.0,
        1019.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1332.5,
      "bbox_min": [
        -1335.0,
        -3984.0,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3983.5,
      "bbox_min": [
        -1335.0,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1332.5,
        -3982.0,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1607.6187744140625,
      "bbox_min": [
        -1335.0,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1332.5,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        -0.0,
        0.3511234521865845
      ],
      "plane_d": 891.4439697265625,
      "bbox_min": [
        -1335.0,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1332.5,
        -3982.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -892.3802490234375,
      "bbox_min": [
        -1335.0,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1333.5,
        -3982.0,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        -0.3511234521865845
      ],
      "plane_d": 1606.682373046875,
      "bbox_min": [
        -1334.0,
        -3983.5,
        1018.5
      ],
      "bbox_max": [
        -1332.5,
        -3982.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1333.5,
      "bbox_min": [
        -1333.5,
        -3983.5,
        1022.5
      ],
      "bbox_max": [
        -1333.5,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1323.5,
      "bbox_min": [
        -1331.4000244140625,
        -3984.0,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3983.5,
      "bbox_min": [
        -1323.5,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3982.0,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.936329185962677,
        -0.0,
        -0.3511234521865845
      ],
      "plane_d": -880.2078857421875,
      "bbox_min": [
        -1323.5,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1321.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1322.5,
      "bbox_min": [
        -1322.5,
        -3983.5,
        1018.5
      ],
      "bbox_max": [
        -1321.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        -0.0,
        0.3511234521865845
      ],
      "plane_d": 879.2716064453125,
      "bbox_min": [
        -1322.5,
        -3983.5,
        1018.5
      ],
      "bbox_max": [
        -1321.0,
        -3982.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1595.4464111328125,
      "bbox_min": [
        -1323.5,
        -3983.5,
        1014.5
      ],
      "bbox_max": [
        -1322.0,
        -3982.0,
        1018.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9958953261375427,
        -0.09051333367824554
      ],
      "plane_d": -3874.19189453125,
      "bbox_min": [
        -1331.4000244140625,
        -3984.0,
        1023.699951171875
      ],
      "bbox_max": [
        -1324.5999755859375,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1331.4000244140625,
      "bbox_min": [
        -1331.4000244140625,
        -3984.0,
        1023.699951171875
      ],
      "bbox_max": [
        -1324.5999755859375,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 1324.599853515625,
      "bbox_min": [
        -1331.4000244140625,
        -3984.0,
        1023.699951171875
      ],
      "bbox_max": [
        -1324.5999755859375,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1023.699951171875,
      "bbox_min": [
        -1331.4000244140625,
        -3983.2001953125,
        1023.699951171875
      ],
      "bbox_max": [
        -1324.5999755859375,
        -3982.0,
        1023.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2631174325942993,
        0.0,
        0.964763879776001
      ],
      "plane_d": -1353.607666015625,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3936.0,
        1039.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1333.0,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3936.0,
        1039.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1344.0,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3936.0,
        1039.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3936.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1333.9647216796875,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3986.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4004.0,
      "bbox_min": [
        -1333.9647216796875,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -4004.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1343.0352783203125,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.9647216796875,
        -3986.0,
        1039.2369384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4004.0,
      "bbox_min": [
        -1344.0,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1343.0352783203125,
        -4004.0,
        1036.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.0,
      "bbox_min": [
        -1343.0352783203125,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.9647216796875,
        -3986.0,
        1039.2369384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4004.0,
      "bbox_min": [
        -1343.0352783203125,
        -4004.0,
        1034.5
      ],
      "bbox_max": [
        -1333.9647216796875,
        -4004.0,
        1039.2369384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3986.0,
      "bbox_min": [
        -1343.0352783203125,
        -3986.0,
        1034.5
      ],
      "bbox_max": [
        -1333.9647216796875,
        -3986.0,
        1039.2369384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3955.0,
      "bbox_min": [
        -1344.0,
        -3955.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3936.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3936.0,
      "bbox_min": [
        -1344.0,
        -3936.0,
        1034.5
      ],
      "bbox_max": [
        -1333.0,
        -3936.0,
        1039.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.381908118724823,
        0.6320831179618835,
        -0.6742529273033142
      ],
      "plane_d": 2737.823486328125,
      "bbox_min": [
        -1353.0,
        -4010.0,
        1039.5
      ],
      "bbox_max": [
        -1285.1422119140625,
        -3930.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1353.0,
        -4010.0,
        1039.5
      ],
      "bbox_max": [
        -1285.1422119140625,
        -3930.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        -1353.0,
        -3995.31787109375,
        1061.0
      ],
      "bbox_max": [
        -1306.6944580078125,
        -3930.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1329.0,
      "bbox_min": [
        -1335.0,
        -3995.31787109375,
        1061.0
      ],
      "bbox_max": [
        -1306.6944580078125,
        -3930.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1335.0,
        -3985.693359375,
        1070.0
      ],
      "bbox_max": [
        -1329.0,
        -3930.0,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19455038011074066,
        0.6444506049156189,
        -0.7394819855690002
      ],
      "plane_d": 3102.17529296875,
      "bbox_min": [
        -1326.9375,
        -3995.31787109375,
        1061.0
      ],
      "bbox_max": [
        -1306.6944580078125,
        -3968.888916015625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3942.0,
      "bbox_min": [
        -1353.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1353.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3938.0,
      "bbox_min": [
        -1353.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1353.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3938.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3980.0,
      "bbox_min": [
        -1353.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1353.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3976.0,
      "bbox_min": [
        -1353.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1353.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1335.0,
        -3976.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": 3512.24560546875,
      "bbox_min": [
        -1335.0,
        -4010.0,
        1039.5
      ],
      "bbox_max": [
        -1285.1422119140625,
        -3991.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19455038011074066,
        0.6444506049156189,
        -0.7394819855690002
      ],
      "plane_d": 3102.17529296875,
      "bbox_min": [
        -1322.0220947265625,
        -4010.0,
        1046.5244140625
      ],
      "bbox_max": [
        -1311.7691650390625,
        -3992.22265625,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5042064785957336,
        0.8344950675964355,
        -0.2222469598054886
      ],
      "plane_d": 2918.916015625,
      "bbox_min": [
        -1306.764892578125,
        -4010.0,
        1039.5
      ],
      "bbox_max": [
        -1285.1422119140625,
        -3997.127685546875,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5179993510246277,
        0.828294575214386,
        -0.21355277299880981
      ],
      "plane_d": 2867.3466796875,
      "bbox_min": [
        -1286.263427734375,
        -3998.1455078125,
        1039.5
      ],
      "bbox_max": [
        -1285.1422119140625,
        -3997.127685546875,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1353.0,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1282.1195068359375,
        -3924.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1353.0,
        -3930.0,
        1022.0
      ],
      "bbox_max": [
        -1282.3582763671875,
        -3924.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        -1335.0,
        -3930.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3924.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1329.0,
      "bbox_min": [
        -1335.0,
        -3930.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3924.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1335.0,
        -3930.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3924.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1335.0,
        -3930.0,
        1061.0
      ],
      "bbox_max": [
        -1329.0,
        -3924.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9941445589065552,
        0.10805919766426086
      ],
      "plane_d": 3796.389404296875,
      "bbox_min": [
        -1348.5,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1290.5,
        -3925.0,
        1000.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1326.5,
      "bbox_min": [
        -1348.5,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1290.5,
        -3925.0,
        1000.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1348.4998779296875,
      "bbox_min": [
        -1348.5,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1326.5,
        -3925.0,
        1000.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1000.5,
      "bbox_min": [
        -1348.5,
        -3930.0,
        1000.5
      ],
      "bbox_max": [
        -1326.5,
        -3927.5,
        1000.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1312.4998779296875,
      "bbox_min": [
        -1312.5,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1290.5,
        -3925.0,
        1000.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1290.5,
      "bbox_min": [
        -1312.5,
        -3930.0,
        977.5
      ],
      "bbox_max": [
        -1290.5,
        -3925.0,
        1000.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1000.5,
      "bbox_min": [
        -1312.5,
        -3930.0,
        1000.5
      ],
      "bbox_max": [
        -1290.5,
        -3927.5,
        1000.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        -1335.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -4010.0,
        1047.27001953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1335.0,
        -4024.199951171875,
        977.5
      ],
      "bbox_max": [
        -1329.0,
        -4010.0,
        1043.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": 3512.24560546875,
      "bbox_min": [
        -1335.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1329.0,
        -4010.0,
        1043.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5042064785957336,
        0.8344950675964355,
        -0.2222469598054886
      ],
      "plane_d": 2918.916015625,
      "bbox_min": [
        -1318.4700927734375,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1279.6585693359375,
        -4010.0,
        1047.2701416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5179993510246277,
        0.828294575214386,
        -0.21355277299880981
      ],
      "plane_d": 2867.3466796875,
      "bbox_min": [
        -1318.4700927734375,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1279.6585693359375,
        -4010.0,
        1047.2701416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.381908118724823,
        0.6320831179618835,
        -0.6742529273033142
      ],
      "plane_d": 2737.823486328125,
      "bbox_min": [
        -1318.4700927734375,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1306.764892578125,
        -4010.0,
        1047.2701416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19455038011074066,
        0.6444506049156189,
        -0.7394819855690002
      ],
      "plane_d": 3102.17529296875,
      "bbox_min": [
        -1318.4700927734375,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1315.6353759765625,
        -4010.0,
        1047.2701416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3976.0,
      "bbox_min": [
        -1395.0,
        -4010.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3980.0,
      "bbox_min": [
        -1395.0,
        -4010.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1395.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1353.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1395.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1353.0,
        -3976.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.7682212591171265
      ],
      "plane_d": -94.4912109375,
      "bbox_min": [
        -1365.0,
        -4010.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3980.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4010.0,
      "bbox_min": [
        -1365.0,
        -4010.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3980.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1365.0,
        -4010.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3980.0,
        1034.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 2191.3515625,
      "bbox_min": [
        -1365.0,
        -4008.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3980.0,
        1034.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1014.5,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.5,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1363.5,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -2142.839111328125,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3982.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4008.0,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3988.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1027.0
      ],
      "bbox_max": [
        -1360.0,
        -3988.0,
        1032.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.0,
      "bbox_min": [
        -1363.5,
        -4008.0,
        1027.0
      ],
      "bbox_max": [
        -1360.0,
        -3988.0,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1395.0,
        -3960.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3942.0,
      "bbox_min": [
        -1395.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1353.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1395.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1353.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3938.0,
      "bbox_min": [
        -1395.0,
        -3938.0,
        1063.0
      ],
      "bbox_max": [
        -1353.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.768221378326416
      ],
      "plane_d": -94.49114990234375,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.5,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1034.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.7682213187217712,
        5.527507696001521e-08
      ],
      "plane_d": -3908.325927734375,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3930.0,
        1014.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3930.0,
      "bbox_min": [
        -1365.0,
        -3930.0,
        1004.5
      ],
      "bbox_max": [
        -1353.0,
        -3930.0,
        1014.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3930.0,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1034.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.5,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3930.0,
        1034.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6401807069778442,
        -0.7682243585586548,
        -6.004658189340262e-06
      ],
      "plane_d": -3908.326904296875,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1032.5
      ],
      "bbox_max": [
        -1353.0,
        -3950.0,
        1034.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1365.0,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3930.0,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3931.5,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3931.5,
        1032.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6401807069778442,
        -0.7682243585586548,
        -6.004658189340262e-06
      ],
      "plane_d": -3908.326904296875,
      "bbox_min": [
        -1365.0,
        -3960.0,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3931.5,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1363.5,
      "bbox_min": [
        -1365.0,
        -3958.333251953125,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3931.5,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1022.0,
      "bbox_min": [
        -1365.0,
        -3951.25,
        1017.0
      ],
      "bbox_max": [
        -1363.5,
        -3935.0,
        1022.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3935.0,
      "bbox_min": [
        -1365.0,
        -3935.0,
        1017.0
      ],
      "bbox_max": [
        -1363.5,
        -3935.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        0.7592566013336182,
        0.0
      ],
      "plane_d": 3885.658447265625,
      "bbox_min": [
        -1363.5,
        -3958.333251953125,
        1014.5
      ],
      "bbox_max": [
        -1353.0,
        -3949.0,
        1032.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1022.0,
      "bbox_min": [
        -1363.5,
        -3958.333251953125,
        1017.0
      ],
      "bbox_max": [
        -1355.0,
        -3949.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1016.9999389648438,
      "bbox_min": [
        -1363.5,
        -3958.333251953125,
        1017.0
      ],
      "bbox_max": [
        -1355.0,
        -3949.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1355.0,
      "bbox_min": [
        -1355.0,
        -3958.333251953125,
        1017.0
      ],
      "bbox_max": [
        -1355.0,
        -3956.28564453125,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -1365.0,
        -3930.0,
        1020.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1020.5,
      "bbox_min": [
        -1365.0,
        -3930.0,
        1020.5
      ],
      "bbox_max": [
        -1353.0,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1365.0,
      "bbox_min": [
        -1365.0,
        -3930.0,
        1020.5
      ],
      "bbox_max": [
        -1365.0,
        -3924.0,
        1022.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.0,
      "bbox_min": [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1395.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.9793568849563599,
        -0.20213910937309265
      ],
      "plane_d": -3578.41748046875,
      "bbox_min": [
        -1401.0,
        -4024.199951171875,
        977.5
      ],
      "bbox_max": [
        -1395.0,
        -3855.60009765625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1401.0,
        -3870.000732421875,
        1041.5
      ],
      "bbox_max": [
        -1395.0,
        -3863.82958984375,
        1047.2708740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1401.0,
        -4024.199951171875,
        977.5
      ],
      "bbox_max": [
        -1395.0,
        -3868.917724609375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1401.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1395.0,
        -4010.019287109375,
        1047.252197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1401.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1395.0,
        -3868.917724609375,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1401.0,
        -4000.0,
        1061.0
      ],
      "bbox_max": [
        -1395.0,
        -3880.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1401.0,
        -3995.31787109375,
        1061.0
      ],
      "bbox_max": [
        -1395.0,
        -3884.68212890625,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1401.0,
        -3980.0,
        1061.0
      ],
      "bbox_max": [
        -1395.0,
        -3884.68212890625,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3942.0,
      "bbox_min": [
        -1401.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1401.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1401.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1401.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1401.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3900.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1401.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3938.0,
      "bbox_min": [
        -1401.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1401.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3938.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3980.0,
      "bbox_min": [
        -1401.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1401.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3976.0,
      "bbox_min": [
        -1401.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1401.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1395.0,
        -3976.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1401.0,
        -3985.693603515625,
        1070.0
      ],
      "bbox_max": [
        -1395.0,
        -3894.306396484375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1401.0,
        -3905.0,
        1070.0
      ],
      "bbox_max": [
        -1395.0,
        -3894.306396484375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": -1899.8505859375,
      "bbox_min": [
        -1401.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1395.0,
        -3868.917724609375,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1401.0,
        -3884.68212890625,
        1047.2708740234375
      ],
      "bbox_max": [
        -1395.0,
        -3870.000732421875,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": 3512.24560546875,
      "bbox_min": [
        -1401.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1395.0,
        -3991.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1401.0,
        -4010.019287109375,
        1047.252197265625
      ],
      "bbox_max": [
        -1395.0,
        -3995.31787109375,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1460.9998779296875,
      "bbox_min": [
        -1467.0,
        -4016.170166015625,
        1041.5001220703125
      ],
      "bbox_max": [
        -1461.0,
        -3985.693359375,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1467.0,
        -4000.0,
        1061.0
      ],
      "bbox_max": [
        -1461.0,
        -3995.317626953125,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1460.9998779296875,
      "bbox_min": [
        -1467.0,
        -3894.30615234375,
        1041.5001220703125
      ],
      "bbox_max": [
        -1461.0,
        -3863.829345703125,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1467.0,
        -3884.681884765625,
        1061.0
      ],
      "bbox_max": [
        -1461.0,
        -3880.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9793568849563599,
        -0.20213910937309265
      ],
      "plane_d": -3578.41748046875,
      "bbox_min": [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -3850.318359375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3870.000732421875,
        977.5
      ],
      "bbox_max": [
        -1461.0,
        -3850.318359375,
        1047.2711181640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1467.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1401.0,
        -3868.917724609375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1461.0,
        -4010.019287109375,
        1047.251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1467.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1401.0,
        -3868.917724609375,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1467.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3886.820556640625,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3942.0,
      "bbox_min": [
        -1467.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1467.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1467.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3900.0,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3938.0,
      "bbox_min": [
        -1467.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3904.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3938.0,
        1067.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3938.0,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3904.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3980.0,
      "bbox_min": [
        -1467.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3942.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3976.0,
      "bbox_min": [
        -1467.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1401.0,
        -3942.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3976.0,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3942.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1461.0,
        -3980.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1467.0,
        -3988.9013671875,
        1067.0
      ],
      "bbox_max": [
        -1461.0,
        -3891.09814453125,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1467.0,
        -3985.693359375,
        1070.0
      ],
      "bbox_max": [
        -1461.0,
        -3894.30615234375,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1467.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1461.0,
        -3868.917724609375,
        1063.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1461.0,
      "bbox_min": [
        -1461.0,
        -3995.317626953125,
        1061.0
      ],
      "bbox_max": [
        -1461.0,
        -3884.681884765625,
        1063.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": -1899.8505859375,
      "bbox_min": [
        -1467.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1461.0,
        -3868.917724609375,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1460.9998779296875,
      "bbox_min": [
        -1461.0,
        -3889.0,
        1042.0234375
      ],
      "bbox_max": [
        -1461.0,
        -3868.917724609375,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": 3512.24560546875,
      "bbox_min": [
        -1467.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1461.0,
        -3991.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1460.9998779296875,
      "bbox_min": [
        -1461.0,
        -4011.082275390625,
        1042.0234375
      ],
      "bbox_max": [
        -1461.0,
        -3991.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1599.0,
      "bbox_min": [
        -1708.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1467.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1533.0,
      "bbox_min": [
        -1599.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1467.0,
        -3850.318359375,
        1080.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.9793568849563599,
        -0.20213910937309265
      ],
      "plane_d": -3578.41748046875,
      "bbox_min": [
        -1533.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -3850.318359375,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1533.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -4011.188720703125,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1527.0,
        -4011.188720703125,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": 3503.8427734375,
      "bbox_min": [
        -1533.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1467.0,
        -3863.829345703125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1526.9998779296875,
      "bbox_min": [
        -1533.0,
        -4016.170166015625,
        1041.5
      ],
      "bbox_max": [
        -1527.0,
        -3985.693359375,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1533.0,
        -4000.0,
        1061.0
      ],
      "bbox_max": [
        -1527.0,
        -3995.317626953125,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6830222606658936,
        -0.7303975820541382
      ],
      "plane_d": -1878.3724365234375,
      "bbox_min": [
        -1533.0,
        -4016.170166015625,
        1041.5
      ],
      "bbox_max": [
        -1467.0,
        -3863.829345703125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1526.9998779296875,
      "bbox_min": [
        -1533.0,
        -3894.30615234375,
        1041.5
      ],
      "bbox_max": [
        -1527.0,
        -3863.829345703125,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1533.0,
        -3884.681884765625,
        1061.0
      ],
      "bbox_max": [
        -1527.0,
        -3880.0,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1533.0,
        -4016.170166015625,
        1041.5
      ],
      "bbox_max": [
        -1467.0,
        -3863.829345703125,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1533.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3886.820556640625,
        1070.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3942.0,
      "bbox_min": [
        -1533.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1533.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1533.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3900.0,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3886.820556640625,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3938.0,
      "bbox_min": [
        -1533.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3904.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3938.0,
        1067.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3938.0,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3904.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3980.0,
      "bbox_min": [
        -1533.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3942.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3976.0,
      "bbox_min": [
        -1533.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1467.0,
        -3942.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3976.0,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3942.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3993.178955078125,
        1063.0
      ],
      "bbox_max": [
        -1527.0,
        -3980.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1533.0,
        -3988.9013671875,
        1067.0
      ],
      "bbox_max": [
        -1527.0,
        -3891.09814453125,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1533.0,
        -3985.693359375,
        1070.0
      ],
      "bbox_max": [
        -1527.0,
        -3894.30615234375,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1533.0,
        -4016.170166015625,
        1041.5
      ],
      "bbox_max": [
        -1527.0,
        -3863.829345703125,
        1063.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        -1527.0,
        -3995.317626953125,
        1061.0
      ],
      "bbox_max": [
        -1527.0,
        -3884.681884765625,
        1063.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": 3512.24560546875,
      "bbox_min": [
        -1533.0,
        -4011.188720703125,
        1041.5
      ],
      "bbox_max": [
        -1527.0,
        -3868.8095703125,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9793568849563599,
        -0.20213910937309265
      ],
      "plane_d": -3578.41748046875,
      "bbox_min": [
        -1533.0,
        -4011.188720703125,
        1041.5
      ],
      "bbox_max": [
        -1527.0,
        -3868.8095703125,
        1042.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1533.0,
        -4011.188720703125,
        1041.5
      ],
      "bbox_max": [
        -1527.0,
        -4011.082275390625,
        1042.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1593.0,
      "bbox_min": [
        -1599.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1585.6051025390625,
        -3850.318359375,
        1041.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.32654091715812683,
        0.9268454313278198,
        -0.18528002500534058
      ],
      "plane_d": 4435.1943359375,
      "bbox_min": [
        -1593.0,
        -4029.699951171875,
        977.5
      ],
      "bbox_max": [
        -1589.92041015625,
        -3850.318603515625,
        981.0108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32630154490470886,
        -0.9269324541091919,
        -0.18526557087898254
      ],
      "plane_d": -2869.0947265625,
      "bbox_min": [
        -1593.0,
        -3852.1044921875,
        977.5
      ],
      "bbox_max": [
        -1589.92041015625,
        -3850.318603515625,
        981.0108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9793568849563599,
        -0.20213910937309265
      ],
      "plane_d": -3578.41748046875,
      "bbox_min": [
        -1599.0,
        -4028.614990234375,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -3851.40283203125,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2933264374732971,
        -0.9312068223953247,
        -0.2163643091917038
      ],
      "plane_d": -2907.5810546875,
      "bbox_min": [
        -1599.0,
        -3868.048828125,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -3851.40283203125,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32630154490470886,
        -0.9269324541091919,
        -0.18526557087898254
      ],
      "plane_d": -2869.0947265625,
      "bbox_min": [
        -1599.0,
        -3855.583740234375,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -3851.40283203125,
        987.85107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1599.0,
        -4028.614990234375,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -3938.40869140625,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2933092713356018,
        0.93115234375,
        -0.21662162244319916
      ],
      "plane_d": 4430.3505859375,
      "bbox_min": [
        -1599.0,
        -4028.614990234375,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -4011.951171875,
        1041.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32654091715812683,
        0.9268454313278198,
        -0.18528002500534058
      ],
      "plane_d": 4435.1943359375,
      "bbox_min": [
        -1599.0,
        -4028.614990234375,
        977.5
      ],
      "bbox_max": [
        -1593.0,
        -4024.431884765625,
        987.85107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923877477645874,
        0.3826882839202881,
        -0.0
      ],
      "plane_d": 2984.462890625,
      "bbox_min": [
        -1599.0,
        -3941.59130859375,
        1030.0
      ],
      "bbox_max": [
        -1598.3408203125,
        -3938.40869140625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923877477645874,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -31.1207275390625,
      "bbox_min": [
        -1599.0,
        -3941.59130859375,
        1030.0
      ],
      "bbox_max": [
        -1598.3408203125,
        -3938.40869140625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1599.0,
        -3941.59130859375,
        1030.0
      ],
      "bbox_max": [
        -1598.3408203125,
        -3938.40869140625,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -1599.0,
        -3941.59130859375,
        1032.0
      ],
      "bbox_max": [
        -1598.3408203125,
        -3938.40869140625,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1593.0,
      "bbox_min": [
        -1599.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1533.0,
        -3863.829345703125,
        1080.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3942.0,
      "bbox_min": [
        -1593.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1533.0,
        -3863.82958984375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3938.0,
      "bbox_min": [
        -1593.0,
        -3942.0,
        1041.5
      ],
      "bbox_max": [
        -1533.0,
        -3863.82958984375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1593.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3938.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1593.0,
        -3942.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3938.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1593.0,
        -3907.8505859375,
        1041.5
      ],
      "bbox_max": [
        -1533.0,
        -3863.82958984375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1593.0,
        -3907.8505859375,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3900.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3904.0,
      "bbox_min": [
        -1593.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3900.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1593.0,
        -3904.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3900.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097343683242798,
        -0.6642122864723206,
        -0.7419878840446472
      ],
      "plane_d": -1649.374755859375,
      "bbox_min": [
        -1593.0,
        -3907.8505859375,
        1072.9722900390625
      ],
      "bbox_max": [
        -1572.1875,
        -3900.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097343683242798,
        -0.6642122864723206,
        -0.7419878840446472
      ],
      "plane_d": -1649.374755859375,
      "bbox_min": [
        -1593.0,
        -3900.0,
        1041.5
      ],
      "bbox_max": [
        -1573.8170166015625,
        -3863.82958984375,
        1075.3243408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023941576480865,
        -0.6991816163063049,
        -0.6801761984825134
      ],
      "plane_d": -1643.9022216796875,
      "bbox_min": [
        -1593.0,
        -3875.035888671875,
        1041.5
      ],
      "bbox_max": [
        -1585.6051025390625,
        -3863.82958984375,
        1050.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3980.0,
      "bbox_min": [
        -1593.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1533.0,
        -3972.1494140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.0,
      "bbox_min": [
        -1593.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3972.1494140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3976.0,
      "bbox_min": [
        -1593.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3976.0,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -1593.0,
        -3980.0,
        1063.0
      ],
      "bbox_max": [
        -1533.0,
        -3976.0,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1593.0,
        -3980.0,
        1072.9722900390625
      ],
      "bbox_max": [
        -1572.1875,
        -3972.1494140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1593.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1573.8170166015625,
        -3980.0,
        1075.3243408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023940086364746,
        0.6991816163063049,
        -0.6801762580871582
      ],
      "plane_d": 3865.648681640625,
      "bbox_min": [
        -1593.0,
        -4016.17041015625,
        1041.5
      ],
      "bbox_max": [
        -1585.6051025390625,
        -4004.964111328125,
        1050.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1061.0,
      "bbox_min": [
        -1599.0,
        -4013.841064453125,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -3866.158935546875,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -1599.0,
        -4000.0,
        1061.0
      ],
      "bbox_max": [
        -1593.0,
        -3880.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1599.0,
        -3993.374267578125,
        1061.0
      ],
      "bbox_max": [
        -1593.0,
        -3886.625732421875,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097343683242798,
        -0.6642122864723206,
        -0.7419878840446472
      ],
      "plane_d": -1649.374755859375,
      "bbox_min": [
        -1599.0,
        -3897.50146484375,
        1061.0
      ],
      "bbox_max": [
        -1593.0,
        -3886.625732421875,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1599.0,
        -3983.3203125,
        1070.0
      ],
      "bbox_max": [
        -1593.0,
        -3896.6796875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097343683242798,
        -0.6642122864723206,
        -0.7419878840446472
      ],
      "plane_d": -1649.374755859375,
      "bbox_min": [
        -1599.0,
        -3908.67236328125,
        1070.0
      ],
      "bbox_max": [
        -1593.0,
        -3896.6796875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": -1899.8505859375,
      "bbox_min": [
        -1599.0,
        -4013.841064453125,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -3866.158935546875,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023941576480865,
        -0.6991816163063049,
        -0.6801761984825134
      ],
      "plane_d": -1643.9022216796875,
      "bbox_min": [
        -1599.0,
        -3887.44775390625,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -3866.158935546875,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097343683242798,
        -0.6642122864723206,
        -0.7419878840446472
      ],
      "plane_d": -1649.374755859375,
      "bbox_min": [
        -1599.0,
        -3887.44775390625,
        1050.625
      ],
      "bbox_max": [
        -1593.0,
        -3875.035888671875,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6868142485618591,
        -0.7268330454826355
      ],
      "plane_d": 3512.24560546875,
      "bbox_min": [
        -1599.0,
        -4013.841064453125,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -3868.8095703125,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023940086364746,
        0.6991816163063049,
        -0.6801762580871582
      ],
      "plane_d": 3865.648681640625,
      "bbox_min": [
        -1599.0,
        -4013.841064453125,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -3992.55224609375,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1599.0,
        -4004.964111328125,
        1050.625
      ],
      "bbox_max": [
        -1593.0,
        -3992.55224609375,
        1061.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9793568849563599,
        -0.20213910937309265
      ],
      "plane_d": -3578.41748046875,
      "bbox_min": [
        -1599.0,
        -4011.188720703125,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -3868.8095703125,
        1042.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9799537658691406,
        -0.1992255449295044
      ],
      "plane_d": 4138.27294921875,
      "bbox_min": [
        -1599.0,
        -4011.188720703125,
        1041.5
      ],
      "bbox_max": [
        -1593.0,
        -4011.082275390625,
        1042.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9931105375289917,
        0.0,
        -0.11718130111694336
      ],
      "plane_d": 1756.7628173828125,
      "bbox_min": [
        -1663.0,
        -4026.5009765625,
        977.5
      ],
      "bbox_max": [
        -1599.0,
        -3853.514892578125,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.41036465764045715,
        0.0,
        -0.911921501159668
      ],
      "plane_d": 1630.834716796875,
      "bbox_min": [
        -1663.0,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1045.0,
      "bbox_min": [
        -1663.0,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3944.5,
      "bbox_min": [
        -1663.0,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3945.0,
      "bbox_min": [
        -1649.5,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1645.64599609375,
        -3944.5,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        -1649.5,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1646.825927734375,
        -3944.5,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1035.5,
      "bbox_min": [
        -1663.0,
        -3944.5,
        1035.0
      ],
      "bbox_max": [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        -1649.5,
        -3944.5,
        1035.0
      ],
      "bbox_max": [
        -1646.7669677734375,
        -3935.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3935.0,
      "bbox_min": [
        -1649.5,
        -3935.0,
        1035.0
      ],
      "bbox_max": [
        -1646.7669677734375,
        -3935.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3935.5,
      "bbox_min": [
        -1663.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3935.0,
      "bbox_min": [
        -1649.5,
        -3935.0,
        1035.5
      ],
      "bbox_max": [
        -1645.64599609375,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1605.0,
      "bbox_min": [
        -1640.0,
        -3988.083984375,
        1065.0
      ],
      "bbox_max": [
        -1599.0,
        -3891.916015625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7962279915809631,
        0.0,
        -0.6049966812133789
      ],
      "plane_d": 1940.7421875,
      "bbox_min": [
        -1640.0,
        -3987.199951171875,
        1065.0
      ],
      "bbox_max": [
        -1605.0,
        -3892.800048828125,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1640.0,
        -3900.0,
        1065.0
      ],
      "bbox_max": [
        -1616.805419921875,
        -3900.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023940086364746,
        0.6991816163063049,
        -0.6801762580871582
      ],
      "plane_d": 3865.648681640625,
      "bbox_min": [
        -1628.2030029296875,
        -3987.199951171875,
        1065.0
      ],
      "bbox_max": [
        -1605.0,
        -3892.800048828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3978.0,
      "bbox_min": [
        -1626.2440185546875,
        -3978.0,
        1067.577880859375
      ],
      "bbox_max": [
        -1605.0,
        -3978.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1628.2027587890625,
        -3986.779296875,
        1065.0
      ],
      "bbox_max": [
        -1605.0,
        -3893.220703125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3978.0,
      "bbox_min": [
        -1610.7938232421875,
        -3978.0,
        1072.580810546875
      ],
      "bbox_max": [
        -1605.0,
        -3978.0,
        1074.4569091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3978.0,
      "bbox_min": [
        -1628.2027587890625,
        -3978.0,
        1065.0
      ],
      "bbox_max": [
        -1605.0,
        -3978.0,
        1073.2911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023941576480865,
        -0.6991816163063049,
        -0.6801761984825134
      ],
      "plane_d": -1643.9022216796875,
      "bbox_min": [
        -1605.0,
        -3893.220703125,
        1065.0
      ],
      "bbox_max": [
        -1604.6495361328125,
        -3892.689697265625,
        1065.4324951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2933092713356018,
        0.93115234375,
        -0.21662162244319916
      ],
      "plane_d": 4430.3505859375,
      "bbox_min": [
        -1646.825927734375,
        -4024.431884765625,
        987.85107421875
      ],
      "bbox_max": [
        -1599.0,
        -3855.583740234375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2933264374732971,
        -0.9312068223953247,
        -0.2163643091917038
      ],
      "plane_d": -2907.5810546875,
      "bbox_min": [
        -1646.825927734375,
        -4011.951171875,
        987.85107421875
      ],
      "bbox_max": [
        -1599.0,
        -3855.583740234375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023940086364746,
        0.6991816163063049,
        -0.6801762580871582
      ],
      "plane_d": 3865.648681640625,
      "bbox_min": [
        -1646.825927734375,
        -4011.951171875,
        1016.0
      ],
      "bbox_max": [
        -1599.0,
        -3868.048828125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22023941576480865,
        -0.6991816163063049,
        -0.6801761984825134
      ],
      "plane_d": -1643.9022216796875,
      "bbox_min": [
        -1646.825927734375,
        -3997.127685546875,
        1016.0
      ],
      "bbox_max": [
        -1599.0,
        -3868.048828125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.796227753162384,
        0.0,
        -0.604996919631958
      ],
      "plane_d": 1940.7421875,
      "bbox_min": [
        -1646.825927734375,
        -3997.127685546875,
        1016.0
      ],
      "bbox_max": [
        -1599.0,
        -3882.872314453125,
        1065.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.3826828598976135,
        0.0
      ],
      "plane_d": -2.7730712890625,
      "bbox_min": [
        -1646.0589599609375,
        -3951.016357421875,
        1041.5001220703125
      ],
      "bbox_max": [
        -1628.203125,
        -3928.983642578125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        -0.3826828598976135,
        0.0
      ],
      "plane_d": -3018.31396484375,
      "bbox_min": [
        -1635.0,
        -3951.016357421875,
        1056.0546875
      ],
      "bbox_max": [
        -1628.203125,
        -3928.983642578125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826885223388672,
        0.9238774180412292,
        0.0
      ],
      "plane_d": 3006.8046875,
      "bbox_min": [
        -1630.8995361328125,
        -3951.016357421875,
        1061.4512939453125
      ],
      "bbox_max": [
        -1628.203125,
        -3928.983642578125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826885223388672,
        -0.9238774180412292,
        0.0
      ],
      "plane_d": -4273.34912109375,
      "bbox_min": [
        -1630.8995361328125,
        -3951.016357421875,
        1061.4512939453125
      ],
      "bbox_max": [
        -1628.203125,
        -3949.8994140625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1045.0,
      "bbox_min": [
        -1646.0589599609375,
        -3945.0,
        1041.5001220703125
      ],
      "bbox_max": [
        -1643.399658203125,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3945.0,
      "bbox_min": [
        -1646.0589599609375,
        -3945.0,
        1041.5001220703125
      ],
      "bbox_max": [
        -1643.399658203125,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3935.0,
      "bbox_min": [
        -1645.7049560546875,
        -3935.0,
        1044.5
      ],
      "bbox_max": [
        -1643.399658203125,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3935.5,
      "bbox_min": [
        -1646.0589599609375,
        -3944.5,
        1041.5001220703125
      ],
      "bbox_max": [
        -1643.779541015625,
        -3935.0,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3935.0,
      "bbox_min": [
        -1646.0589599609375,
        -3935.0,
        1041.5001220703125
      ],
      "bbox_max": [
        -1643.779541015625,
        -3935.0,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3944.5,
      "bbox_min": [
        -1646.0589599609375,
        -3944.5,
        1041.5001220703125
      ],
      "bbox_max": [
        -1643.779541015625,
        -3944.5,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923879861831665,
        0.3826828598976135,
        -0.0
      ],
      "plane_d": 2992.4453125,
      "bbox_min": [
        -1646.825927734375,
        -3995.87158203125,
        1016.0
      ],
      "bbox_max": [
        -1599.0,
        -3921.67041015625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923879861831665,
        -0.3826828598976135,
        0.0
      ],
      "plane_d": -23.0955810546875,
      "bbox_min": [
        -1646.825927734375,
        -3995.87158203125,
        1016.0
      ],
      "bbox_max": [
        -1599.0,
        -3921.67041015625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826885223388672,
        -0.9238774180412292,
        0.0
      ],
      "plane_d": -3032.67333984375,
      "bbox_min": [
        -1646.825927734375,
        -3962.6591796875,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3921.67041015625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826885223388672,
        0.9238774180412292,
        0.0
      ],
      "plane_d": 3006.8046875,
      "bbox_min": [
        -1646.825927734375,
        -3958.32958984375,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3921.67041015625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.3826828598976135,
        0.0
      ],
      "plane_d": -2.7730712890625,
      "bbox_min": [
        -1646.825927734375,
        -3958.32958984375,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3926.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826885223388672,
        -0.9238774180412292,
        0.0
      ],
      "plane_d": -4273.34912109375,
      "bbox_min": [
        -1639.3294677734375,
        -3958.32958984375,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3926.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        -0.3826828598976135,
        0.0
      ],
      "plane_d": -3018.31396484375,
      "bbox_min": [
        -1637.8992919921875,
        -3954.0,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3926.0,
        1061.4512939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35741060972213745,
        0.8628520965576172,
        -0.35741281509399414
      ],
      "plane_d": 4335.05517578125,
      "bbox_min": [
        -1635.0,
        -3954.0,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3926.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35741204023361206,
        0.8628554940223694,
        -0.3574032187461853
      ],
      "plane_d": 3176.330810546875,
      "bbox_min": [
        -1635.0,
        -3954.0,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3926.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35741060972213745,
        -0.8628520965576172,
        -0.35741281509399414
      ],
      "plane_d": -3622.944580078125,
      "bbox_min": [
        -1635.0,
        -3954.0,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3930.1005859375,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35741204023361206,
        -0.8628554940223694,
        -0.3574032187461853
      ],
      "plane_d": -2464.240478515625,
      "bbox_min": [
        -1635.0,
        -3954.0,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3930.1005859375,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8628560900688171,
        0.35740599036216736,
        -0.3574078679084778
      ],
      "plane_d": 3162.91943359375,
      "bbox_min": [
        -1635.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3930.1005859375,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8628572821617126,
        0.35740652680397034,
        -0.35740429162979126
      ],
      "plane_d": 365.5364990234375,
      "bbox_min": [
        -1635.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3930.1005859375,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8628560900688171,
        -0.35740599036216736,
        -0.3574078679084778
      ],
      "plane_d": -2450.819091796875,
      "bbox_min": [
        -1635.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3930.1005859375,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8628572821617126,
        -0.35740652680397034,
        -0.35740429162979126
      ],
      "plane_d": 346.556396484375,
      "bbox_min": [
        -1630.8995361328125,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1607.0,
        -3930.1005859375,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3779645562171936,
        0.1565602421760559,
        -0.9124865531921387
      ],
      "plane_d": 2156.6142578125,
      "bbox_min": [
        -1630.8995361328125,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1611.1004638671875,
        -3930.1005859375,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3779645264148712,
        0.1565602570772171,
        -0.9124864339828491
      ],
      "plane_d": 931.2531127929688,
      "bbox_min": [
        -1630.8995361328125,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1611.1004638671875,
        -3930.1005859375,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3779645562171936,
        -0.1565602421760559,
        -0.9124865531921387
      ],
      "plane_d": -302.44158935546875,
      "bbox_min": [
        -1630.8995361328125,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1611.1004638671875,
        -3930.1005859375,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3779645264148712,
        -0.1565602570772171,
        -0.9124864339828491
      ],
      "plane_d": 922.9192504882812,
      "bbox_min": [
        -1628.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1611.1004638671875,
        -3930.1005859375,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15655545890331268,
        0.37796884775161743,
        -0.9124855995178223
      ],
      "plane_d": 2670.058837890625,
      "bbox_min": [
        -1628.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1614.0,
        -3930.1005859375,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1565553843975067,
        0.37796884775161743,
        -0.9124855399131775
      ],
      "plane_d": 2162.50634765625,
      "bbox_min": [
        -1628.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1614.0,
        -3930.1005859375,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15655545890331268,
        -0.37796884775161743,
        -0.9124855995178223
      ],
      "plane_d": -815.8883056640625,
      "bbox_min": [
        -1628.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1614.0,
        -3940.0,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1565553843975067,
        -0.37796884775161743,
        -0.9124855399131775
      ],
      "plane_d": -308.3356628417969,
      "bbox_min": [
        -1621.0,
        -3949.8994140625,
        1016.0
      ],
      "bbox_max": [
        -1614.0,
        -3940.0,
        1020.1005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -1637.8992919921875,
        -3949.8994140625,
        1032.0
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3940.0,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1639.3294677734375,
        -3958.32958984375,
        1030.0
      ],
      "bbox_max": [
        -1621.0,
        -3946.999755859375,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -1639.3294677734375,
        -3958.32958984375,
        1030.0
      ],
      "bbox_max": [
        -1621.0,
        -3946.999755859375,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923877477645874,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -3026.33154296875,
      "bbox_min": [
        -1639.3294677734375,
        -3956.022216796875,
        1030.0
      ],
      "bbox_max": [
        -1637.0224609375,
        -3950.45263671875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1643.6591796875,
        -3950.45263671875,
        1030.0
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3930.1005859375,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923877477645874,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -3026.33154296875,
      "bbox_min": [
        -1643.6591796875,
        -3950.45263671875,
        1030.0
      ],
      "bbox_max": [
        -1639.3294677734375,
        -3934.43017578125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923877477645874,
        0.3826882839202881,
        0.0
      ],
      "plane_d": -10.747802734375,
      "bbox_min": [
        -1643.6591796875,
        -3940.0,
        1030.0
      ],
      "bbox_max": [
        -1641.35205078125,
        -3934.43017578125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        -1646.825927734375,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1640.0,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1045.0,
      "bbox_min": [
        -1646.7669677734375,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1640.0,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1639.9998779296875,
      "bbox_min": [
        -1646.7669677734375,
        -3945.0,
        1035.0
      ],
      "bbox_max": [
        -1640.0,
        -3935.0,
        1045.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1035.5,
      "bbox_min": [
        -1646.7669677734375,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1640.0,
        -3935.5,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3935.5,
      "bbox_min": [
        -1643.9351806640625,
        -3935.5,
        1035.5
      ],
      "bbox_max": [
        -1640.0,
        -3935.5,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1641.35205078125,
        -3934.43017578125,
        1030.0
      ],
      "bbox_max": [
        -1621.0,
        -3921.67041015625,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923877477645874,
        0.3826882839202881,
        0.0
      ],
      "plane_d": -10.747802734375,
      "bbox_min": [
        -1641.35205078125,
        -3934.43017578125,
        1030.0
      ],
      "bbox_max": [
        -1631.452392578125,
        -3921.67041015625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38269534707069397,
        0.9238746166229248,
        0.0
      ],
      "plane_d": 2998.782470703125,
      "bbox_min": [
        -1637.0224609375,
        -3923.977783203125,
        1030.0
      ],
      "bbox_max": [
        -1631.452392578125,
        -3921.67041015625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3935.0,
      "bbox_min": [
        -1646.825927734375,
        -3936.69775390625,
        1035.0
      ],
      "bbox_max": [
        -1642.7271728515625,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1045.0,
      "bbox_min": [
        -1643.399658203125,
        -3935.278564453125,
        1045.0
      ],
      "bbox_max": [
        -1642.727294921875,
        -3935.0,
        1045.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1031.9998779296875,
      "bbox_min": [
        -1631.4520263671875,
        -3962.6591796875,
        1030.0
      ],
      "bbox_max": [
        -1611.1004638671875,
        -3949.8994140625,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38269534707069397,
        -0.9238746166229248,
        0.0
      ],
      "plane_d": -4281.349609375,
      "bbox_min": [
        -1631.4520263671875,
        -3962.6591796875,
        1030.0
      ],
      "bbox_max": [
        -1615.429931640625,
        -3958.32958984375,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269534707069397,
        -0.9238746166229248,
        0.0
      ],
      "plane_d": -3040.65087890625,
      "bbox_min": [
        -1621.0,
        -3962.6591796875,
        1030.0
      ],
      "bbox_max": [
        -1615.429931640625,
        -3960.351806640625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1615.429931640625,
        -3960.351806640625,
        1030.0
      ],
      "bbox_max": [
        -1602.67041015625,
        -3940.0,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38269534707069397,
        -0.9238746166229248,
        0.0
      ],
      "plane_d": -3040.65087890625,
      "bbox_min": [
        -1615.429931640625,
        -3960.351806640625,
        1030.0
      ],
      "bbox_max": [
        -1602.67041015625,
        -3950.452392578125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923877477645874,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -31.1207275390625,
      "bbox_min": [
        -1604.9775390625,
        -3956.022216796875,
        1030.0
      ],
      "bbox_max": [
        -1602.67041015625,
        -3950.452392578125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097342938184738,
        0.664212167263031,
        -0.7419878840446472
      ],
      "plane_d": 3584.61767578125,
      "bbox_min": [
        -1604.6495361328125,
        -3995.87158203125,
        1058.0286865234375
      ],
      "bbox_max": [
        -1599.0,
        -3987.310302734375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1611.1004638671875,
        -3950.452392578125,
        1030.0
      ],
      "bbox_max": [
        -1599.0,
        -3930.1005859375,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -1611.1004638671875,
        -3950.452392578125,
        1030.0
      ],
      "bbox_max": [
        -1599.0,
        -3930.1005859375,
        1032.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923877477645874,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -31.1207275390625,
      "bbox_min": [
        -1602.67041015625,
        -3950.452392578125,
        1030.0
      ],
      "bbox_max": [
        -1599.0,
        -3934.430419921875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923877477645874,
        0.3826882839202881,
        -0.0
      ],
      "plane_d": 2984.462890625,
      "bbox_min": [
        -1600.64794921875,
        -3938.40869140625,
        1030.0
      ],
      "bbox_max": [
        -1599.0,
        -3934.430419921875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269534707069397,
        0.9238746166229248,
        -0.0
      ],
      "plane_d": 4239.48095703125,
      "bbox_min": [
        -1631.452392578125,
        -3934.430419921875,
        1030.0
      ],
      "bbox_max": [
        -1599.0,
        -3884.12841796875,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1631.452392578125,
        -3934.430419921875,
        1030.0
      ],
      "bbox_max": [
        -1600.64794921875,
        -3917.3408203125,
        1032.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.38269534707069397,
        0.9238746166229248,
        0.0
      ],
      "plane_d": 2998.782470703125,
      "bbox_min": [
        -1631.452392578125,
        -3921.67041015625,
        1030.0
      ],
      "bbox_max": [
        -1621.0,
        -3917.3408203125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09097343683242798,
        -0.6642122864723206,
        -0.7419878840446472
      ],
      "plane_d": -1649.374755859375,
      "bbox_min": [
        -1604.6495361328125,
        -3892.689697265625,
        1058.0286865234375
      ],
      "bbox_max": [
        -1599.0,
        -3884.12841796875,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1708.0,
        -3962.0,
        992.0
      ],
      "bbox_max": [
        -1663.0,
        -3929.0,
        1040.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1035.5,
      "bbox_min": [
        -1708.0,
        -3962.0,
        992.0
      ],
      "bbox_max": [
        -1663.0,
        -3929.0,
        1040.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3944.5,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1663.0,
        -3935.5,
        1040.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1705.0,
        -3944.5,
        1040.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3935.5,
      "bbox_min": [
        -1705.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1663.0,
        -3935.5,
        1040.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        -1705.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1705.0,
        -3935.5,
        1040.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25766265392303467,
        -0.9662349820137024,
        0.0
      ],
      "plane_d": -4235.71630859375,
      "bbox_min": [
        -1684.0,
        -3944.0,
        992.0
      ],
      "bbox_max": [
        -1675.25,
        -3936.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25766268372535706,
        0.9662350416183472,
        0.0
      ],
      "plane_d": 3378.21533203125,
      "bbox_min": [
        -1684.0,
        -3944.0,
        992.0
      ],
      "bbox_max": [
        -1675.25,
        -3936.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766265392303467,
        -0.9662349820137024,
        0.0
      ],
      "plane_d": -3370.4853515625,
      "bbox_min": [
        -1684.0,
        -3944.0,
        993.5
      ],
      "bbox_max": [
        -1679.0,
        -3936.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766268372535706,
        0.9662350416183472,
        0.0
      ],
      "plane_d": 4243.44677734375,
      "bbox_min": [
        -1684.0,
        -3944.0,
        993.5
      ],
      "bbox_max": [
        -1679.0,
        -3937.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9230769872665405,
        -0.38461539149284363,
        0.0
      ],
      "plane_d": 39.0770263671875,
      "bbox_min": [
        -1684.0,
        -3943.0,
        995.0
      ],
      "bbox_max": [
        -1682.75,
        -3937.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9230769872665405,
        0.38461539149284363,
        0.0
      ],
      "plane_d": 3069.84619140625,
      "bbox_min": [
        -1684.0,
        -3943.0,
        995.0
      ],
      "bbox_max": [
        -1682.75,
        -3940.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1605.0,
      "bbox_min": [
        -1640.0,
        -3978.0,
        1080.0
      ],
      "bbox_max": [
        -1605.0,
        -3900.0,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3978.0,
      "bbox_min": [
        -1640.0,
        -3978.0,
        1080.0
      ],
      "bbox_max": [
        -1605.0,
        -3900.0,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3900.0,
      "bbox_min": [
        -1640.0,
        -3900.0,
        1080.0
      ],
      "bbox_max": [
        -1605.0,
        -3900.0,
        1086.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt02b",
      "entity_class": "CGameArea",
      "piece_name": "mt02b",
      "offset": 54,
      "centroid": [
        -1580.0,
        -3932.25,
        867.125
      ],
      "bbox_min": [
        -1666.0,
        -3944.5,
        691.2000122070312
      ],
      "bbox_max": [
        -1494.0,
        -3918.39990234375,
        1040.0
      ],
      "dimensions_source": {
        "span_x": 172.0,
        "span_y": 26.10009765625,
        "height_z": 348.79998779296875,
        "door_width": 172.0,
        "door_depth": 26.10009765625,
        "leaf_depth": 26.10009765625,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          -0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1666.0,
          -3944.5,
          1035.5
        ],
        [
          -1666.0,
          -3944.5,
          1040.0
        ],
        [
          -1666.0,
          -3935.5,
          1040.0
        ],
        [
          -1666.0,
          -3935.5,
          1035.5
        ],
        [
          -1494.0,
          -3930.60009765625,
          691.2000122070312
        ],
        [
          -1494.0,
          -3918.39990234375,
          691.2000122070312
        ],
        [
          -1494.0,
          -3918.39990234375,
          701.7999877929688
        ],
        [
          -1494.0,
          -3930.60009765625,
          701.7999877929688
        ]
      ],
      "plane_distance": 1666.0
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 4924,
      "centroid": [
        -1338.5,
        -3994.5,
        1038.0
      ],
      "bbox_min": [
        -1343.0352783203125,
        -4003.0,
        1036.7630615234375
      ],
      "bbox_max": [
        -1333.9647216796875,
        -3986.0,
        1039.2369384765625
      ],
      "dimensions_source": {
        "span_x": 9.070556640625,
        "span_y": 17.0,
        "height_z": 2.473876953125,
        "door_width": 17.0,
        "door_depth": 9.070556640625,
        "leaf_depth": 9.070556640625,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -0.2631,
          0.0,
          0.9648
        ]
      },
      "vertices": [
        [
          -1333.9647216796875,
          -4003.0,
          1039.2369384765625
        ],
        [
          -1343.0352783203125,
          -4003.0,
          1036.7630615234375
        ],
        [
          -1343.0352783203125,
          -3986.0,
          1036.7630615234375
        ],
        [
          -1333.9647216796875,
          -3986.0,
          1039.2369384765625
        ]
      ],
      "plane_distance": -1353.6169,
      "authentic_texture": "chkptroofgrate1"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 5516,
      "centroid": [
        -1301.5,
        -3930.75,
        1004.5
      ],
      "bbox_min": [
        -1311.5,
        -3931.5,
        1001.0
      ],
      "bbox_max": [
        -1291.5,
        -3930.0,
        1008.0
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 1.5,
        "height_z": 7.0,
        "door_width": 20.0,
        "door_depth": 1.5,
        "leaf_depth": 1.5,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1311.5,
          -3931.5,
          1001.0
        ],
        [
          -1311.5,
          -3930.0,
          1001.0
        ],
        [
          -1291.5,
          -3931.5,
          1008.0
        ],
        [
          -1291.5,
          -3930.0,
          1008.0
        ],
        [
          -1291.5,
          -3931.5,
          1001.0
        ],
        [
          -1291.5,
          -3930.0,
          1001.0
        ],
        [
          -1311.5,
          -3931.5,
          1008.0
        ],
        [
          -1311.5,
          -3930.0,
          1008.0
        ]
      ],
      "plane_distance": 3930.0,
      "authentic_texture": "chkptroofgrate1-t"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 6376,
      "centroid": [
        -1344.5,
        -3935.75,
        1014.0
      ],
      "bbox_min": [
        -1349.5,
        -3940.0,
        1013.5
      ],
      "bbox_max": [
        -1339.5,
        -3931.5,
        1014.5
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 8.5,
        "height_z": 1.0,
        "door_width": 10.0,
        "door_depth": 8.5,
        "leaf_depth": 8.5,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -1349.5,
          -3940.0,
          1013.5
        ],
        [
          -1349.5,
          -3931.5,
          1014.5
        ],
        [
          -1349.5,
          -3940.0,
          1014.5
        ],
        [
          -1349.5,
          -3931.5,
          1013.5
        ],
        [
          -1339.5,
          -3940.0,
          1013.5
        ],
        [
          -1339.5,
          -3931.5,
          1014.5
        ],
        [
          -1339.5,
          -3940.0,
          1014.5
        ],
        [
          -1339.5,
          -3931.5,
          1013.5
        ]
      ],
      "plane_distance": -1014.5,
      "authentic_texture": "chkptroofgrate1-t"
    },
    {
      "tag": "CSlidingDoor piece: recharge",
      "entity_class": "CSlidingDoor",
      "piece_name": "recharge",
      "offset": 12814,
      "centroid": [
        -1303.5,
        -3957.89990234375,
        1018.5499877929688
      ],
      "bbox_min": [
        -1305.0,
        -3957.89990234375,
        1017.5999755859375
      ],
      "bbox_max": [
        -1302.0,
        -3957.89990234375,
        1019.5
      ],
      "dimensions_source": {
        "span_x": 3.0,
        "span_y": 0.0,
        "height_z": 1.9000244140625,
        "door_width": 3.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1305.0,
          -3957.89990234375,
          1017.5999755859375
        ],
        [
          -1302.0,
          -3957.89990234375,
          1019.5
        ],
        [
          -1302.0,
          -3957.89990234375,
          1017.5999755859375
        ],
        [
          -1305.0,
          -3957.89990234375,
          1019.5
        ]
      ],
      "plane_distance": 3957.8999
    }
  ],
  "tutorial_messages": []
}